export type Maybe<T> = T | null;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  AWSDateTime: Date | string;
  AWSTimestamp: any;
  AWSDate: string;
  AWSJSON: string | { [key: string]: any };
};



export type Agency = {
  __typename?: 'Agency';
  id: Scalars['ID'];
  sk: Scalars['String'];
  workspaceId: Scalars['String'];
  schemaVersion: Scalars['String'];
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  tags?: Maybe<Array<Tag>>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
  creator?: Maybe<User>;
  creatorId?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  highestGradeDescr?: Maybe<Scalars['String']>;
  lowestGradeDescr?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  ncesId?: Maybe<Scalars['String']>;
  ncesLocale?: Maybe<Scalars['String']>;
  parentAgencyId?: Maybe<Scalars['String']>;
  schoolType?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type CreateAgencyInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
  workspaceId: Scalars['String'];
  schemaVersion: Scalars['String'];
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  tags?: Maybe<Array<TagInput>>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
  creatorId?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  highestGradeDescr?: Maybe<Scalars['String']>;
  lowestGradeDescr?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  ncesId?: Maybe<Scalars['String']>;
  ncesLocale?: Maybe<Scalars['String']>;
  parentAgencyId?: Maybe<Scalars['String']>;
  schoolType?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type UpdateAgencyInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
  workspaceId: Scalars['String'];
  schemaVersion?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  tags?: Maybe<Array<TagInput>>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
  creatorId?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  highestGradeDescr?: Maybe<Scalars['String']>;
  lowestGradeDescr?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  ncesId?: Maybe<Scalars['String']>;
  ncesLocale?: Maybe<Scalars['String']>;
  parentAgencyId?: Maybe<Scalars['String']>;
  schoolType?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type DeleteAgencyInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
};

export type Annotation = {
  __typename?: 'Annotation';
  id: Scalars['ID'];
  sk: Scalars['String'];
  workspaceId: Scalars['String'];
  schemaVersion: Scalars['String'];
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  tags?: Maybe<Array<Tag>>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
  creator?: Maybe<User>;
  creatorId?: Maybe<Scalars['String']>;
  resourceId?: Maybe<Scalars['String']>;
  resource?: Maybe<Resource>;
  bankId?: Maybe<Scalars['String']>;
  content?: Maybe<ResourceContent>;
  resources?: Maybe<Array<ResourcesItem>>;
  resourcesIds?: Maybe<Array<GenericReferenceId>>;
};

export type CreateAnnotationInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
  workspaceId: Scalars['String'];
  schemaVersion: Scalars['String'];
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  tags?: Maybe<Array<TagInput>>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
  creatorId?: Maybe<Scalars['String']>;
  resourceId?: Maybe<Scalars['String']>;
  bankId?: Maybe<Scalars['String']>;
  content?: Maybe<ResourceContentInput>;
  resourcesIds?: Maybe<Array<GenericReferenceIdInput>>;
};

export type UpdateAnnotationInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
  workspaceId: Scalars['String'];
  schemaVersion?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  tags?: Maybe<Array<TagInput>>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
  creatorId?: Maybe<Scalars['String']>;
  resourceId?: Maybe<Scalars['String']>;
  bankId?: Maybe<Scalars['String']>;
  content?: Maybe<ResourceContentInput>;
  resourcesIds?: Maybe<Array<GenericReferenceIdInput>>;
};

export type DeleteAnnotationInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
};

export type ModelAnnotationConnection = {
  __typename?: 'ModelAnnotationConnection';
  items?: Maybe<Array<Annotation>>;
  nextToken?: Maybe<Scalars['String']>;
};

export type Query = {
  __typename?: 'Query';
  adminLoginAsAppUser: Scalars['AWSJSON'];
  adminSearch?: Maybe<SearchableResourceConnectionNew>;
  authGetToken?: Maybe<AuthToken>;
  bulkSearch?: Maybe<BulkSearchableResourceConnection>;
  determineRegistrationStatus?: Maybe<RegistrationPass>;
  getAcademicCalendar?: Maybe<AcademicCalendar>;
  getAppDomain?: Maybe<AppDomain>;
  getBank?: Maybe<Workspace>;
  getClassroom?: Maybe<Classroom>;
  getClassroomActivity?: Maybe<ClassroomActivity>;
  getClassroomUnit?: Maybe<ClassroomUnit>;
  getCollection?: Maybe<Resource>;
  getComment?: Maybe<Comment>;
  getCourse?: Maybe<Course>;
  getCourseCalendar?: Maybe<CourseCalendar>;
  getExamAttempt?: Maybe<ExamAttempt>;
  getExamConfig?: Maybe<Resource>;
  getExamSession?: Maybe<ExamSession>;
  getExamTicket?: Maybe<Resource>;
  getFileChecksum?: Maybe<Scalars['AWSJSON']>;
  getIssue?: Maybe<Resource>;
  getItem?: Maybe<Resource>;
  getLaunchToken?: Maybe<LaunchToken>;
  getLoginTokenForAppUser: Scalars['AWSJSON'];
  getObjectivesView?: Maybe<ObjectivesView>;
  getOpenGraphMetadata?: Maybe<Scalars['AWSJSON']>;
  getPerformanceTask?: Maybe<PerformanceTask>;
  getPlayableExam?: Maybe<Resource>;
  getPrintableExam?: Maybe<Resource>;
  getResourceForUser?: Maybe<Resource>;
  getResourceTranslation?: Maybe<Scalars['AWSJSON']>;
  getResourceVersionData?: Maybe<VersionData>;
  getRolePolicy?: Maybe<RolePolicy>;
  getRubric?: Maybe<Rubric>;
  getStudent?: Maybe<Student>;
  getStudentAnswerKey?: Maybe<Array<Scalars['AWSJSON']>>;
  getStudentScore?: Maybe<Scalars['AWSJSON']>;
  getTask?: Maybe<Resource>;
  getUnit?: Maybe<Unit>;
  getUnitLayout?: Maybe<UnitLayout>;
  getUser?: Maybe<User>;
  getVocabulary?: Maybe<Vocabulary>;
  getWebDocument?: Maybe<WebDocument>;
  getWorklog?: Maybe<Resource>;
  getWorkspace?: Maybe<Workspace>;
  getWorkspaceInvitation?: Maybe<Workspace>;
  getWorkspaceParent?: Maybe<WorkspaceParent>;
  getWorkspaceProduct?: Maybe<WorkspaceProduct>;
  getWorkspaceShare?: Maybe<WorkspaceShare>;
  listAcademicCalendars?: Maybe<ModelAcademicCalendarConnection>;
  listAnnotations?: Maybe<ModelAnnotationConnection>;
  listAppUserConfigs: ModelAppUserConnection;
  listBanks?: Maybe<ModelWorkspaceConnection>;
  listClassroomActivities?: Maybe<ModelClassroomActivityConnection>;
  listClassroomStudents?: Maybe<ModelStudentConnection>;
  listCollectionItems?: Maybe<ModelResourceConnection>;
  listCollections?: Maybe<ModelResourceConnection>;
  listComments?: Maybe<ModelCommentConnection>;
  listContentLicenses?: Maybe<ModelContentLicenseConnection>;
  listContentSharedToWorkspace: Array<WorkspaceShare>;
  listCourseCalendars?: Maybe<ModelCourseCalendarConnection>;
  listExamAttempts?: Maybe<ModelExamAttemptConnection>;
  listExamTickets?: Maybe<ModelResourceConnection>;
  listInboundWorkspaceShares: Array<WorkspaceShare>;
  listIssues?: Maybe<ModelResourceConnection>;
  listItemUnits?: Maybe<ModelResourceConnection>;
  listManagedWorkspaceUsers?: Maybe<ModelWorkspaceConnection>;
  listOutboundWorkspaceShares: Array<WorkspaceShare>;
  listRestApiTokens: Array<RestApiToken>;
  listReviews?: Maybe<ModelResourceConnection>;
  listRevisionNotes?: Maybe<ModelResourceConnection>;
  listRolePolicies?: Maybe<ModelRolePolicyConnection>;
  listTasks?: Maybe<ModelResourceConnection>;
  listUnitExams?: Maybe<ModelResourceConnection>;
  listUnitItems?: Maybe<ModelResourceConnection>;
  listUnitLayouts?: Maybe<UnitLayoutConnection>;
  listUserClassrooms?: Maybe<ModelUserClassroomConnection>;
  listUserNotifications?: Maybe<ModelUserConnection>;
  listUserReviewRequests?: Maybe<ModelResourceConnection>;
  listUserWorkspaces?: Maybe<ModelWorkspaceConnection>;
  listWorklogs?: Maybe<ModelResourceConnection>;
  listWorkspaceParentsByParentWorkspaceId: ModelWorkspaceParentConnection;
  listWorkspaceRegistrationCodes: Array<WorkspaceRegistrationCode>;
  listWorkspaceRoles?: Maybe<ModelWorkspaceConnection>;
  listWorkspaceUserInvitations?: Maybe<ModelWorkspaceConnection>;
  listWorkspaceUsers?: Maybe<ModelWorkspaceConnection>;
  listWorkspaces?: Maybe<ModelWorkspaceConnection>;
  listWorkspacesForUser?: Maybe<ModelWorkspaceConnection>;
  loginUser?: Maybe<Scalars['AWSJSON']>;
  resolveUnitVocabularies?: Maybe<VocabularyItems>;
  search?: Maybe<SearchableResourceConnectionNew>;
  searchAcademicCalendars?: Maybe<SearchableAcademicCalendarConnection>;
  searchCourseCalendars?: Maybe<SearchableCourseCalendarConnection>;
  searchExamResponses?: Maybe<SearchableResourceConnectionNew>;
  searchResourcesGuest?: Maybe<ResourceAggregates>;
  searchUserResources?: Maybe<SearchableResourceConnection>;
  searchUsers?: Maybe<SearchableUserConnection>;
  searchVocabulary?: Maybe<SearchableVocabularyConnection>;
  searchWorkspaceProducts?: Maybe<SearchableWorkspaceProductConnection>;
  searchWorkspaceShares?: Maybe<SearchableWorkspaceShareConnection>;
  searchWorkspaceUsers?: Maybe<SearchableWorkspaceConnection>;
  searchWorkspaces?: Maybe<SearchableWorkspaceConnection>;
  searchv2?: Maybe<SearchableResourceConnectionNew>;
  signCampfireLti?: Maybe<SignCampfireLtiResponse>;
  signContentItemSelectionLti?: Maybe<SignCampfireLtiResponse>;
};


export type QueryAdminLoginAsAppUserArgs = {
  input: ControllerInput;
};


export type QueryAdminSearchArgs = {
  filter?: Maybe<SearchableResourceFilterInput>;
  sort?: Maybe<Array<SearchableResourceSortInput>>;
  aggs?: Maybe<Array<SearchableResourceAggsInput>>;
  aggsNew?: Maybe<Array<SearchAggsInput>>;
  limit?: Maybe<Scalars['Int']>;
  nextToken?: Maybe<Scalars['String']>;
};


export type QueryAuthGetTokenArgs = {
  input?: Maybe<AuthTokenInput>;
};


export type QueryBulkSearchArgs = {
  filter?: Maybe<SearchableResourceFilterInput>;
  sort?: Maybe<Array<SearchableResourceSortInput>>;
  aggs?: Maybe<Array<SearchableResourceAggsInput>>;
  aggsNew?: Maybe<Array<SearchAggsInput>>;
  limit?: Maybe<Scalars['Int']>;
  nextToken?: Maybe<Scalars['String']>;
};


export type QueryDetermineRegistrationStatusArgs = {
  input: RegistrationStatusControllerInput;
};


export type QueryGetAcademicCalendarArgs = {
  input: ModelGetInput;
  authorizationContext: AuthorizationContextInput;
};


export type QueryGetAppDomainArgs = {
  input: ModelGetInput;
};


export type QueryGetBankArgs = {
  input?: Maybe<ModelGetInput>;
};


export type QueryGetClassroomArgs = {
  input?: Maybe<ModelGetInput>;
  authorizationContext?: Maybe<AuthorizationContextInput>;
};


export type QueryGetClassroomActivityArgs = {
  input?: Maybe<ModelGetInput>;
  authorizationContext?: Maybe<AuthorizationContextInput>;
};


export type QueryGetClassroomUnitArgs = {
  input?: Maybe<ModelGetInput>;
  authorizationContext?: Maybe<AuthorizationContextInput>;
};


export type QueryGetCollectionArgs = {
  input: ModelGetInput;
};


export type QueryGetCommentArgs = {
  input?: Maybe<ModelGetInput>;
};


export type QueryGetCourseArgs = {
  input: ModelGetInput;
  authorizationContext?: Maybe<AuthorizationContextInput>;
};


export type QueryGetCourseCalendarArgs = {
  input: ModelGetInput;
  authorizationContext: AuthorizationContextInput;
};


export type QueryGetExamAttemptArgs = {
  input: ModelGetInput;
};


export type QueryGetExamConfigArgs = {
  input: ModelGetInput;
};


export type QueryGetExamSessionArgs = {
  input: ModelGetInput;
};


export type QueryGetExamTicketArgs = {
  input: ModelGetInput;
};


export type QueryGetFileChecksumArgs = {
  input: ControllerInput;
};


export type QueryGetIssueArgs = {
  input?: Maybe<ModelGetInput>;
};


export type QueryGetItemArgs = {
  input: ModelGetInput;
  authorizationContext: AuthorizationContextInput;
};


export type QueryGetLaunchTokenArgs = {
  input: ModelGetInput;
};


export type QueryGetLoginTokenForAppUserArgs = {
  input: ControllerInput;
};


export type QueryGetObjectivesViewArgs = {
  input: ModelGetInput;
  authorizationContext?: Maybe<AuthorizationContextInput>;
};


export type QueryGetOpenGraphMetadataArgs = {
  input: ControllerInput;
};


export type QueryGetPerformanceTaskArgs = {
  input: ModelGetInput;
};


export type QueryGetPlayableExamArgs = {
  input: ModelGetInput;
};


export type QueryGetPrintableExamArgs = {
  input: ModelGetInput;
};


export type QueryGetResourceForUserArgs = {
  id: Scalars['ID'];
  sk: Scalars['String'];
};


export type QueryGetResourceTranslationArgs = {
  input: GetResourceTranslationInput;
};


export type QueryGetResourceVersionDataArgs = {
  input: ModelGetInput;
};


export type QueryGetRolePolicyArgs = {
  input?: Maybe<ModelGetInput>;
  authorizationContext: AuthorizationContextInput;
};


export type QueryGetRubricArgs = {
  input: ModelGetInput;
};


export type QueryGetStudentArgs = {
  input?: Maybe<ModelGetInput>;
  authorizationContext?: Maybe<AuthorizationContextInput>;
};


export type QueryGetStudentAnswerKeyArgs = {
  input: ControllerInput;
};


export type QueryGetStudentScoreArgs = {
  input: ControllerInput;
};


export type QueryGetTaskArgs = {
  input?: Maybe<ModelGetInput>;
};


export type QueryGetUnitArgs = {
  input: ModelGetInput;
};


export type QueryGetUnitLayoutArgs = {
  input: ModelGetInput;
  authorizationContext?: Maybe<AuthorizationContextInput>;
};


export type QueryGetUserArgs = {
  input?: Maybe<ModelGetInput>;
};


export type QueryGetVocabularyArgs = {
  input: ModelGetInput;
};


export type QueryGetWebDocumentArgs = {
  input: ModelGetInput;
};


export type QueryGetWorklogArgs = {
  input?: Maybe<ModelGetInput>;
};


export type QueryGetWorkspaceArgs = {
  input?: Maybe<ModelGetInput>;
};


export type QueryGetWorkspaceInvitationArgs = {
  input?: Maybe<ModelGetInput>;
};


export type QueryGetWorkspaceParentArgs = {
  input: ModelGetInput;
};


export type QueryGetWorkspaceProductArgs = {
  input?: Maybe<ModelGetInput>;
  authorizationContext?: Maybe<AuthorizationContextInput>;
};


export type QueryGetWorkspaceShareArgs = {
  input?: Maybe<ModelGetInput>;
  authorizationContext?: Maybe<AuthorizationContextInput>;
};


export type QueryListAcademicCalendarsArgs = {
  input?: Maybe<ListResourcesByWorkspaceIdThenSkInput>;
  authorizationContext: AuthorizationContextInput;
};


export type QueryListAnnotationsArgs = {
  input: ListResourcesByIdThenSkInput;
  authorizationContext: AuthorizationContextInput;
};


export type QueryListAppUserConfigsArgs = {
  input: ListAppUserConfigsInput;
  authorizationContext: AuthorizationContextInput;
};


export type QueryListBanksArgs = {
  input?: Maybe<ModelListInput>;
};


export type QueryListClassroomActivitiesArgs = {
  input?: Maybe<ModelListInput>;
};


export type QueryListClassroomStudentsArgs = {
  input?: Maybe<ModelListInput>;
  authorizationContext?: Maybe<AuthorizationContextInput>;
};


export type QueryListCollectionItemsArgs = {
  input: ListResourcesByWorkspaceIdThenSkInput;
};


export type QueryListCollectionsArgs = {
  input: ListResourcesByWorkspaceIdThenSkInput;
};


export type QueryListCommentsArgs = {
  input?: Maybe<ModelListInput>;
};


export type QueryListContentLicensesArgs = {
  input: ListResourcesByIdThenSkInput;
  authorizationContext: AuthorizationContextInput;
};


export type QueryListContentSharedToWorkspaceArgs = {
  authorizationContext?: Maybe<AuthorizationContextInput>;
};


export type QueryListCourseCalendarsArgs = {
  input?: Maybe<ListResourcesByWorkspaceIdThenSkInput>;
  authorizationContext: AuthorizationContextInput;
};


export type QueryListExamAttemptsArgs = {
  input: ListExamAttemptsInput;
  nextToken?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QueryListExamTicketsArgs = {
  input: ModelListInput;
};


export type QueryListInboundWorkspaceSharesArgs = {
  authorizationContext?: Maybe<AuthorizationContextInput>;
};


export type QueryListIssuesArgs = {
  input?: Maybe<ListResourcesByWorkspaceIdInput>;
};


export type QueryListItemUnitsArgs = {
  input: ListResourcesByIdThenSkInput;
};


export type QueryListManagedWorkspaceUsersArgs = {
  input?: Maybe<ModelListInput>;
};


export type QueryListOutboundWorkspaceSharesArgs = {
  authorizationContext?: Maybe<AuthorizationContextInput>;
};


export type QueryListRestApiTokensArgs = {
  input: ListResourcesByWorkspaceIdInput;
};


export type QueryListReviewsArgs = {
  input?: Maybe<ListResourcesByIdThenSkInput>;
};


export type QueryListRevisionNotesArgs = {
  input: ListResourcesByIdThenSkInput;
  authorizationContext: AuthorizationContextInput;
};


export type QueryListRolePoliciesArgs = {
  input?: Maybe<ListRolePoliciesInput>;
  authorizationContext: AuthorizationContextInput;
};


export type QueryListTasksArgs = {
  input?: Maybe<ListResourcesByWorkspaceIdInput>;
};


export type QueryListUnitExamsArgs = {
  input: ListResourcesByIdThenSkInput;
};


export type QueryListUnitItemsArgs = {
  input: ListResourcesByIdThenSkInput;
};


export type QueryListUnitLayoutsArgs = {
  input: ListResourcesByIdThenSkInput;
  authorizationContext?: Maybe<AuthorizationContextInput>;
};


export type QueryListUserClassroomsArgs = {
  input?: Maybe<ListUserClassroomsInput>;
  authorizationContext?: Maybe<AuthorizationContextInput>;
};


export type QueryListUserNotificationsArgs = {
  input?: Maybe<ModelListInput>;
};


export type QueryListUserReviewRequestsArgs = {
  input?: Maybe<ListResourcesByWorkspaceIdThenSkInput>;
};


export type QueryListUserWorkspacesArgs = {
  input?: Maybe<ListUserWorkspacesInput>;
  nextToken?: Maybe<Scalars['String']>;
  authorizationContext?: Maybe<AuthorizationContextInput>;
};


export type QueryListWorklogsArgs = {
  input?: Maybe<ModelListInput>;
};


export type QueryListWorkspaceParentsByParentWorkspaceIdArgs = {
  input?: Maybe<ModelListInput>;
};


export type QueryListWorkspaceRegistrationCodesArgs = {
  input?: Maybe<ListResourcesByWorkspaceIdInput>;
  authorizationContext?: Maybe<AuthorizationContextInput>;
};


export type QueryListWorkspaceRolesArgs = {
  input?: Maybe<ModelListInput>;
};


export type QueryListWorkspaceUserInvitationsArgs = {
  input?: Maybe<ModelListInput>;
};


export type QueryListWorkspaceUsersArgs = {
  input?: Maybe<ModelListInput>;
};


export type QueryListWorkspacesArgs = {
  input?: Maybe<ListWorkspacesBySortKeyInput>;
};


export type QueryListWorkspacesForUserArgs = {
  input?: Maybe<ListWorkspacesBySortKeyInput>;
};


export type QueryLoginUserArgs = {
  input: LoginUserInput;
};


export type QueryResolveUnitVocabulariesArgs = {
  input: Array<GenericReferenceIdInput>;
  authorizationContext: AuthorizationContextInput;
};


export type QuerySearchArgs = {
  filter?: Maybe<SearchableResourceFilterInput>;
  sort?: Maybe<Array<SearchableResourceSortInput>>;
  aggs?: Maybe<Array<SearchableResourceAggsInput>>;
  aggsNew?: Maybe<Array<SearchAggsInput>>;
  limit?: Maybe<Scalars['Int']>;
  nextToken?: Maybe<Scalars['String']>;
  authorizationContext?: Maybe<AuthorizationContextInput>;
};


export type QuerySearchAcademicCalendarsArgs = {
  filter?: Maybe<SearchableResourceFilterInput>;
  sort?: Maybe<Array<SearchableResourceSortInput>>;
  aggs?: Maybe<Array<SearchableResourceAggsInput>>;
  aggsNew?: Maybe<Array<SearchAggsInput>>;
  limit?: Maybe<Scalars['Int']>;
  nextToken?: Maybe<Scalars['String']>;
  authorizationContext?: Maybe<AuthorizationContextInput>;
};


export type QuerySearchCourseCalendarsArgs = {
  filter?: Maybe<SearchableResourceFilterInput>;
  sort?: Maybe<Array<SearchableResourceSortInput>>;
  aggs?: Maybe<Array<SearchableResourceAggsInput>>;
  aggsNew?: Maybe<Array<SearchAggsInput>>;
  limit?: Maybe<Scalars['Int']>;
  nextToken?: Maybe<Scalars['String']>;
  authorizationContext?: Maybe<AuthorizationContextInput>;
};


export type QuerySearchExamResponsesArgs = {
  filter?: Maybe<SearchableResourceFilterInput>;
  sort?: Maybe<Array<SearchableResourceSortInput>>;
  aggs?: Maybe<Array<SearchableResourceAggsInput>>;
  aggsNew?: Maybe<Array<SearchAggsInput>>;
  limit?: Maybe<Scalars['Int']>;
  nextToken?: Maybe<Scalars['String']>;
};


export type QuerySearchResourcesGuestArgs = {
  filter?: Maybe<SearchableResourceFilterInput>;
  sort?: Maybe<Array<SearchableResourceSortInput>>;
  aggs?: Maybe<Array<SearchableResourceAggsInput>>;
  limit?: Maybe<Scalars['Int']>;
  nextToken?: Maybe<Scalars['String']>;
};


export type QuerySearchUserResourcesArgs = {
  filter?: Maybe<SearchableResourceFilterInput>;
  sort?: Maybe<Array<SearchableResourceSortInput>>;
  aggs?: Maybe<Array<SearchableResourceAggsInput>>;
  limit?: Maybe<Scalars['Int']>;
  nextToken?: Maybe<Scalars['String']>;
  authorizationContext?: Maybe<AuthorizationContextInput>;
};


export type QuerySearchUsersArgs = {
  filter?: Maybe<SearchableResourceFilterInput>;
  sort?: Maybe<Array<SearchableResourceSortInput>>;
  aggs?: Maybe<Array<SearchableResourceAggsInput>>;
  aggsNew?: Maybe<Array<SearchAggsInput>>;
  limit?: Maybe<Scalars['Int']>;
  nextToken?: Maybe<Scalars['String']>;
};


export type QuerySearchVocabularyArgs = {
  filter?: Maybe<SearchableResourceFilterInput>;
  sort?: Maybe<Array<SearchableResourceSortInput>>;
  aggs?: Maybe<Array<SearchableResourceAggsInput>>;
  limit?: Maybe<Scalars['Int']>;
  nextToken?: Maybe<Scalars['String']>;
  authorizationContext?: Maybe<AuthorizationContextInput>;
};


export type QuerySearchWorkspaceProductsArgs = {
  filter?: Maybe<SearchableResourceFilterInput>;
  sort?: Maybe<Array<SearchableResourceSortInput>>;
  aggs?: Maybe<Array<SearchableResourceAggsInput>>;
  aggsNew?: Maybe<Array<SearchAggsInput>>;
  limit?: Maybe<Scalars['Int']>;
  nextToken?: Maybe<Scalars['String']>;
  authorizationContext?: Maybe<AuthorizationContextInput>;
};


export type QuerySearchWorkspaceSharesArgs = {
  filter?: Maybe<SearchableResourceFilterInput>;
  sort?: Maybe<Array<SearchableResourceSortInput>>;
  aggs?: Maybe<Array<SearchableResourceAggsInput>>;
  aggsNew?: Maybe<Array<SearchAggsInput>>;
  limit?: Maybe<Scalars['Int']>;
  nextToken?: Maybe<Scalars['String']>;
  authorizationContext?: Maybe<AuthorizationContextInput>;
};


export type QuerySearchWorkspaceUsersArgs = {
  filter?: Maybe<SearchableResourceFilterInput>;
  sort?: Maybe<Array<SearchableResourceFilterInput>>;
  aggs?: Maybe<Array<SearchableResourceAggsInput>>;
  aggsNew?: Maybe<Array<SearchAggsInput>>;
  limit?: Maybe<Scalars['Int']>;
  nextToken?: Maybe<Scalars['String']>;
  authorizationContext?: Maybe<AuthorizationContextInput>;
};


export type QuerySearchWorkspacesArgs = {
  filter?: Maybe<SearchableResourceFilterInput>;
  sort?: Maybe<Array<SearchableResourceSortInput>>;
  aggs?: Maybe<Array<SearchableResourceAggsInput>>;
  aggsNew?: Maybe<Array<SearchAggsInput>>;
  limit?: Maybe<Scalars['Int']>;
  nextToken?: Maybe<Scalars['String']>;
};


export type QuerySearchv2Args = {
  filter?: Maybe<SearchableResourceFilterInput>;
  sort?: Maybe<Array<SearchableResourceSortInput>>;
  aggs?: Maybe<Array<SearchableResourceAggsInput>>;
  aggsNew?: Maybe<Array<SearchAggsInput>>;
  limit?: Maybe<Scalars['Int']>;
  nextToken?: Maybe<Scalars['String']>;
  authorizationContext: AuthorizationContextInput;
};


export type QuerySignCampfireLtiArgs = {
  input: ControllerInput;
  authorizationContext: AuthorizationContextInput;
};


export type QuerySignContentItemSelectionLtiArgs = {
  input: ControllerInput;
  authorizationContext: AuthorizationContextInput;
};

export type Mutation = {
  __typename?: 'Mutation';
  addCollectionItem?: Maybe<Array<Maybe<KeysResultItemType>>>;
  addTaskAuditItem?: Maybe<TaskToResource>;
  archiveCampfireUserActivities?: Maybe<Scalars['AWSJSON']>;
  archiveClassroomAction?: Maybe<Resource>;
  archiveExam?: Maybe<Resource>;
  attachExamsToUnit: Array<GenericReferenceId>;
  attachItemsToUnit: Array<GenericReferenceId>;
  attachTaskOutputToResource?: Maybe<TaskToResource>;
  attachTaskToResource?: Maybe<TaskToResource>;
  attachVendorId: Array<KeysResultItemType>;
  createAcademicCalendar?: Maybe<AcademicCalendar>;
  createAccount?: Maybe<User>;
  createAnnotation?: Maybe<Annotation>;
  createBank?: Maybe<Workspace>;
  createBlueprint?: Maybe<Resource>;
  createClassroom?: Maybe<Classroom>;
  createClassroomActivity?: Maybe<ClassroomActivity>;
  createClassroomResource?: Maybe<Resource>;
  createClassroomStudentAction?: Maybe<Scalars['AWSJSON']>;
  createClassroomUnit?: Maybe<Classroom>;
  createCollection?: Maybe<Resource>;
  createComment?: Maybe<Comment>;
  createCourse?: Maybe<Course>;
  createCourseCalendar?: Maybe<CourseCalendar>;
  createEventForUser?: Maybe<Scalars['Boolean']>;
  createExamAttempt?: Maybe<ExamAttempt>;
  createExamConfig?: Maybe<Resource>;
  createExamConfigSession?: Maybe<Resource>;
  createExamExportAction?: Maybe<Resource>;
  createExamSession?: Maybe<ExamSession>;
  createIssue?: Maybe<Resource>;
  createItem?: Maybe<Resource>;
  createObjectivesView?: Maybe<ObjectivesView>;
  createPerformanceTask?: Maybe<PerformanceTask>;
  createRelative?: Maybe<ResourceRelative>;
  createResourceFavorite?: Maybe<Resource>;
  createResourcePurchase?: Maybe<CreateResourcePurchase>;
  createResourceRating?: Maybe<CreateResourceRating>;
  createResourceVersionData?: Maybe<VersionData>;
  createResourceWatcher?: Maybe<Scalars['AWSJSON']>;
  createRestApiToken: RestApiToken;
  createReview: Array<KeysResultItemType>;
  createRevisionNote?: Maybe<RevisionNote>;
  createRole?: Maybe<Role>;
  createRolePolicy?: Maybe<Role>;
  createRoleSecure?: Maybe<Scalars['AWSJSON']>;
  createRubric?: Maybe<Rubric>;
  createSnapshot?: Maybe<Resource>;
  createStudent?: Maybe<Student>;
  createSystemEvent?: Maybe<SystemEvent>;
  createTask?: Maybe<Resource>;
  createTaskAction?: Maybe<Resource>;
  createUnit?: Maybe<Unit>;
  createUnitLayout?: Maybe<UnitLayout>;
  createUserClassroom: Array<GenericReferenceId>;
  createUserNotification?: Maybe<User>;
  createUserNotificationRecord?: Maybe<User>;
  createVocabulary?: Maybe<Vocabulary>;
  createWebDocument?: Maybe<WebDocument>;
  createWorklog?: Maybe<Resource>;
  createWorkspace?: Maybe<Workspace>;
  createWorkspaceInvitation?: Maybe<Workspace>;
  createWorkspaceParent?: Maybe<WorkspaceParent>;
  createWorkspaceProduct?: Maybe<WorkspaceProduct>;
  createWorkspaceRegistrationCode?: Maybe<WorkspaceRegistrationCode>;
  createWorkspaceRole?: Maybe<Workspace>;
  createWorkspaceShare?: Maybe<WorkspaceShare>;
  createWorkspaceUser?: Maybe<Workspace>;
  deleteAcademicCalendar?: Maybe<AcademicCalendar>;
  deleteAnnotation?: Maybe<Annotation>;
  deleteAppUserAction?: Maybe<Resource>;
  deleteBank?: Maybe<Workspace>;
  deleteBlueprint?: Maybe<Resource>;
  deleteClassroom?: Maybe<Classroom>;
  deleteClassroomAction?: Maybe<Resource>;
  deleteClassroomActivity?: Maybe<ClassroomActivity>;
  deleteClassroomActivityAction?: Maybe<Resource>;
  deleteClassroomResource?: Maybe<Resource>;
  deleteClassroomUnit?: Maybe<ClassroomUnit>;
  deleteCollection?: Maybe<Resource>;
  deleteComment?: Maybe<Comment>;
  deleteCourse?: Maybe<Course>;
  deleteCourseCalendar?: Maybe<CourseCalendar>;
  deleteIssue?: Maybe<Resource>;
  deleteItem?: Maybe<Resource>;
  deleteObjectivesView?: Maybe<ObjectivesView>;
  deletePerformanceTask?: Maybe<PerformanceTask>;
  deleteRelative?: Maybe<ResourceRelative>;
  deleteResourceFavorite?: Maybe<Resource>;
  deleteResourcePurchase: Array<KeysResultItemType>;
  deleteResourceRating: Array<KeysResultItemType>;
  deleteResourceWatcher?: Maybe<Scalars['AWSJSON']>;
  deleteRestApiToken: RestApiToken;
  deleteReview?: Maybe<Resource>;
  deleteRevisionNote?: Maybe<RevisionNote>;
  deleteRole?: Maybe<Role>;
  deleteRolePolicy?: Maybe<RolePolicy>;
  deleteRubric?: Maybe<Rubric>;
  deleteSnapshot?: Maybe<Resource>;
  deleteStudent?: Maybe<Student>;
  deleteTask?: Maybe<Resource>;
  deleteTaskAction?: Maybe<Resource>;
  deleteUnit?: Maybe<Unit>;
  deleteUnitLayout?: Maybe<UnitLayout>;
  deleteUserClassroom: Array<GenericReferenceId>;
  deleteUserNotification?: Maybe<User>;
  deleteUserResource?: Maybe<Resource>;
  deleteVocabulary?: Maybe<Vocabulary>;
  deleteWebDocument?: Maybe<WebDocument>;
  deleteWorklog?: Maybe<Resource>;
  deleteWorkspace?: Maybe<Workspace>;
  deleteWorkspaceInvitation?: Maybe<Workspace>;
  deleteWorkspaceParent?: Maybe<WorkspaceParent>;
  deleteWorkspaceProduct?: Maybe<WorkspaceProduct>;
  deleteWorkspaceRole?: Maybe<Workspace>;
  deleteWorkspaceShare?: Maybe<WorkspaceShare>;
  deleteWorkspaceUser?: Maybe<Workspace>;
  deregisterContent?: Maybe<RegisterContentResponse>;
  detachExamsFromUnit: Array<GenericReferenceId>;
  detachItemsFromUnit: Array<GenericReferenceId>;
  detachTaskFromResource?: Maybe<TaskToResource>;
  detachTaskOutputFromResource?: Maybe<TaskToResource>;
  detachVendorId: Array<KeysResultItemType>;
  disableWorkspaceUser?: Maybe<Workspace>;
  exportClassroomRosterAction?: Maybe<Scalars['AWSJSON']>;
  getPresignedUrlsForExamBlobs?: Maybe<Array<PresignedUrlResponse>>;
  importClassroomRosterAction?: Maybe<Scalars['AWSJSON']>;
  incrementWorkspaceCounter?: Maybe<Workspace>;
  invokeObjective?: Maybe<Scalars['AWSJSON']>;
  joinWorkspace?: Maybe<Workspace>;
  leaveWorkspace?: Maybe<Workspace>;
  leaveWorkspaceV2?: Maybe<Workspace>;
  printExam: ExportDocumentResponse;
  printPerformanceAssessment: ExportDocumentResponse;
  printVerificationDocument: ExportDocumentResponse;
  printYearAtaGlance: ExportDocumentResponse;
  putAppUser: AppUserConfig;
  registerAppUser?: Maybe<GenericStatus>;
  registerCognitoUser?: Maybe<GenericStatus>;
  registerContent?: Maybe<RegisterContentResponse>;
  removeCollectionItem?: Maybe<Array<Maybe<KeysResultItemType>>>;
  removeTaskAuditItem?: Maybe<TaskToResource>;
  resetAppUserAction?: Maybe<Resource>;
  resetClassroomAction?: Maybe<Resource>;
  restoreSnapshot?: Maybe<Resource>;
  sendEmail?: Maybe<Scalars['String']>;
  sendExamSessionUpdate?: Maybe<ExamSession>;
  sendWorkspaceUpdate?: Maybe<WorkspaceUpdate>;
  setDefaultWorkspaceCalendar?: Maybe<Workspace>;
  setUserConfirmed?: Maybe<User>;
  submitFeedback: SubmitFeedbackResponse;
  submitStudentExam?: Maybe<SubmittedExamToken>;
  toggleAppLicenseAction?: Maybe<Resource>;
  toggleAppUserAction?: Maybe<Resource>;
  updateAcademicCalendar?: Maybe<AcademicCalendar>;
  updateAccount?: Maybe<User>;
  updateAnnotation?: Maybe<Annotation>;
  updateBank?: Maybe<Workspace>;
  updateBlueprint?: Maybe<Resource>;
  updateClassroom?: Maybe<Classroom>;
  updateClassroomActivity?: Maybe<ClassroomActivity>;
  updateClassroomStudentAction?: Maybe<Scalars['AWSJSON']>;
  updateClassroomUnit?: Maybe<ClassroomUnit>;
  updateCollection?: Maybe<Resource>;
  updateComment?: Maybe<Comment>;
  updateCourse?: Maybe<Course>;
  updateCourseCalendar?: Maybe<CourseCalendar>;
  updateExamAttempt?: Maybe<ExamAttempt>;
  updateExamSession?: Maybe<ExamSession>;
  updateIssue?: Maybe<Resource>;
  updateItem?: Maybe<Resource>;
  updateObjectivesView?: Maybe<ObjectivesView>;
  updatePerformanceTask?: Maybe<PerformanceTask>;
  updateResourceVersionData?: Maybe<VersionData>;
  updateReview?: Maybe<Resource>;
  updateRole?: Maybe<Role>;
  updateRolePolicy?: Maybe<RolePolicy>;
  updateRubric?: Maybe<Rubric>;
  updateStudent?: Maybe<Student>;
  updateTask?: Maybe<Resource>;
  updateTaskStatus?: Maybe<Resource>;
  updateUnit?: Maybe<Unit>;
  updateUnitLayout?: Maybe<UnitLayout>;
  updateUserNotification?: Maybe<User>;
  updateVocabulary?: Maybe<Vocabulary>;
  updateWebDocument?: Maybe<WebDocument>;
  updateWorklog?: Maybe<Resource>;
  updateWorkspace?: Maybe<Workspace>;
  updateWorkspaceProduct?: Maybe<WorkspaceProduct>;
  updateWorkspaceRole?: Maybe<Workspace>;
  updateWorkspaceShare?: Maybe<WorkspaceShare>;
  updateWorkspaceSubscriptionForWorkspace?: Maybe<Workspace>;
  updateWorkspaceUser?: Maybe<Workspace>;
};


export type MutationAddCollectionItemArgs = {
  input?: Maybe<AddCollectionItemInput>;
};


export type MutationAddTaskAuditItemArgs = {
  input: TaskToResourceInput;
};


export type MutationArchiveCampfireUserActivitiesArgs = {
  input: ControllerInput;
};


export type MutationArchiveClassroomActionArgs = {
  input: ControllerInput;
  authorizationContext?: Maybe<AuthorizationContextInput>;
};


export type MutationArchiveExamArgs = {
  input: IdskInput;
  authorizationContext: AuthorizationContextInput;
};


export type MutationAttachExamsToUnitArgs = {
  input: Array<GenericRelationshipInput>;
};


export type MutationAttachItemsToUnitArgs = {
  input: Array<GenericRelationshipInput>;
};


export type MutationAttachTaskOutputToResourceArgs = {
  input: TaskToResourceInput;
};


export type MutationAttachTaskToResourceArgs = {
  input: TaskToResourceInput;
};


export type MutationAttachVendorIdArgs = {
  input: AttachVendorIdInput;
};


export type MutationCreateAcademicCalendarArgs = {
  input: CreateAcademicCalendarInput;
  authorizationContext: AuthorizationContextInput;
};


export type MutationCreateAccountArgs = {
  input: CreateAccountInput;
};


export type MutationCreateAnnotationArgs = {
  input: CreateAnnotationInput;
  authorizationContext: AuthorizationContextInput;
};


export type MutationCreateBankArgs = {
  input: CreateBankInput;
};


export type MutationCreateBlueprintArgs = {
  input: CreateResourceInput;
};


export type MutationCreateClassroomArgs = {
  input: CreateClassroomInput;
  authorizationContext?: Maybe<AuthorizationContextInput>;
};


export type MutationCreateClassroomActivityArgs = {
  input: CreateClassroomActivityInput;
  authorizationContext?: Maybe<AuthorizationContextInput>;
};


export type MutationCreateClassroomResourceArgs = {
  input: CreateResourceInput;
  authorizationContext: AuthorizationContextInput;
};


export type MutationCreateClassroomStudentActionArgs = {
  input: ControllerInput;
  authorizationContext?: Maybe<AuthorizationContextInput>;
};


export type MutationCreateClassroomUnitArgs = {
  input: CreateClassroomUnitInput;
  authorizationContext?: Maybe<AuthorizationContextInput>;
};


export type MutationCreateCollectionArgs = {
  input?: Maybe<CreateAssetInput>;
};


export type MutationCreateCommentArgs = {
  input: CreateCommentInput;
};


export type MutationCreateCourseArgs = {
  input: CreateCourseInput;
};


export type MutationCreateCourseCalendarArgs = {
  input: CreateCourseCalendarInput;
  authorizationContext: AuthorizationContextInput;
};


export type MutationCreateEventForUserArgs = {
  input: CreateEventForUserInput;
};


export type MutationCreateExamAttemptArgs = {
  input: CreateExamAttemptInput;
};


export type MutationCreateExamConfigArgs = {
  input: CreateExamConfigInput;
};


export type MutationCreateExamConfigSessionArgs = {
  input: CreateResourceInput;
};


export type MutationCreateExamExportActionArgs = {
  input: ControllerInput;
};


export type MutationCreateExamSessionArgs = {
  input: CreateExamSessionInput;
};


export type MutationCreateIssueArgs = {
  input: CreateIssueInput;
};


export type MutationCreateItemArgs = {
  input: CreateItemInput;
  authorizationContext: AuthorizationContextInput;
};


export type MutationCreateObjectivesViewArgs = {
  input: CreateObjectivesViewInput;
  authorizationContext: AuthorizationContextInput;
};


export type MutationCreatePerformanceTaskArgs = {
  input: CreatePerformanceTaskInput;
};


export type MutationCreateRelativeArgs = {
  input?: Maybe<CreateResourceRelativeInput>;
};


export type MutationCreateResourceFavoriteArgs = {
  input: CreateResourceFavoriteInput;
};


export type MutationCreateResourcePurchaseArgs = {
  input: CreateResourcePurchaseInput;
};


export type MutationCreateResourceRatingArgs = {
  input: CreateResourceRatingInput;
};


export type MutationCreateResourceVersionDataArgs = {
  input: CreateResourceVersionDataInput;
};


export type MutationCreateResourceWatcherArgs = {
  input: CreateResourceWatcherInput;
};


export type MutationCreateRestApiTokenArgs = {
  input: CreateRestApiTokenInput;
};


export type MutationCreateReviewArgs = {
  input: CreateReviewInput;
};


export type MutationCreateRevisionNoteArgs = {
  input: CreateRevisionNoteInput;
  authorizationContext: AuthorizationContextInput;
};


export type MutationCreateRoleArgs = {
  input: CreateRoleInput;
  authorizationContext: AuthorizationContextInput;
};


export type MutationCreateRolePolicyArgs = {
  input: CreateRolePolicyInput;
  authorizationContext: AuthorizationContextInput;
};


export type MutationCreateRoleSecureArgs = {
  input: CreateRoleInput;
  authorizationContext: AuthorizationContextInput;
};


export type MutationCreateRubricArgs = {
  input: CreateRubricInput;
};


export type MutationCreateSnapshotArgs = {
  input: CreateSnapshotInput;
};


export type MutationCreateStudentArgs = {
  input: CreateStudentInput;
  authorizationContext?: Maybe<AuthorizationContextInput>;
};


export type MutationCreateSystemEventArgs = {
  event?: Maybe<SystemEventInput>;
};


export type MutationCreateTaskArgs = {
  input: CreateTaskInput;
};


export type MutationCreateTaskActionArgs = {
  input: ControllerInput;
};


export type MutationCreateUnitArgs = {
  input: CreateUnitInput;
};


export type MutationCreateUnitLayoutArgs = {
  input: CreateUnitLayoutInput;
  authorizationContext: AuthorizationContextInput;
};


export type MutationCreateUserClassroomArgs = {
  input: GenericRelationshipInput;
  authorizationContext?: Maybe<AuthorizationContextInput>;
};


export type MutationCreateUserNotificationArgs = {
  input: CreateUserInput;
};


export type MutationCreateUserNotificationRecordArgs = {
  input: CreateUserInput;
};


export type MutationCreateVocabularyArgs = {
  input: CreateVocabularyInput;
};


export type MutationCreateWebDocumentArgs = {
  input: CreateWebDocumentInput;
};


export type MutationCreateWorklogArgs = {
  input: CreateWorklogInput;
};


export type MutationCreateWorkspaceArgs = {
  input: CreateWorkspaceInput;
};


export type MutationCreateWorkspaceInvitationArgs = {
  input: CreateWorkspaceInput;
};


export type MutationCreateWorkspaceParentArgs = {
  input: CreateWorkspaceParentInput;
};


export type MutationCreateWorkspaceProductArgs = {
  input: CreateWorkspaceProductInput;
  authorizationContext?: Maybe<AuthorizationContextInput>;
};


export type MutationCreateWorkspaceRegistrationCodeArgs = {
  input?: Maybe<CreateWorkspaceRegistrationCodeInput>;
};


export type MutationCreateWorkspaceRoleArgs = {
  input: CreateWorkspaceInput;
};


export type MutationCreateWorkspaceShareArgs = {
  input: CreateWorkspaceShareInput;
  authorizationContext?: Maybe<AuthorizationContextInput>;
};


export type MutationCreateWorkspaceUserArgs = {
  input: CreateWorkspaceInput;
  registrationCode?: Maybe<Scalars['String']>;
};


export type MutationDeleteAcademicCalendarArgs = {
  input: DeleteAcademicCalendarInput;
  authorizationContext: AuthorizationContextInput;
};


export type MutationDeleteAnnotationArgs = {
  input: DeleteAnnotationInput;
  authorizationContext: AuthorizationContextInput;
};


export type MutationDeleteAppUserActionArgs = {
  input: ControllerInput;
};


export type MutationDeleteBankArgs = {
  input: DeleteBankInput;
};


export type MutationDeleteBlueprintArgs = {
  input: DeleteResourceInput;
};


export type MutationDeleteClassroomArgs = {
  input: DeleteClassroomInput;
  authorizationContext?: Maybe<AuthorizationContextInput>;
};


export type MutationDeleteClassroomActionArgs = {
  input: ControllerInput;
  authorizationContext?: Maybe<AuthorizationContextInput>;
};


export type MutationDeleteClassroomActivityArgs = {
  input: DeleteClassroomActivityInput;
  authorizationContext?: Maybe<AuthorizationContextInput>;
};


export type MutationDeleteClassroomActivityActionArgs = {
  input: ControllerInput;
  authorizationContext?: Maybe<AuthorizationContextInput>;
};


export type MutationDeleteClassroomResourceArgs = {
  input: DeleteResourceInput;
  authorizationContext: AuthorizationContextInput;
};


export type MutationDeleteClassroomUnitArgs = {
  input: DeleteClassroomUnitInput;
  authorizationContext?: Maybe<AuthorizationContextInput>;
};


export type MutationDeleteCollectionArgs = {
  input?: Maybe<DeleteAssetInput>;
};


export type MutationDeleteCommentArgs = {
  input: DeleteCommentInput;
};


export type MutationDeleteCourseArgs = {
  input: DeleteCourseInput;
};


export type MutationDeleteCourseCalendarArgs = {
  input: DeleteCourseCalendarInput;
  authorizationContext: AuthorizationContextInput;
};


export type MutationDeleteIssueArgs = {
  input: DeleteIssueInput;
};


export type MutationDeleteItemArgs = {
  input: DeleteItemInput;
};


export type MutationDeleteObjectivesViewArgs = {
  input: DeleteObjectivesViewInput;
  authorizationContext: AuthorizationContextInput;
};


export type MutationDeletePerformanceTaskArgs = {
  input: DeletePerformanceTaskInput;
};


export type MutationDeleteRelativeArgs = {
  input?: Maybe<DeleteResourceRelativeInput>;
};


export type MutationDeleteResourceFavoriteArgs = {
  input: DeleteResourceFavoriteInput;
};


export type MutationDeleteResourcePurchaseArgs = {
  input: DeleteResourcePurchaseInput;
};


export type MutationDeleteResourceRatingArgs = {
  input: DeleteResourceRatingInput;
};


export type MutationDeleteResourceWatcherArgs = {
  input: DeleteResourceWatcherInput;
};


export type MutationDeleteRestApiTokenArgs = {
  input: DeleteRestApiTokenInput;
};


export type MutationDeleteReviewArgs = {
  input: DeleteReviewInput;
};


export type MutationDeleteRevisionNoteArgs = {
  input: DeleteRevisionNoteInput;
  authorizationContext: AuthorizationContextInput;
};


export type MutationDeleteRoleArgs = {
  input: DeleteRoleInput;
  authorizationContext: AuthorizationContextInput;
};


export type MutationDeleteRolePolicyArgs = {
  input: DeleteRoleInput;
  authorizationContext: AuthorizationContextInput;
};


export type MutationDeleteRubricArgs = {
  input: DeleteRubricInput;
};


export type MutationDeleteSnapshotArgs = {
  input: DeleteSnapshotInput;
};


export type MutationDeleteStudentArgs = {
  input: DeleteStudentInput;
  authorizationContext?: Maybe<AuthorizationContextInput>;
};


export type MutationDeleteTaskArgs = {
  input: DeleteTaskInput;
};


export type MutationDeleteTaskActionArgs = {
  input: ControllerInput;
};


export type MutationDeleteUnitArgs = {
  input: DeleteUnitInput;
};


export type MutationDeleteUnitLayoutArgs = {
  input: DeleteUnitLayoutInput;
  authorizationContext: AuthorizationContextInput;
};


export type MutationDeleteUserClassroomArgs = {
  input: GenericRelationshipInput;
  authorizationContext?: Maybe<AuthorizationContextInput>;
};


export type MutationDeleteUserNotificationArgs = {
  input: DeleteUserNotificationInput;
};


export type MutationDeleteUserResourceArgs = {
  input: DeleteUserResourceInput;
};


export type MutationDeleteVocabularyArgs = {
  input: DeleteVocabularyInput;
};


export type MutationDeleteWebDocumentArgs = {
  input: DeleteWebDocumentInput;
};


export type MutationDeleteWorklogArgs = {
  input: DeleteWorklogInput;
};


export type MutationDeleteWorkspaceArgs = {
  input: DeleteWorkspaceInput;
};


export type MutationDeleteWorkspaceInvitationArgs = {
  input: DeleteWorkspaceInput;
};


export type MutationDeleteWorkspaceParentArgs = {
  input: DeleteWorkspaceParentInput;
};


export type MutationDeleteWorkspaceProductArgs = {
  input: DeleteWorkspaceProductInput;
  authorizationContext?: Maybe<AuthorizationContextInput>;
};


export type MutationDeleteWorkspaceRoleArgs = {
  input: DeleteWorkspaceInput;
};


export type MutationDeleteWorkspaceShareArgs = {
  input: DeleteWorkspaceShareInput;
  authorizationContext?: Maybe<AuthorizationContextInput>;
};


export type MutationDeleteWorkspaceUserArgs = {
  input: DeleteWorkspaceInput;
};


export type MutationDeregisterContentArgs = {
  input: ControllerInput;
  authorizationContext: AuthorizationContextInput;
};


export type MutationDetachExamsFromUnitArgs = {
  input: Array<GenericRelationshipInput>;
};


export type MutationDetachItemsFromUnitArgs = {
  input: Array<GenericRelationshipInput>;
};


export type MutationDetachTaskFromResourceArgs = {
  input: TaskToResourceInput;
};


export type MutationDetachTaskOutputFromResourceArgs = {
  input: TaskToResourceInput;
};


export type MutationDetachVendorIdArgs = {
  input: DetachVendorIdInput;
};


export type MutationDisableWorkspaceUserArgs = {
  input: UpdateWorkspaceInput;
};


export type MutationExportClassroomRosterActionArgs = {
  input: ControllerInput;
  authorizationContext?: Maybe<AuthorizationContextInput>;
};


export type MutationGetPresignedUrlsForExamBlobsArgs = {
  input: ControllerInput;
};


export type MutationImportClassroomRosterActionArgs = {
  input: ControllerInput;
  authorizationContext?: Maybe<AuthorizationContextInput>;
};


export type MutationIncrementWorkspaceCounterArgs = {
  input?: Maybe<IncrementWorkspaceCounterInput>;
};


export type MutationInvokeObjectiveArgs = {
  input?: Maybe<InvokeObjectiveInput>;
};


export type MutationJoinWorkspaceArgs = {
  input: CreateWorkspaceInput;
};


export type MutationLeaveWorkspaceArgs = {
  input: CreateWorkspaceInput;
};


export type MutationLeaveWorkspaceV2Args = {
  input: DeleteWorkspaceInput;
};


export type MutationPrintExamArgs = {
  input: PrintExamInput;
};


export type MutationPrintPerformanceAssessmentArgs = {
  input: PrintPerformanceAssessmentInput;
};


export type MutationPrintVerificationDocumentArgs = {
  input: PrintVerificationDocumentInput;
};


export type MutationPrintYearAtaGlanceArgs = {
  input: PrintYearAtaGlanceInput;
};


export type MutationPutAppUserArgs = {
  input: CreateAppUserConfigInput;
  authorizationContext: AuthorizationContextInput;
};


export type MutationRegisterAppUserArgs = {
  input: RegisterAppUserControllerInput;
};


export type MutationRegisterCognitoUserArgs = {
  input: RegisterCognitoUserControllerInput;
};


export type MutationRegisterContentArgs = {
  input: ControllerInput;
  authorizationContext: AuthorizationContextInput;
};


export type MutationRemoveCollectionItemArgs = {
  input?: Maybe<RemoveCollectionItemInput>;
};


export type MutationRemoveTaskAuditItemArgs = {
  input: TaskToResourceInput;
};


export type MutationResetAppUserActionArgs = {
  input: ControllerInput;
};


export type MutationResetClassroomActionArgs = {
  input: ControllerInput;
  authorizationContext?: Maybe<AuthorizationContextInput>;
};


export type MutationRestoreSnapshotArgs = {
  input: RestoreSnapshotInput;
};


export type MutationSendEmailArgs = {
  type?: Maybe<Scalars['String']>;
  params?: Maybe<Scalars['AWSJSON']>;
};


export type MutationSendExamSessionUpdateArgs = {
  id?: Maybe<Scalars['ID']>;
  examConfigId?: Maybe<Scalars['ID']>;
  input: UpdateExamSessionInput;
};


export type MutationSendWorkspaceUpdateArgs = {
  input: WorkspaceUpdateInput;
};


export type MutationSetDefaultWorkspaceCalendarArgs = {
  input: SetDefaultWorkspaceCalendarInput;
  authorizationContext: AuthorizationContextInput;
};


export type MutationSetUserConfirmedArgs = {
  input: LoginUserInput;
};


export type MutationSubmitFeedbackArgs = {
  input: SubmitFeedbackInput;
};


export type MutationSubmitStudentExamArgs = {
  input: ControllerInput;
};


export type MutationToggleAppLicenseActionArgs = {
  input: ControllerInput;
};


export type MutationToggleAppUserActionArgs = {
  input: ControllerInput;
};


export type MutationUpdateAcademicCalendarArgs = {
  input: UpdateAcademicCalendarInput;
  authorizationContext: AuthorizationContextInput;
};


export type MutationUpdateAccountArgs = {
  input: UpdateAccountInput;
};


export type MutationUpdateAnnotationArgs = {
  input: UpdateAnnotationInput;
  authorizationContext: AuthorizationContextInput;
};


export type MutationUpdateBankArgs = {
  input: UpdateBankInput;
};


export type MutationUpdateBlueprintArgs = {
  input: UpdateResourceInput;
};


export type MutationUpdateClassroomArgs = {
  input: UpdateClassroomInput;
  authorizationContext?: Maybe<AuthorizationContextInput>;
};


export type MutationUpdateClassroomActivityArgs = {
  input: UpdateClassroomActivityInput;
  authorizationContext?: Maybe<AuthorizationContextInput>;
};


export type MutationUpdateClassroomStudentActionArgs = {
  input: ControllerInput;
  authorizationContext?: Maybe<AuthorizationContextInput>;
};


export type MutationUpdateClassroomUnitArgs = {
  input: UpdateClassroomUnitInput;
  authorizationContext?: Maybe<AuthorizationContextInput>;
};


export type MutationUpdateCollectionArgs = {
  input?: Maybe<UpdateAssetInput>;
};


export type MutationUpdateCommentArgs = {
  input: UpdateCommentInput;
};


export type MutationUpdateCourseArgs = {
  input: UpdateCourseInput;
};


export type MutationUpdateCourseCalendarArgs = {
  input: UpdateCourseCalendarInput;
  authorizationContext: AuthorizationContextInput;
};


export type MutationUpdateExamAttemptArgs = {
  input: UpdateExamAttemptInput;
};


export type MutationUpdateExamSessionArgs = {
  input: UpdateExamSessionInput;
};


export type MutationUpdateIssueArgs = {
  input: UpdateIssueInput;
};


export type MutationUpdateItemArgs = {
  input: UpdateResourceInput;
  authorizationContext: AuthorizationContextInput;
};


export type MutationUpdateObjectivesViewArgs = {
  input: UpdateObjectivesViewInput;
  authorizationContext: AuthorizationContextInput;
};


export type MutationUpdatePerformanceTaskArgs = {
  input: UpdatePerformanceTaskInput;
};


export type MutationUpdateResourceVersionDataArgs = {
  input: UpdateResourceVersionDataInput;
};


export type MutationUpdateReviewArgs = {
  input: UpdateReviewInput;
};


export type MutationUpdateRoleArgs = {
  input: UpdateRoleInput;
  authorizationContext: AuthorizationContextInput;
};


export type MutationUpdateRolePolicyArgs = {
  input: UpdateRolePolicyInput;
  authorizationContext: AuthorizationContextInput;
};


export type MutationUpdateRubricArgs = {
  input: UpdateRubricInput;
};


export type MutationUpdateStudentArgs = {
  input: UpdateStudentInput;
  authorizationContext?: Maybe<AuthorizationContextInput>;
};


export type MutationUpdateTaskArgs = {
  input: UpdateTaskInput;
};


export type MutationUpdateTaskStatusArgs = {
  input: ControllerInput;
};


export type MutationUpdateUnitArgs = {
  input: UpdateUnitInput;
};


export type MutationUpdateUnitLayoutArgs = {
  input: UpdateUnitLayoutInput;
  authorizationContext: AuthorizationContextInput;
};


export type MutationUpdateUserNotificationArgs = {
  input: UpdateUserNotificationInput;
};


export type MutationUpdateVocabularyArgs = {
  input: UpdateVocabularyInput;
};


export type MutationUpdateWebDocumentArgs = {
  input: UpdateWebDocumentInput;
};


export type MutationUpdateWorklogArgs = {
  input: UpdateWorklogInput;
};


export type MutationUpdateWorkspaceArgs = {
  input: UpdateWorkspaceInput;
};


export type MutationUpdateWorkspaceProductArgs = {
  input: UpdateWorkspaceProductInput;
  authorizationContext?: Maybe<AuthorizationContextInput>;
};


export type MutationUpdateWorkspaceRoleArgs = {
  input: UpdateWorkspaceInput;
};


export type MutationUpdateWorkspaceShareArgs = {
  input: UpdateWorkspaceShareInput;
  authorizationContext?: Maybe<AuthorizationContextInput>;
};


export type MutationUpdateWorkspaceSubscriptionForWorkspaceArgs = {
  input: UpdateWorkspaceSubscriptionInput;
};


export type MutationUpdateWorkspaceUserArgs = {
  input: UpdateWorkspaceInput;
};

export type AppDomain = {
  __typename?: 'AppDomain';
  id: Scalars['ID'];
  sk: Scalars['String'];
  workspaceId: Scalars['String'];
  schemaVersion: Scalars['String'];
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  tags?: Maybe<Array<Tag>>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
  appId?: Maybe<Scalars['String']>;
  app?: Maybe<App>;
};

export type CreateAppDomainInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
  workspaceId: Scalars['String'];
  schemaVersion: Scalars['String'];
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  tags?: Maybe<Array<TagInput>>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
  appId?: Maybe<Scalars['String']>;
};

export type UpdateAppDomainInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
  workspaceId: Scalars['String'];
  schemaVersion?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  tags?: Maybe<Array<TagInput>>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
  appId?: Maybe<Scalars['String']>;
};

export type DeleteAppDomainInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
};

export type AppLicense = {
  __typename?: 'AppLicense';
  id: Scalars['ID'];
  sk: Scalars['String'];
  workspaceId: Scalars['String'];
  schemaVersion: Scalars['String'];
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  tags?: Maybe<Array<Tag>>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
  creator?: Maybe<User>;
  creatorId?: Maybe<Scalars['String']>;
  appId?: Maybe<Scalars['String']>;
  appKey?: Maybe<Scalars['String']>;
  appSecret?: Maybe<Scalars['String']>;
  isDisabled?: Maybe<Scalars['Boolean']>;
  resourceId?: Maybe<Scalars['String']>;
  app?: Maybe<App>;
};

export type CreateAppLicenseInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
  workspaceId: Scalars['String'];
  schemaVersion: Scalars['String'];
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  tags?: Maybe<Array<TagInput>>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
  creatorId?: Maybe<Scalars['String']>;
  appId?: Maybe<Scalars['String']>;
  appKey?: Maybe<Scalars['String']>;
  appSecret?: Maybe<Scalars['String']>;
  isDisabled?: Maybe<Scalars['Boolean']>;
  resourceId?: Maybe<Scalars['String']>;
};

export type UpdateAppLicenseInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
  workspaceId: Scalars['String'];
  schemaVersion?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  tags?: Maybe<Array<TagInput>>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
  creatorId?: Maybe<Scalars['String']>;
  appId?: Maybe<Scalars['String']>;
  appKey?: Maybe<Scalars['String']>;
  appSecret?: Maybe<Scalars['String']>;
  isDisabled?: Maybe<Scalars['Boolean']>;
  resourceId?: Maybe<Scalars['String']>;
};

export type DeleteAppLicenseInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
};

export type App = {
  __typename?: 'App';
  id: Scalars['ID'];
  sk: Scalars['String'];
  workspaceId: Scalars['String'];
  schemaVersion: Scalars['String'];
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  tags?: Maybe<Array<Tag>>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
  creator?: Maybe<User>;
  creatorId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  config?: Maybe<Scalars['AWSJSON']>;
  serverConfig?: Maybe<Scalars['AWSJSON']>;
  workspace?: Maybe<Workspace>;
};

export type CreateAppInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
  workspaceId: Scalars['String'];
  schemaVersion: Scalars['String'];
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  tags?: Maybe<Array<TagInput>>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
  creatorId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  config?: Maybe<Scalars['AWSJSON']>;
};

export type UpdateAppInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
  workspaceId: Scalars['String'];
  schemaVersion?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  tags?: Maybe<Array<TagInput>>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
  creatorId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  config?: Maybe<Scalars['AWSJSON']>;
};

export type DeleteAppInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
};

export type AppKey = {
  __typename?: 'AppKey';
  id: Scalars['ID'];
  sk: Scalars['String'];
  workspaceId: Scalars['String'];
  schemaVersion: Scalars['String'];
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  tags?: Maybe<Array<Tag>>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
  creator?: Maybe<User>;
  creatorId?: Maybe<Scalars['String']>;
  config?: Maybe<Scalars['AWSJSON']>;
  appId?: Maybe<Scalars['String']>;
  appKey?: Maybe<Scalars['String']>;
  appSecret?: Maybe<Scalars['String']>;
  isDisabled?: Maybe<Scalars['Boolean']>;
  resourceId?: Maybe<Scalars['String']>;
};

export type CreateAppKeyInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
  workspaceId: Scalars['String'];
  schemaVersion: Scalars['String'];
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  tags?: Maybe<Array<TagInput>>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
  creatorId?: Maybe<Scalars['String']>;
  config?: Maybe<Scalars['AWSJSON']>;
  appId?: Maybe<Scalars['String']>;
  appKey?: Maybe<Scalars['String']>;
  appSecret?: Maybe<Scalars['String']>;
  isDisabled?: Maybe<Scalars['Boolean']>;
  resourceId?: Maybe<Scalars['String']>;
};

export type UpdateAppKeyInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
  workspaceId: Scalars['String'];
  schemaVersion?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  tags?: Maybe<Array<TagInput>>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
  creatorId?: Maybe<Scalars['String']>;
  config?: Maybe<Scalars['AWSJSON']>;
  appId?: Maybe<Scalars['String']>;
  appKey?: Maybe<Scalars['String']>;
  appSecret?: Maybe<Scalars['String']>;
  isDisabled?: Maybe<Scalars['Boolean']>;
  resourceId?: Maybe<Scalars['String']>;
};

export type DeleteAppKeyInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
};

export type AppUserLicense = {
  __typename?: 'AppUserLicense';
  id: Scalars['ID'];
  sk: Scalars['String'];
  workspaceId: Scalars['String'];
  schemaVersion: Scalars['String'];
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  tags?: Maybe<Array<Tag>>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
  creator?: Maybe<User>;
  creatorId?: Maybe<Scalars['String']>;
  config?: Maybe<Scalars['AWSJSON']>;
  isDisabled?: Maybe<Scalars['Boolean']>;
};

export type CreateAppUserLicenseInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
  workspaceId: Scalars['String'];
  schemaVersion: Scalars['String'];
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  tags?: Maybe<Array<TagInput>>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
  creatorId?: Maybe<Scalars['String']>;
  config?: Maybe<Scalars['AWSJSON']>;
  isDisabled?: Maybe<Scalars['Boolean']>;
};

export type UpdateAppUserLicenseInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
  workspaceId: Scalars['String'];
  schemaVersion?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  tags?: Maybe<Array<TagInput>>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
  creatorId?: Maybe<Scalars['String']>;
  config?: Maybe<Scalars['AWSJSON']>;
  isDisabled?: Maybe<Scalars['Boolean']>;
};

export type DeleteAppUserLicenseInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
};

export type AppUserConfig = {
  __typename?: 'AppUserConfig';
  id: Scalars['ID'];
  sk: Scalars['String'];
  workspaceId: Scalars['String'];
  schemaVersion: Scalars['String'];
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  tags?: Maybe<Array<Tag>>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
  config?: Maybe<Scalars['AWSJSON']>;
  workspaceUser?: Maybe<Workspace>;
};

export type CreateAppUserConfigInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
  workspaceId: Scalars['String'];
  schemaVersion: Scalars['String'];
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  tags?: Maybe<Array<TagInput>>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
  config?: Maybe<Scalars['AWSJSON']>;
};

export type UpdateAppUserConfigInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
  workspaceId: Scalars['String'];
  schemaVersion?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  tags?: Maybe<Array<TagInput>>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
  config?: Maybe<Scalars['AWSJSON']>;
};

export type DeleteAppUserConfigInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
};

export type ModelAppUserConnection = {
  __typename?: 'ModelAppUserConnection';
  items: Array<AppUserConfig>;
  nextToken?: Maybe<Scalars['String']>;
};

export type SignCampfireLtiResponse = {
  __typename?: 'SignCampfireLtiResponse';
  signature?: Maybe<Scalars['String']>;
};

export type ListAppUserConfigsInput = {
  appKeyId: Scalars['String'];
  nextToken?: Maybe<Scalars['String']>;
};

export type StudentLaunchReservation = {
  __typename?: 'StudentLaunchReservation';
  id: Scalars['ID'];
  sk: Scalars['String'];
  workspaceId: Scalars['String'];
  schemaVersion: Scalars['String'];
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  tags?: Maybe<Array<Tag>>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
  email: Scalars['String'];
  appId: Scalars['String'];
  expiresAt?: Maybe<Scalars['AWSDateTime']>;
};

export type CreateStudentLaunchReservationInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
  workspaceId: Scalars['String'];
  schemaVersion: Scalars['String'];
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  tags?: Maybe<Array<TagInput>>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
  email: Scalars['String'];
  appId: Scalars['String'];
  expiresAt?: Maybe<Scalars['AWSDateTime']>;
};

export type UpdateStudentLaunchReservationInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
  workspaceId: Scalars['String'];
  schemaVersion?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  tags?: Maybe<Array<TagInput>>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
  email?: Maybe<Scalars['String']>;
  appId?: Maybe<Scalars['String']>;
  expiresAt?: Maybe<Scalars['AWSDateTime']>;
};

export type DeleteStudentLaunchReservationInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
};

export type LaunchToken = {
  __typename?: 'LaunchToken';
  id: Scalars['ID'];
  sk: Scalars['String'];
  workspaceId: Scalars['String'];
  schemaVersion: Scalars['String'];
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  tags?: Maybe<Array<Tag>>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
  token?: Maybe<Scalars['String']>;
};

export type CreateLaunchTokenInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
  workspaceId: Scalars['String'];
  schemaVersion: Scalars['String'];
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  tags?: Maybe<Array<TagInput>>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
  token?: Maybe<Scalars['String']>;
};

export type UpdateLaunchTokenInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
  workspaceId: Scalars['String'];
  schemaVersion?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  tags?: Maybe<Array<TagInput>>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
  token?: Maybe<Scalars['String']>;
};

export type DeleteLaunchTokenInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
};

export type AuthToken = {
  __typename?: 'AuthToken';
  AccessToken?: Maybe<Scalars['String']>;
  ExpiresIn?: Maybe<Scalars['Int']>;
  TokenType?: Maybe<Scalars['String']>;
  RefreshToken?: Maybe<Scalars['String']>;
  IdToken?: Maybe<Scalars['String']>;
  ClientId?: Maybe<Scalars['String']>;
};

export type AuthTokenInput = {
  username: Scalars['String'];
};

export type ModelIdFilterInput = {
  ne?: Maybe<Scalars['ID']>;
  eq?: Maybe<Scalars['ID']>;
  le?: Maybe<Scalars['ID']>;
  lt?: Maybe<Scalars['ID']>;
  ge?: Maybe<Scalars['ID']>;
  gt?: Maybe<Scalars['ID']>;
  contains?: Maybe<Scalars['ID']>;
  notContains?: Maybe<Scalars['ID']>;
  between?: Maybe<Array<Maybe<Scalars['ID']>>>;
  beginsWith?: Maybe<Scalars['ID']>;
};

export type ModelStringFilterInput = {
  ne?: Maybe<Scalars['String']>;
  eq?: Maybe<Scalars['String']>;
  le?: Maybe<Scalars['String']>;
  lt?: Maybe<Scalars['String']>;
  ge?: Maybe<Scalars['String']>;
  gt?: Maybe<Scalars['String']>;
  contains?: Maybe<Scalars['String']>;
  notContains?: Maybe<Scalars['String']>;
  between?: Maybe<Array<Maybe<Scalars['String']>>>;
  beginsWith?: Maybe<Scalars['String']>;
};

export type ModelStringKeyConditionInput = {
  eq?: Maybe<Scalars['String']>;
  le?: Maybe<Scalars['String']>;
  lt?: Maybe<Scalars['String']>;
  ge?: Maybe<Scalars['String']>;
  gt?: Maybe<Scalars['String']>;
  between?: Maybe<Array<Maybe<Scalars['String']>>>;
  beginsWith?: Maybe<Scalars['String']>;
};

export type ModelIntFilterInput = {
  ne?: Maybe<Scalars['Int']>;
  eq?: Maybe<Scalars['Int']>;
  le?: Maybe<Scalars['Int']>;
  lt?: Maybe<Scalars['Int']>;
  ge?: Maybe<Scalars['Int']>;
  gt?: Maybe<Scalars['Int']>;
  between?: Maybe<Array<Maybe<Scalars['Int']>>>;
};

export type ModelBooleanFilterInput = {
  ne?: Maybe<Scalars['Boolean']>;
  eq?: Maybe<Scalars['Boolean']>;
};

export type OldEvent = {
  __typename?: 'OldEvent';
  type?: Maybe<Scalars['String']>;
  sender?: Maybe<Scalars['String']>;
  payload?: Maybe<Scalars['String']>;
};

export type OldEventInput = {
  type?: Maybe<Scalars['String']>;
  sender?: Maybe<Scalars['String']>;
  payload?: Maybe<Scalars['String']>;
};

export type Reviews = {
  __typename?: 'Reviews';
  approved?: Maybe<Array<Maybe<Review>>>;
  rejected?: Maybe<Array<Maybe<Review>>>;
  pending?: Maybe<Array<Maybe<Review>>>;
};

export type Review = {
  __typename?: 'Review';
  user?: Maybe<User>;
  status?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['AWSDateTime']>;
};

export enum WorkspaceUserRole {
  Viewer = 'VIEWER',
  Collector = 'COLLECTOR',
  Author = 'AUTHOR',
  Editor = 'EDITOR',
  Standard = 'STANDARD',
  ContentManager = 'CONTENT_MANAGER',
  Administrator = 'ADMINISTRATOR'
}

export enum UserType {
  AppsOnly = 'APPS_ONLY'
}

export enum ModelSortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type ModelGetInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
};

export type ModelListInput = {
  id?: Maybe<Scalars['ID']>;
  sk?: Maybe<ModelStringKeyConditionInput>;
  filter?: Maybe<ModelWorkspaceFilterInput>;
  workspaceId?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  nextToken?: Maybe<Scalars['String']>;
  sortDirection?: Maybe<ModelSortDirection>;
};

export type ListWorkspacesBySortKeyInput = {
  id?: Maybe<ModelStringKeyConditionInput>;
  sk?: Maybe<Scalars['ID']>;
  filter?: Maybe<ModelWorkspaceFilterInput>;
  limit?: Maybe<Scalars['Int']>;
  nextToken?: Maybe<Scalars['String']>;
  sortDirection?: Maybe<ModelSortDirection>;
};

export type KeysResultItemType = {
  __typename?: 'KeysResultItemType';
  id: Scalars['String'];
  sk: Scalars['String'];
};

export type IdskInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
  typename?: Maybe<Scalars['String']>;
};

export type AuthorizationContextInput = {
  workspaceId?: Maybe<Scalars['String']>;
  appId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type GenericReferenceId = {
  __typename?: 'GenericReferenceId';
  id: Scalars['ID'];
  sk: Scalars['String'];
  data?: Maybe<Scalars['AWSJSON']>;
  tags?: Maybe<Array<Tag>>;
};

export type GenericReferenceIdInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
  data?: Maybe<Scalars['AWSJSON']>;
  tags?: Maybe<Array<TagInput>>;
};

export type GenericRelationshipInput = {
  left: IdskInput;
  right: IdskInput;
  workspaceId: Scalars['String'];
};

export type ClassroomActivity = {
  __typename?: 'ClassroomActivity';
  id: Scalars['ID'];
  sk: Scalars['String'];
  workspaceId: Scalars['String'];
  schemaVersion: Scalars['String'];
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  tags?: Maybe<Array<Tag>>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
  creator?: Maybe<User>;
  creatorId?: Maybe<Scalars['String']>;
  classroom?: Maybe<Classroom>;
  unit?: Maybe<Unit>;
  resourceId?: Maybe<Scalars['String']>;
  examConfig?: Maybe<Resource>;
};

export type CreateClassroomActivityInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
  workspaceId: Scalars['String'];
  schemaVersion: Scalars['String'];
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  tags?: Maybe<Array<TagInput>>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
  creatorId?: Maybe<Scalars['String']>;
  resourceId?: Maybe<Scalars['String']>;
};

export type UpdateClassroomActivityInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
  workspaceId: Scalars['String'];
  schemaVersion?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  tags?: Maybe<Array<TagInput>>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
  creatorId?: Maybe<Scalars['String']>;
  resourceId?: Maybe<Scalars['String']>;
};

export type DeleteClassroomActivityInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
};

export type ModelClassroomActivityConnection = {
  __typename?: 'ModelClassroomActivityConnection';
  items?: Maybe<Array<Maybe<ClassroomActivity>>>;
  nextToken?: Maybe<Scalars['String']>;
};

export type AcademicCalendar = {
  __typename?: 'AcademicCalendar';
  id: Scalars['ID'];
  sk: Scalars['String'];
  workspaceId: Scalars['String'];
  schemaVersion: Scalars['String'];
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  tags?: Maybe<Array<Tag>>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
  author?: Maybe<Scalars['String']>;
  bankId?: Maybe<Scalars['String']>;
  checksum?: Maybe<Scalars['String']>;
  copyrightYear?: Maybe<Scalars['String']>;
  courseIds?: Maybe<Array<Scalars['String']>>;
  grade?: Maybe<Array<Scalars['String']>>;
  idInc?: Maybe<Scalars['String']>;
  idVendor?: Maybe<Scalars['String']>;
  isbn?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isUnlisted?: Maybe<Scalars['Boolean']>;
  keywords?: Maybe<Array<Scalars['String']>>;
  language?: Maybe<Array<Scalars['String']>>;
  maturity?: Maybe<Scalars['String']>;
  sequence?: Maybe<Scalars['String']>;
  subject?: Maybe<Array<Scalars['String']>>;
  type?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['Int']>;
  visibility?: Maybe<ResourceVisibilityType>;
  creator?: Maybe<User>;
  creatorId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  startAt: Scalars['AWSDate'];
  endAt: Scalars['AWSDate'];
  instructionWeekdays?: Maybe<Array<Weekday>>;
  nonInstructionDates?: Maybe<Array<NonInstructionDate>>;
  gradingPeriodLength?: Maybe<Scalars['String']>;
  gradingPeriods?: Maybe<Array<GradingPeriod>>;
  isArchived?: Maybe<Scalars['Boolean']>;
};

export type CreateAcademicCalendarInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
  workspaceId: Scalars['String'];
  schemaVersion: Scalars['String'];
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  tags?: Maybe<Array<TagInput>>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
  author?: Maybe<Scalars['String']>;
  bankId?: Maybe<Scalars['String']>;
  checksum?: Maybe<Scalars['String']>;
  copyrightYear?: Maybe<Scalars['String']>;
  courseIds?: Maybe<Array<Scalars['String']>>;
  grade?: Maybe<Array<Scalars['String']>>;
  idInc?: Maybe<Scalars['String']>;
  idVendor?: Maybe<Scalars['String']>;
  isbn?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isUnlisted?: Maybe<Scalars['Boolean']>;
  keywords?: Maybe<Array<Scalars['String']>>;
  language?: Maybe<Array<Scalars['String']>>;
  maturity?: Maybe<Scalars['String']>;
  sequence?: Maybe<Scalars['String']>;
  subject?: Maybe<Array<Scalars['String']>>;
  type?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['Int']>;
  visibility?: Maybe<ResourceVisibilityType>;
  creatorId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  startAt: Scalars['AWSDate'];
  endAt: Scalars['AWSDate'];
  instructionWeekdays?: Maybe<Array<Weekday>>;
  nonInstructionDates?: Maybe<Array<NonInstructionDateInput>>;
  gradingPeriodLength?: Maybe<Scalars['String']>;
  gradingPeriods?: Maybe<Array<GradingPeriodInput>>;
  isArchived?: Maybe<Scalars['Boolean']>;
};

export type UpdateAcademicCalendarInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
  workspaceId: Scalars['String'];
  schemaVersion?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  tags?: Maybe<Array<TagInput>>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
  author?: Maybe<Scalars['String']>;
  bankId?: Maybe<Scalars['String']>;
  checksum?: Maybe<Scalars['String']>;
  copyrightYear?: Maybe<Scalars['String']>;
  courseIds?: Maybe<Array<Scalars['String']>>;
  grade?: Maybe<Array<Scalars['String']>>;
  idInc?: Maybe<Scalars['String']>;
  idVendor?: Maybe<Scalars['String']>;
  isbn?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isUnlisted?: Maybe<Scalars['Boolean']>;
  keywords?: Maybe<Array<Scalars['String']>>;
  language?: Maybe<Array<Scalars['String']>>;
  maturity?: Maybe<Scalars['String']>;
  sequence?: Maybe<Scalars['String']>;
  subject?: Maybe<Array<Scalars['String']>>;
  type?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['Int']>;
  visibility?: Maybe<ResourceVisibilityType>;
  creatorId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  startAt?: Maybe<Scalars['AWSDate']>;
  endAt?: Maybe<Scalars['AWSDate']>;
  instructionWeekdays?: Maybe<Array<Weekday>>;
  nonInstructionDates?: Maybe<Array<NonInstructionDateInput>>;
  gradingPeriodLength?: Maybe<Scalars['String']>;
  gradingPeriods?: Maybe<Array<GradingPeriodInput>>;
  isArchived?: Maybe<Scalars['Boolean']>;
};

export type DeleteAcademicCalendarInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
};

export type CourseCalendar = {
  __typename?: 'CourseCalendar';
  id: Scalars['ID'];
  sk: Scalars['String'];
  workspaceId: Scalars['String'];
  schemaVersion: Scalars['String'];
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  tags?: Maybe<Array<Tag>>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
  author?: Maybe<Scalars['String']>;
  bankId?: Maybe<Scalars['String']>;
  checksum?: Maybe<Scalars['String']>;
  copyrightYear?: Maybe<Scalars['String']>;
  courseIds?: Maybe<Array<Scalars['String']>>;
  description?: Maybe<Scalars['String']>;
  grade?: Maybe<Array<Scalars['String']>>;
  idInc?: Maybe<Scalars['String']>;
  idVendor?: Maybe<Scalars['String']>;
  isbn?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isUnlisted?: Maybe<Scalars['Boolean']>;
  keywords?: Maybe<Array<Scalars['String']>>;
  language?: Maybe<Array<Scalars['String']>>;
  maturity?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  sequence?: Maybe<Scalars['String']>;
  subject?: Maybe<Array<Scalars['String']>>;
  type?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['Int']>;
  visibility?: Maybe<ResourceVisibilityType>;
  creator?: Maybe<User>;
  creatorId?: Maybe<Scalars['String']>;
  calendarId: Scalars['ID'];
  calendar?: Maybe<AcademicCalendar>;
  courseId: Scalars['ID'];
  course?: Maybe<Course>;
  units?: Maybe<Array<UnitPlan>>;
  additionalNonInstructionDates?: Maybe<Array<NonInstructionDate>>;
  isArchived?: Maybe<Scalars['Boolean']>;
};

export type CreateCourseCalendarInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
  workspaceId: Scalars['String'];
  schemaVersion: Scalars['String'];
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  tags?: Maybe<Array<TagInput>>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
  author?: Maybe<Scalars['String']>;
  bankId?: Maybe<Scalars['String']>;
  checksum?: Maybe<Scalars['String']>;
  copyrightYear?: Maybe<Scalars['String']>;
  courseIds?: Maybe<Array<Scalars['String']>>;
  description?: Maybe<Scalars['String']>;
  grade?: Maybe<Array<Scalars['String']>>;
  idInc?: Maybe<Scalars['String']>;
  idVendor?: Maybe<Scalars['String']>;
  isbn?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isUnlisted?: Maybe<Scalars['Boolean']>;
  keywords?: Maybe<Array<Scalars['String']>>;
  language?: Maybe<Array<Scalars['String']>>;
  maturity?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  sequence?: Maybe<Scalars['String']>;
  subject?: Maybe<Array<Scalars['String']>>;
  type?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['Int']>;
  visibility?: Maybe<ResourceVisibilityType>;
  creatorId?: Maybe<Scalars['String']>;
  calendarId: Scalars['ID'];
  courseId: Scalars['ID'];
  units?: Maybe<Array<UnitPlanInput>>;
  additionalNonInstructionDates?: Maybe<Array<NonInstructionDateInput>>;
  isArchived?: Maybe<Scalars['Boolean']>;
};

export type UpdateCourseCalendarInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
  workspaceId: Scalars['String'];
  schemaVersion?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  tags?: Maybe<Array<TagInput>>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
  author?: Maybe<Scalars['String']>;
  bankId?: Maybe<Scalars['String']>;
  checksum?: Maybe<Scalars['String']>;
  copyrightYear?: Maybe<Scalars['String']>;
  courseIds?: Maybe<Array<Scalars['String']>>;
  description?: Maybe<Scalars['String']>;
  grade?: Maybe<Array<Scalars['String']>>;
  idInc?: Maybe<Scalars['String']>;
  idVendor?: Maybe<Scalars['String']>;
  isbn?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isUnlisted?: Maybe<Scalars['Boolean']>;
  keywords?: Maybe<Array<Scalars['String']>>;
  language?: Maybe<Array<Scalars['String']>>;
  maturity?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  sequence?: Maybe<Scalars['String']>;
  subject?: Maybe<Array<Scalars['String']>>;
  type?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['Int']>;
  visibility?: Maybe<ResourceVisibilityType>;
  creatorId?: Maybe<Scalars['String']>;
  calendarId?: Maybe<Scalars['ID']>;
  courseId?: Maybe<Scalars['ID']>;
  units?: Maybe<Array<UnitPlanInput>>;
  additionalNonInstructionDates?: Maybe<Array<NonInstructionDateInput>>;
  isArchived?: Maybe<Scalars['Boolean']>;
};

export type DeleteCourseCalendarInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
};

export enum Weekday {
  Sunday = 'SUNDAY',
  Monday = 'MONDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY',
  Thursday = 'THURSDAY',
  Friday = 'FRIDAY',
  Saturday = 'SATURDAY'
}

export type NonInstructionDate = {
  __typename?: 'NonInstructionDate';
  type?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  startAt: Scalars['AWSDate'];
  endAt?: Maybe<Scalars['AWSDate']>;
};

export type NonInstructionDateInput = {
  type?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  startAt: Scalars['AWSDate'];
  endAt?: Maybe<Scalars['AWSDate']>;
};

export type GradingPeriod = {
  __typename?: 'GradingPeriod';
  label: Scalars['String'];
  startAt: Scalars['AWSDate'];
  endAt: Scalars['AWSDate'];
  length?: Maybe<Scalars['Int']>;
  units?: Maybe<Array<UnitPlan>>;
};

export type GradingPeriodInput = {
  label: Scalars['String'];
  startAt: Scalars['AWSDate'];
  endAt: Scalars['AWSDate'];
  length?: Maybe<Scalars['Int']>;
  units?: Maybe<Array<UnitPlanInput>>;
};

export type ModelAcademicCalendarConnection = {
  __typename?: 'ModelAcademicCalendarConnection';
  items?: Maybe<Array<Maybe<AcademicCalendar>>>;
  nextToken?: Maybe<Scalars['String']>;
};

export type ModelCourseCalendarConnection = {
  __typename?: 'ModelCourseCalendarConnection';
  items?: Maybe<Array<Maybe<CourseCalendar>>>;
  nextToken?: Maybe<Scalars['String']>;
};

export type SetDefaultWorkspaceCalendarInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
  defaultCalendarTag: TagInput;
};

export type SearchableCourseCalendarConnection = {
  __typename?: 'SearchableCourseCalendarConnection';
  items?: Maybe<Array<CourseCalendar>>;
  nextToken?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Int']>;
  aggregations?: Maybe<Scalars['AWSJSON']>;
};

export type SearchableAcademicCalendarConnection = {
  __typename?: 'SearchableAcademicCalendarConnection';
  items?: Maybe<Array<AcademicCalendar>>;
  nextToken?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Int']>;
  aggregations?: Maybe<Scalars['AWSJSON']>;
};

export type UserClassroom = {
  __typename?: 'UserClassroom';
  id: Scalars['ID'];
  sk: Scalars['String'];
  workspaceId: Scalars['String'];
  schemaVersion: Scalars['String'];
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  tags?: Maybe<Array<Tag>>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
  creator?: Maybe<User>;
  creatorId?: Maybe<Scalars['String']>;
  classroom?: Maybe<Classroom>;
  user?: Maybe<User>;
  role?: Maybe<Scalars['String']>;
};

export type CreateUserClassroomInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
  workspaceId: Scalars['String'];
  schemaVersion: Scalars['String'];
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  tags?: Maybe<Array<TagInput>>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
  creatorId?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
};

export type UpdateUserClassroomInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
  workspaceId: Scalars['String'];
  schemaVersion?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  tags?: Maybe<Array<TagInput>>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
  creatorId?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
};

export type DeleteUserClassroomInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
};

export type UnitPlan = {
  __typename?: 'UnitPlan';
  id?: Maybe<Scalars['String']>;
  dates?: Maybe<Array<Scalars['AWSDate']>>;
};

export type UnitPlanInput = {
  id?: Maybe<Scalars['String']>;
  dates?: Maybe<Array<Scalars['AWSDate']>>;
};

export type Holiday = {
  __typename?: 'Holiday';
  label: Scalars['String'];
  date: Scalars['AWSDateTime'];
};

export type HolidayInput = {
  label: Scalars['String'];
  date: Scalars['AWSDateTime'];
};

export type ClassroomPacing = {
  __typename?: 'ClassroomPacing';
  courseStartAt: Scalars['AWSDateTime'];
  courseEndAt: Scalars['AWSDateTime'];
  instructionDays?: Maybe<Array<Weekday>>;
  holidays?: Maybe<Array<Holiday>>;
  gradingPeriodLength?: Maybe<Scalars['String']>;
  gradingPeriods?: Maybe<Array<GradingPeriod>>;
};

export type ClassroomPacingInput = {
  courseStartAt: Scalars['AWSDateTime'];
  courseEndAt: Scalars['AWSDateTime'];
  instructionDays?: Maybe<Array<Weekday>>;
  holidays?: Maybe<Array<HolidayInput>>;
  gradingPeriodLength?: Maybe<Scalars['String']>;
  gradingPeriods?: Maybe<Array<GradingPeriodInput>>;
};

export type CoursePlan = {
  __typename?: 'CoursePlan';
  units?: Maybe<Array<UnitPlan>>;
  nonInstructionDates?: Maybe<Array<Scalars['AWSDate']>>;
  gradingPeriods?: Maybe<Array<GradingPeriod>>;
};

export type CoursePlanInput = {
  units?: Maybe<Array<UnitPlanInput>>;
  nonInstructionDates?: Maybe<Array<Scalars['AWSDate']>>;
  gradingPeriods?: Maybe<Array<GradingPeriodInput>>;
};

export type ClassroomUser = {
  __typename?: 'ClassroomUser';
  id: Scalars['ID'];
  sk: Scalars['String'];
  workspaceId: Scalars['String'];
  schemaVersion: Scalars['String'];
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  tags?: Maybe<Array<Tag>>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
  creator?: Maybe<User>;
  creatorId?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
};

export type CreateClassroomUserInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
  workspaceId: Scalars['String'];
  schemaVersion: Scalars['String'];
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  tags?: Maybe<Array<TagInput>>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
  creatorId?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
};

export type UpdateClassroomUserInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
  workspaceId: Scalars['String'];
  schemaVersion?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  tags?: Maybe<Array<TagInput>>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
  creatorId?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
};

export type DeleteClassroomUserInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
};

export type Classroom = {
  __typename?: 'Classroom';
  id: Scalars['ID'];
  sk: Scalars['String'];
  workspaceId: Scalars['String'];
  schemaVersion: Scalars['String'];
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  tags?: Maybe<Array<Tag>>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
  creator?: Maybe<User>;
  creatorId?: Maybe<Scalars['String']>;
  courseId?: Maybe<Scalars['String']>;
  course?: Maybe<Course>;
  data?: Maybe<Scalars['AWSJSON']>;
  description?: Maybe<Scalars['String']>;
  grade?: Maybe<Array<Scalars['String']>>;
  isArchived?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  room?: Maybe<Scalars['String']>;
  sectionNumber?: Maybe<Scalars['String']>;
  studentCount?: Maybe<Scalars['Int']>;
  subject?: Maybe<Array<Scalars['String']>>;
  calendarId?: Maybe<Scalars['String']>;
  unitId?: Maybe<Scalars['String']>;
  unit?: Maybe<Unit>;
  units?: Maybe<Array<ClassroomUnit>>;
  users?: Maybe<Array<UserClassroom>>;
};

export type CreateClassroomInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
  workspaceId: Scalars['String'];
  schemaVersion: Scalars['String'];
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  tags?: Maybe<Array<TagInput>>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
  creatorId?: Maybe<Scalars['String']>;
  courseId?: Maybe<Scalars['String']>;
  data?: Maybe<Scalars['AWSJSON']>;
  description?: Maybe<Scalars['String']>;
  grade?: Maybe<Array<Scalars['String']>>;
  isArchived?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  room?: Maybe<Scalars['String']>;
  sectionNumber?: Maybe<Scalars['String']>;
  subject?: Maybe<Array<Scalars['String']>>;
  calendarId?: Maybe<Scalars['String']>;
  unitId?: Maybe<Scalars['String']>;
};

export type UpdateClassroomInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
  workspaceId: Scalars['String'];
  schemaVersion?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  tags?: Maybe<Array<TagInput>>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
  creatorId?: Maybe<Scalars['String']>;
  courseId?: Maybe<Scalars['String']>;
  data?: Maybe<Scalars['AWSJSON']>;
  description?: Maybe<Scalars['String']>;
  grade?: Maybe<Array<Scalars['String']>>;
  isArchived?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  room?: Maybe<Scalars['String']>;
  sectionNumber?: Maybe<Scalars['String']>;
  subject?: Maybe<Array<Scalars['String']>>;
  calendarId?: Maybe<Scalars['String']>;
  unitId?: Maybe<Scalars['String']>;
};

export type DeleteClassroomInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
};

export type ClassroomUnit = {
  __typename?: 'ClassroomUnit';
  id: Scalars['ID'];
  sk: Scalars['String'];
  workspaceId: Scalars['String'];
  schemaVersion: Scalars['String'];
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  tags?: Maybe<Array<Tag>>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
  creator?: Maybe<User>;
  creatorId?: Maybe<Scalars['String']>;
  maturity?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['AWSDateTime']>;
  completedAt?: Maybe<Scalars['AWSDateTime']>;
  unit?: Maybe<Unit>;
};

export type CreateClassroomUnitInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
  workspaceId: Scalars['String'];
  schemaVersion: Scalars['String'];
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  tags?: Maybe<Array<TagInput>>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
  creatorId?: Maybe<Scalars['String']>;
  maturity?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['AWSDateTime']>;
  completedAt?: Maybe<Scalars['AWSDateTime']>;
};

export type UpdateClassroomUnitInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
  workspaceId: Scalars['String'];
  schemaVersion?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  tags?: Maybe<Array<TagInput>>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
  creatorId?: Maybe<Scalars['String']>;
  maturity?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['AWSDateTime']>;
  completedAt?: Maybe<Scalars['AWSDateTime']>;
};

export type DeleteClassroomUnitInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
};

export type Student = {
  __typename?: 'Student';
  id: Scalars['ID'];
  sk: Scalars['String'];
  workspaceId: Scalars['String'];
  schemaVersion: Scalars['String'];
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  tags?: Maybe<Array<Tag>>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
  creator?: Maybe<User>;
  creatorId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  idProviderType?: Maybe<Scalars['String']>;
  idProviderUserId?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isDisabled?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  photoURL?: Maybe<Scalars['String']>;
  studentId?: Maybe<Scalars['String']>;
};

export type CreateStudentInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
  workspaceId: Scalars['String'];
  schemaVersion: Scalars['String'];
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  tags?: Maybe<Array<TagInput>>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
  creatorId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  idProviderType?: Maybe<Scalars['String']>;
  idProviderUserId?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isDisabled?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  photoURL?: Maybe<Scalars['String']>;
  studentId?: Maybe<Scalars['String']>;
};

export type UpdateStudentInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
  workspaceId: Scalars['String'];
  schemaVersion?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  tags?: Maybe<Array<TagInput>>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
  creatorId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  idProviderType?: Maybe<Scalars['String']>;
  idProviderUserId?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isDisabled?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  photoURL?: Maybe<Scalars['String']>;
  studentId?: Maybe<Scalars['String']>;
};

export type DeleteStudentInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
};

export type ModelUserClassroomConnection = {
  __typename?: 'ModelUserClassroomConnection';
  items?: Maybe<Array<Maybe<UserClassroom>>>;
  nextToken?: Maybe<Scalars['String']>;
};

export type ModelStudentConnection = {
  __typename?: 'ModelStudentConnection';
  items?: Maybe<Array<Maybe<Student>>>;
  nextToken?: Maybe<Scalars['String']>;
};

export type ListUserClassroomsInput = {
  userId?: Maybe<Scalars['String']>;
  includeAll?: Maybe<Scalars['Boolean']>;
  nextToken?: Maybe<Scalars['String']>;
};

export type Collaboration = {
  __typename?: 'Collaboration';
  id: Scalars['ID'];
  sk: Scalars['String'];
};

export type Comment = {
  __typename?: 'Comment';
  id: Scalars['ID'];
  sk: Scalars['String'];
  workspaceId: Scalars['String'];
  schemaVersion: Scalars['String'];
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  tags?: Maybe<Array<Tag>>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
  creator?: Maybe<User>;
  creatorId?: Maybe<Scalars['String']>;
  resourceId?: Maybe<Scalars['String']>;
  resource?: Maybe<Resource>;
  content?: Maybe<ResourceContent>;
};

export type CreateCommentInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
  workspaceId: Scalars['String'];
  schemaVersion: Scalars['String'];
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  tags?: Maybe<Array<TagInput>>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
  creatorId?: Maybe<Scalars['String']>;
  resourceId?: Maybe<Scalars['String']>;
  content?: Maybe<ResourceContentInput>;
};

export type UpdateCommentInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
  workspaceId: Scalars['String'];
  schemaVersion?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  tags?: Maybe<Array<TagInput>>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
  creatorId?: Maybe<Scalars['String']>;
  resourceId?: Maybe<Scalars['String']>;
  content?: Maybe<ResourceContentInput>;
};

export type DeleteCommentInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
};

export type ModelCommentConnection = {
  __typename?: 'ModelCommentConnection';
  items?: Maybe<Array<Maybe<Comment>>>;
  nextToken?: Maybe<Scalars['String']>;
};

export type ContentRegistrationCode = {
  __typename?: 'ContentRegistrationCode';
  id: Scalars['ID'];
  sk: Scalars['String'];
  workspaceId: Scalars['String'];
  schemaVersion: Scalars['String'];
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  tags?: Maybe<Array<Tag>>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
  allowFilter?: Maybe<Scalars['AWSJSON']>;
  appId?: Maybe<Scalars['String']>;
  appKey?: Maybe<Scalars['String']>;
  expiresAt?: Maybe<Scalars['AWSDateTime']>;
  name?: Maybe<Scalars['String']>;
  isDisabled?: Maybe<Scalars['Boolean']>;
  courseIds?: Maybe<Array<Scalars['String']>>;
};

export type CreateContentRegistrationCodeInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
  workspaceId: Scalars['String'];
  schemaVersion: Scalars['String'];
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  tags?: Maybe<Array<TagInput>>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
  allowFilter?: Maybe<Scalars['AWSJSON']>;
  appId?: Maybe<Scalars['String']>;
  appKey?: Maybe<Scalars['String']>;
  expiresAt?: Maybe<Scalars['AWSDateTime']>;
  name?: Maybe<Scalars['String']>;
  isDisabled?: Maybe<Scalars['Boolean']>;
  courseIds?: Maybe<Array<Scalars['String']>>;
};

export type UpdateContentRegistrationCodeInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
  workspaceId: Scalars['String'];
  schemaVersion?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  tags?: Maybe<Array<TagInput>>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
  allowFilter?: Maybe<Scalars['AWSJSON']>;
  appId?: Maybe<Scalars['String']>;
  appKey?: Maybe<Scalars['String']>;
  expiresAt?: Maybe<Scalars['AWSDateTime']>;
  name?: Maybe<Scalars['String']>;
  isDisabled?: Maybe<Scalars['Boolean']>;
  courseIds?: Maybe<Array<Scalars['String']>>;
};

export type DeleteContentRegistrationCodeInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
};

export type RegisterContentResponse = {
  __typename?: 'RegisterContentResponse';
  success?: Maybe<Scalars['Boolean']>;
  userErrorMessage?: Maybe<Scalars['String']>;
};

export type ContentLicense = {
  __typename?: 'ContentLicense';
  id: Scalars['ID'];
  sk: Scalars['String'];
  workspaceId: Scalars['String'];
  schemaVersion: Scalars['String'];
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  tags?: Maybe<Array<Tag>>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
  appId?: Maybe<Scalars['String']>;
  expiresAt?: Maybe<Scalars['AWSDateTime']>;
  isDisabled?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
};

export type CreateContentLicenseInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
  workspaceId: Scalars['String'];
  schemaVersion: Scalars['String'];
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  tags?: Maybe<Array<TagInput>>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
  appId?: Maybe<Scalars['String']>;
  expiresAt?: Maybe<Scalars['AWSDateTime']>;
  isDisabled?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
};

export type UpdateContentLicenseInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
  workspaceId: Scalars['String'];
  schemaVersion?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  tags?: Maybe<Array<TagInput>>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
  appId?: Maybe<Scalars['String']>;
  expiresAt?: Maybe<Scalars['AWSDateTime']>;
  isDisabled?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
};

export type DeleteContentLicenseInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
};

export type ModelContentLicenseConnection = {
  __typename?: 'ModelContentLicenseConnection';
  items?: Maybe<Array<ContentLicense>>;
  nextToken?: Maybe<Scalars['String']>;
};

export type Course = {
  __typename?: 'Course';
  id: Scalars['ID'];
  sk: Scalars['String'];
  workspaceId: Scalars['String'];
  schemaVersion: Scalars['String'];
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  tags?: Maybe<Array<Tag>>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
  creator?: Maybe<User>;
  creatorId?: Maybe<Scalars['String']>;
  author?: Maybe<Scalars['String']>;
  bankId?: Maybe<Scalars['String']>;
  checksum?: Maybe<Scalars['String']>;
  copyrightYear?: Maybe<Scalars['String']>;
  courseIds?: Maybe<Array<Scalars['String']>>;
  description?: Maybe<Scalars['String']>;
  grade?: Maybe<Array<Scalars['String']>>;
  idInc?: Maybe<Scalars['String']>;
  idVendor?: Maybe<Scalars['String']>;
  isbn?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isUnlisted?: Maybe<Scalars['Boolean']>;
  keywords?: Maybe<Array<Scalars['String']>>;
  language?: Maybe<Array<Scalars['String']>>;
  maturity?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  sequence?: Maybe<Scalars['String']>;
  subject?: Maybe<Array<Scalars['String']>>;
  type?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['Int']>;
  visibility?: Maybe<ResourceVisibilityType>;
  alignmentScopes?: Maybe<Array<Scalars['String']>>;
  coverImage?: Maybe<S3Object>;
  duration?: Maybe<Scalars['String']>;
  numberLabel?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  resources?: Maybe<Array<ResourcesItem>>;
  resourcesIds?: Maybe<Array<GenericReferenceId>>;
  units?: Maybe<Array<CourseUnit>>;
  unitIds?: Maybe<Array<GenericReferenceId>>;
};

export type CreateCourseInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
  workspaceId: Scalars['String'];
  schemaVersion: Scalars['String'];
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  tags?: Maybe<Array<TagInput>>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
  creatorId?: Maybe<Scalars['String']>;
  author?: Maybe<Scalars['String']>;
  bankId?: Maybe<Scalars['String']>;
  checksum?: Maybe<Scalars['String']>;
  copyrightYear?: Maybe<Scalars['String']>;
  courseIds?: Maybe<Array<Scalars['String']>>;
  description?: Maybe<Scalars['String']>;
  grade?: Maybe<Array<Scalars['String']>>;
  idInc?: Maybe<Scalars['String']>;
  idVendor?: Maybe<Scalars['String']>;
  isbn?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isUnlisted?: Maybe<Scalars['Boolean']>;
  keywords?: Maybe<Array<Scalars['String']>>;
  language?: Maybe<Array<Scalars['String']>>;
  maturity?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  sequence?: Maybe<Scalars['String']>;
  subject?: Maybe<Array<Scalars['String']>>;
  type?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['Int']>;
  visibility?: Maybe<ResourceVisibilityType>;
  alignmentScopes?: Maybe<Array<Scalars['String']>>;
  coverImage?: Maybe<S3ObjectInput>;
  duration?: Maybe<Scalars['String']>;
  numberLabel?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  resourcesIds?: Maybe<Array<GenericReferenceIdInput>>;
  unitIds?: Maybe<Array<GenericReferenceIdInput>>;
};

export type UpdateCourseInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
  workspaceId: Scalars['String'];
  schemaVersion?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  tags?: Maybe<Array<TagInput>>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
  creatorId?: Maybe<Scalars['String']>;
  author?: Maybe<Scalars['String']>;
  bankId?: Maybe<Scalars['String']>;
  checksum?: Maybe<Scalars['String']>;
  copyrightYear?: Maybe<Scalars['String']>;
  courseIds?: Maybe<Array<Scalars['String']>>;
  description?: Maybe<Scalars['String']>;
  grade?: Maybe<Array<Scalars['String']>>;
  idInc?: Maybe<Scalars['String']>;
  idVendor?: Maybe<Scalars['String']>;
  isbn?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isUnlisted?: Maybe<Scalars['Boolean']>;
  keywords?: Maybe<Array<Scalars['String']>>;
  language?: Maybe<Array<Scalars['String']>>;
  maturity?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  sequence?: Maybe<Scalars['String']>;
  subject?: Maybe<Array<Scalars['String']>>;
  type?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['Int']>;
  visibility?: Maybe<ResourceVisibilityType>;
  alignmentScopes?: Maybe<Array<Scalars['String']>>;
  coverImage?: Maybe<S3ObjectInput>;
  duration?: Maybe<Scalars['String']>;
  numberLabel?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  resourcesIds?: Maybe<Array<GenericReferenceIdInput>>;
  unitIds?: Maybe<Array<GenericReferenceIdInput>>;
};

export type DeleteCourseInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
};

export type CourseUnit = {
  __typename?: 'CourseUnit';
  id: Scalars['ID'];
  sk: Scalars['String'];
  data?: Maybe<Scalars['AWSJSON']>;
  unit?: Maybe<Unit>;
  tags?: Maybe<Array<Tag>>;
};

export type UnitLayoutBucket = {
  __typename?: 'UnitLayoutBucket';
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  unitIds?: Maybe<Array<GenericReferenceId>>;
};

export type UnitLayoutBucketInput = {
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  unitIds?: Maybe<Array<GenericReferenceIdInput>>;
};

export type UnitLayout = {
  __typename?: 'UnitLayout';
  id: Scalars['ID'];
  sk: Scalars['String'];
  workspaceId: Scalars['String'];
  schemaVersion: Scalars['String'];
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  tags?: Maybe<Array<Tag>>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
  creator?: Maybe<User>;
  creatorId?: Maybe<Scalars['String']>;
  author?: Maybe<Scalars['String']>;
  bankId?: Maybe<Scalars['String']>;
  checksum?: Maybe<Scalars['String']>;
  copyrightYear?: Maybe<Scalars['String']>;
  courseIds?: Maybe<Array<Scalars['String']>>;
  description?: Maybe<Scalars['String']>;
  grade?: Maybe<Array<Scalars['String']>>;
  idInc?: Maybe<Scalars['String']>;
  idVendor?: Maybe<Scalars['String']>;
  isbn?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isUnlisted?: Maybe<Scalars['Boolean']>;
  keywords?: Maybe<Array<Scalars['String']>>;
  language?: Maybe<Array<Scalars['String']>>;
  maturity?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  sequence?: Maybe<Scalars['String']>;
  subject?: Maybe<Array<Scalars['String']>>;
  type?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['Int']>;
  visibility?: Maybe<ResourceVisibilityType>;
  buckets?: Maybe<Array<UnitLayoutBucket>>;
};

export type CreateUnitLayoutInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
  workspaceId: Scalars['String'];
  schemaVersion: Scalars['String'];
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  tags?: Maybe<Array<TagInput>>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
  creatorId?: Maybe<Scalars['String']>;
  author?: Maybe<Scalars['String']>;
  bankId?: Maybe<Scalars['String']>;
  checksum?: Maybe<Scalars['String']>;
  copyrightYear?: Maybe<Scalars['String']>;
  courseIds?: Maybe<Array<Scalars['String']>>;
  description?: Maybe<Scalars['String']>;
  grade?: Maybe<Array<Scalars['String']>>;
  idInc?: Maybe<Scalars['String']>;
  idVendor?: Maybe<Scalars['String']>;
  isbn?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isUnlisted?: Maybe<Scalars['Boolean']>;
  keywords?: Maybe<Array<Scalars['String']>>;
  language?: Maybe<Array<Scalars['String']>>;
  maturity?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  sequence?: Maybe<Scalars['String']>;
  subject?: Maybe<Array<Scalars['String']>>;
  type?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['Int']>;
  visibility?: Maybe<ResourceVisibilityType>;
  buckets?: Maybe<Array<UnitLayoutBucketInput>>;
};

export type UpdateUnitLayoutInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
  workspaceId: Scalars['String'];
  schemaVersion?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  tags?: Maybe<Array<TagInput>>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
  creatorId?: Maybe<Scalars['String']>;
  author?: Maybe<Scalars['String']>;
  bankId?: Maybe<Scalars['String']>;
  checksum?: Maybe<Scalars['String']>;
  copyrightYear?: Maybe<Scalars['String']>;
  courseIds?: Maybe<Array<Scalars['String']>>;
  description?: Maybe<Scalars['String']>;
  grade?: Maybe<Array<Scalars['String']>>;
  idInc?: Maybe<Scalars['String']>;
  idVendor?: Maybe<Scalars['String']>;
  isbn?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isUnlisted?: Maybe<Scalars['Boolean']>;
  keywords?: Maybe<Array<Scalars['String']>>;
  language?: Maybe<Array<Scalars['String']>>;
  maturity?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  sequence?: Maybe<Scalars['String']>;
  subject?: Maybe<Array<Scalars['String']>>;
  type?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['Int']>;
  visibility?: Maybe<ResourceVisibilityType>;
  buckets?: Maybe<Array<UnitLayoutBucketInput>>;
};

export type DeleteUnitLayoutInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
};

export type UnitLayoutConnection = {
  __typename?: 'UnitLayoutConnection';
  items?: Maybe<Array<UnitLayout>>;
  nextToken?: Maybe<Scalars['String']>;
};

export type ObjectivesView = {
  __typename?: 'ObjectivesView';
  id: Scalars['ID'];
  sk: Scalars['String'];
  workspaceId: Scalars['String'];
  schemaVersion: Scalars['String'];
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  tags?: Maybe<Array<Tag>>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
  creator?: Maybe<User>;
  creatorId?: Maybe<Scalars['String']>;
  author?: Maybe<Scalars['String']>;
  bankId?: Maybe<Scalars['String']>;
  checksum?: Maybe<Scalars['String']>;
  copyrightYear?: Maybe<Scalars['String']>;
  courseIds?: Maybe<Array<Scalars['String']>>;
  description?: Maybe<Scalars['String']>;
  grade?: Maybe<Array<Scalars['String']>>;
  idInc?: Maybe<Scalars['String']>;
  idVendor?: Maybe<Scalars['String']>;
  isbn?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isUnlisted?: Maybe<Scalars['Boolean']>;
  keywords?: Maybe<Array<Scalars['String']>>;
  language?: Maybe<Array<Scalars['String']>>;
  maturity?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  sequence?: Maybe<Scalars['String']>;
  subject?: Maybe<Array<Scalars['String']>>;
  type?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['Int']>;
  visibility?: Maybe<ResourceVisibilityType>;
  objectiveScope: Array<Scalars['String']>;
  data?: Maybe<Scalars['AWSJSON']>;
};

export type CreateObjectivesViewInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
  workspaceId: Scalars['String'];
  schemaVersion: Scalars['String'];
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  tags?: Maybe<Array<TagInput>>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
  creatorId?: Maybe<Scalars['String']>;
  author?: Maybe<Scalars['String']>;
  bankId?: Maybe<Scalars['String']>;
  checksum?: Maybe<Scalars['String']>;
  copyrightYear?: Maybe<Scalars['String']>;
  courseIds?: Maybe<Array<Scalars['String']>>;
  description?: Maybe<Scalars['String']>;
  grade?: Maybe<Array<Scalars['String']>>;
  idInc?: Maybe<Scalars['String']>;
  idVendor?: Maybe<Scalars['String']>;
  isbn?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isUnlisted?: Maybe<Scalars['Boolean']>;
  keywords?: Maybe<Array<Scalars['String']>>;
  language?: Maybe<Array<Scalars['String']>>;
  maturity?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  sequence?: Maybe<Scalars['String']>;
  subject?: Maybe<Array<Scalars['String']>>;
  type?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['Int']>;
  visibility?: Maybe<ResourceVisibilityType>;
  objectiveScope: Array<Scalars['String']>;
  data?: Maybe<Scalars['AWSJSON']>;
};

export type UpdateObjectivesViewInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
  workspaceId: Scalars['String'];
  schemaVersion?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  tags?: Maybe<Array<TagInput>>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
  creatorId?: Maybe<Scalars['String']>;
  author?: Maybe<Scalars['String']>;
  bankId?: Maybe<Scalars['String']>;
  checksum?: Maybe<Scalars['String']>;
  copyrightYear?: Maybe<Scalars['String']>;
  courseIds?: Maybe<Array<Scalars['String']>>;
  description?: Maybe<Scalars['String']>;
  grade?: Maybe<Array<Scalars['String']>>;
  idInc?: Maybe<Scalars['String']>;
  idVendor?: Maybe<Scalars['String']>;
  isbn?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isUnlisted?: Maybe<Scalars['Boolean']>;
  keywords?: Maybe<Array<Scalars['String']>>;
  language?: Maybe<Array<Scalars['String']>>;
  maturity?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  sequence?: Maybe<Scalars['String']>;
  subject?: Maybe<Array<Scalars['String']>>;
  type?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['Int']>;
  visibility?: Maybe<ResourceVisibilityType>;
  objectiveScope?: Maybe<Array<Scalars['String']>>;
  data?: Maybe<Scalars['AWSJSON']>;
};

export type DeleteObjectivesViewInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
};

export type Unit = {
  __typename?: 'Unit';
  id: Scalars['ID'];
  sk: Scalars['String'];
  workspaceId: Scalars['String'];
  schemaVersion: Scalars['String'];
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  tags?: Maybe<Array<Tag>>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
  creator?: Maybe<User>;
  creatorId?: Maybe<Scalars['String']>;
  author?: Maybe<Scalars['String']>;
  bankId?: Maybe<Scalars['String']>;
  checksum?: Maybe<Scalars['String']>;
  copyrightYear?: Maybe<Scalars['String']>;
  courseIds?: Maybe<Array<Scalars['String']>>;
  description?: Maybe<Scalars['String']>;
  grade?: Maybe<Array<Scalars['String']>>;
  idInc?: Maybe<Scalars['String']>;
  idVendor?: Maybe<Scalars['String']>;
  isbn?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isUnlisted?: Maybe<Scalars['Boolean']>;
  keywords?: Maybe<Array<Scalars['String']>>;
  language?: Maybe<Array<Scalars['String']>>;
  maturity?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  sequence?: Maybe<Scalars['String']>;
  subject?: Maybe<Array<Scalars['String']>>;
  type?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['Int']>;
  visibility?: Maybe<ResourceVisibilityType>;
  activitiesIds?: Maybe<Array<GenericReferenceId>>;
  course?: Maybe<Course>;
  courseId?: Maybe<Scalars['String']>;
  coverImage?: Maybe<S3Object>;
  data?: Maybe<Scalars['AWSJSON']>;
  isUserFavorite?: Maybe<Scalars['Boolean']>;
  numberLabel?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  objectives?: Maybe<Array<ObjectivesItem>>;
  objectivesIds?: Maybe<Array<GenericReferenceId>>;
  resources?: Maybe<Array<ResourcesItem>>;
  resourcesIds?: Maybe<Array<GenericReferenceId>>;
  subUnits?: Maybe<Array<SubUnit>>;
  vocabularies?: Maybe<Array<VocabularyItem>>;
  vocabulariesIds?: Maybe<Array<GenericReferenceId>>;
};

export type CreateUnitInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
  workspaceId: Scalars['String'];
  schemaVersion: Scalars['String'];
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  tags?: Maybe<Array<TagInput>>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
  creatorId?: Maybe<Scalars['String']>;
  author?: Maybe<Scalars['String']>;
  bankId?: Maybe<Scalars['String']>;
  checksum?: Maybe<Scalars['String']>;
  copyrightYear?: Maybe<Scalars['String']>;
  courseIds?: Maybe<Array<Scalars['String']>>;
  description?: Maybe<Scalars['String']>;
  grade?: Maybe<Array<Scalars['String']>>;
  idInc?: Maybe<Scalars['String']>;
  idVendor?: Maybe<Scalars['String']>;
  isbn?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isUnlisted?: Maybe<Scalars['Boolean']>;
  keywords?: Maybe<Array<Scalars['String']>>;
  language?: Maybe<Array<Scalars['String']>>;
  maturity?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  sequence?: Maybe<Scalars['String']>;
  subject?: Maybe<Array<Scalars['String']>>;
  type?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['Int']>;
  visibility?: Maybe<ResourceVisibilityType>;
  activitiesIds?: Maybe<Array<GenericReferenceIdInput>>;
  courseId?: Maybe<Scalars['String']>;
  coverImage?: Maybe<S3ObjectInput>;
  data?: Maybe<Scalars['AWSJSON']>;
  numberLabel?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  objectivesIds?: Maybe<Array<GenericReferenceIdInput>>;
  resourcesIds?: Maybe<Array<GenericReferenceIdInput>>;
  subUnits?: Maybe<Array<SubUnitInput>>;
  vocabulariesIds?: Maybe<Array<GenericReferenceIdInput>>;
};

export type UpdateUnitInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
  workspaceId: Scalars['String'];
  schemaVersion?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  tags?: Maybe<Array<TagInput>>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
  creatorId?: Maybe<Scalars['String']>;
  author?: Maybe<Scalars['String']>;
  bankId?: Maybe<Scalars['String']>;
  checksum?: Maybe<Scalars['String']>;
  copyrightYear?: Maybe<Scalars['String']>;
  courseIds?: Maybe<Array<Scalars['String']>>;
  description?: Maybe<Scalars['String']>;
  grade?: Maybe<Array<Scalars['String']>>;
  idInc?: Maybe<Scalars['String']>;
  idVendor?: Maybe<Scalars['String']>;
  isbn?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isUnlisted?: Maybe<Scalars['Boolean']>;
  keywords?: Maybe<Array<Scalars['String']>>;
  language?: Maybe<Array<Scalars['String']>>;
  maturity?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  sequence?: Maybe<Scalars['String']>;
  subject?: Maybe<Array<Scalars['String']>>;
  type?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['Int']>;
  visibility?: Maybe<ResourceVisibilityType>;
  activitiesIds?: Maybe<Array<GenericReferenceIdInput>>;
  courseId?: Maybe<Scalars['String']>;
  coverImage?: Maybe<S3ObjectInput>;
  data?: Maybe<Scalars['AWSJSON']>;
  numberLabel?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  objectivesIds?: Maybe<Array<GenericReferenceIdInput>>;
  resourcesIds?: Maybe<Array<GenericReferenceIdInput>>;
  subUnits?: Maybe<Array<SubUnitInput>>;
  vocabulariesIds?: Maybe<Array<GenericReferenceIdInput>>;
};

export type DeleteUnitInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
};

export type SubUnit = {
  __typename?: 'SubUnit';
  id: Scalars['String'];
  activitiesIds?: Maybe<Array<GenericReferenceId>>;
  coverImage?: Maybe<S3Object>;
  data?: Maybe<Scalars['AWSJSON']>;
  description?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  numberLabel?: Maybe<Scalars['String']>;
  objectives?: Maybe<Array<ObjectivesItem>>;
  objectivesIds?: Maybe<Array<GenericReferenceId>>;
  resources?: Maybe<Array<ResourcesItem>>;
  resourcesIds?: Maybe<Array<GenericReferenceId>>;
  vocabularies?: Maybe<Array<VocabularyItem>>;
  vocabulariesIds?: Maybe<Array<GenericReferenceId>>;
};

export type SubUnitInput = {
  id: Scalars['String'];
  activitiesIds?: Maybe<Array<GenericReferenceIdInput>>;
  coverImage?: Maybe<S3ObjectInput>;
  data?: Maybe<Scalars['AWSJSON']>;
  description?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  numberLabel?: Maybe<Scalars['String']>;
  resourcesIds?: Maybe<Array<GenericReferenceIdInput>>;
  objectivesIds?: Maybe<Array<GenericReferenceIdInput>>;
  vocabulariesIds?: Maybe<Array<GenericReferenceIdInput>>;
};

export type ResourcesItem = {
  __typename?: 'ResourcesItem';
  id: Scalars['ID'];
  sk: Scalars['String'];
  data?: Maybe<Scalars['AWSJSON']>;
  resource?: Maybe<Resource>;
  tags?: Maybe<Array<Tag>>;
};

export type ObjectivesItem = {
  __typename?: 'ObjectivesItem';
  id: Scalars['ID'];
  sk: Scalars['String'];
  data?: Maybe<Scalars['AWSJSON']>;
  objective?: Maybe<Objective>;
  tags?: Maybe<Array<Tag>>;
};

export type VocabularyItem = {
  __typename?: 'VocabularyItem';
  id: Scalars['ID'];
  sk: Scalars['String'];
  data?: Maybe<Scalars['AWSJSON']>;
  tags?: Maybe<Array<Tag>>;
  vocabulary?: Maybe<Vocabulary>;
};

export type VocabularyItems = {
  __typename?: 'VocabularyItems';
  items?: Maybe<Array<VocabularyItem>>;
};

export type RevisionNote = {
  __typename?: 'RevisionNote';
  id: Scalars['ID'];
  sk: Scalars['String'];
  workspaceId: Scalars['String'];
  schemaVersion: Scalars['String'];
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  tags?: Maybe<Array<Tag>>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
  author?: Maybe<Scalars['String']>;
  bankId?: Maybe<Scalars['String']>;
  checksum?: Maybe<Scalars['String']>;
  copyrightYear?: Maybe<Scalars['String']>;
  courseIds?: Maybe<Array<Scalars['String']>>;
  description?: Maybe<Scalars['String']>;
  grade?: Maybe<Array<Scalars['String']>>;
  idInc?: Maybe<Scalars['String']>;
  idVendor?: Maybe<Scalars['String']>;
  isbn?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isUnlisted?: Maybe<Scalars['Boolean']>;
  keywords?: Maybe<Array<Scalars['String']>>;
  language?: Maybe<Array<Scalars['String']>>;
  maturity?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  sequence?: Maybe<Scalars['String']>;
  subject?: Maybe<Array<Scalars['String']>>;
  type?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['Int']>;
  visibility?: Maybe<ResourceVisibilityType>;
  resourceId?: Maybe<Scalars['String']>;
  resource?: Maybe<Resource>;
  creator?: Maybe<User>;
  creatorId?: Maybe<Scalars['String']>;
};

export type CreateRevisionNoteInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
  workspaceId: Scalars['String'];
  schemaVersion: Scalars['String'];
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  tags?: Maybe<Array<TagInput>>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
  author?: Maybe<Scalars['String']>;
  bankId?: Maybe<Scalars['String']>;
  checksum?: Maybe<Scalars['String']>;
  copyrightYear?: Maybe<Scalars['String']>;
  courseIds?: Maybe<Array<Scalars['String']>>;
  description?: Maybe<Scalars['String']>;
  grade?: Maybe<Array<Scalars['String']>>;
  idInc?: Maybe<Scalars['String']>;
  idVendor?: Maybe<Scalars['String']>;
  isbn?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isUnlisted?: Maybe<Scalars['Boolean']>;
  keywords?: Maybe<Array<Scalars['String']>>;
  language?: Maybe<Array<Scalars['String']>>;
  maturity?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  sequence?: Maybe<Scalars['String']>;
  subject?: Maybe<Array<Scalars['String']>>;
  type?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['Int']>;
  visibility?: Maybe<ResourceVisibilityType>;
  resourceId?: Maybe<Scalars['String']>;
  creatorId?: Maybe<Scalars['String']>;
};

export type UpdateRevisionNoteInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
  workspaceId: Scalars['String'];
  schemaVersion?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  tags?: Maybe<Array<TagInput>>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
  author?: Maybe<Scalars['String']>;
  bankId?: Maybe<Scalars['String']>;
  checksum?: Maybe<Scalars['String']>;
  copyrightYear?: Maybe<Scalars['String']>;
  courseIds?: Maybe<Array<Scalars['String']>>;
  description?: Maybe<Scalars['String']>;
  grade?: Maybe<Array<Scalars['String']>>;
  idInc?: Maybe<Scalars['String']>;
  idVendor?: Maybe<Scalars['String']>;
  isbn?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isUnlisted?: Maybe<Scalars['Boolean']>;
  keywords?: Maybe<Array<Scalars['String']>>;
  language?: Maybe<Array<Scalars['String']>>;
  maturity?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  sequence?: Maybe<Scalars['String']>;
  subject?: Maybe<Array<Scalars['String']>>;
  type?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['Int']>;
  visibility?: Maybe<ResourceVisibilityType>;
  resourceId?: Maybe<Scalars['String']>;
  creatorId?: Maybe<Scalars['String']>;
};

export type DeleteRevisionNoteInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
};

export type Vocabulary = {
  __typename?: 'Vocabulary';
  id: Scalars['ID'];
  sk: Scalars['String'];
  schemaVersion: Scalars['String'];
  workspaceId: Scalars['String'];
  bankId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  description?: Maybe<Scalars['String']>;
  grade?: Maybe<Array<Scalars['String']>>;
  language?: Maybe<Array<Scalars['String']>>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  subject?: Maybe<Array<Scalars['String']>>;
  tags?: Maybe<Array<Tag>>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
  usages?: Maybe<VocabularyUsage>;
};

export type VocabularyUsage = {
  __typename?: 'VocabularyUsage';
  count: Scalars['Int'];
  items: Array<VocabularyUsageItem>;
};

export type VocabularyUsageItem = {
  __typename?: 'VocabularyUsageItem';
  id: Scalars['ID'];
  sk: Scalars['String'];
  tags?: Maybe<Array<Tag>>;
  item?: Maybe<Unit>;
};

export type CreateVocabularyInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
  workspaceId: Scalars['String'];
  schemaVersion: Scalars['String'];
  name: Scalars['String'];
  bankId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  description?: Maybe<Scalars['String']>;
  grade?: Maybe<Array<Scalars['String']>>;
  language?: Maybe<Array<Scalars['String']>>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  subject?: Maybe<Array<Scalars['String']>>;
  tags?: Maybe<Array<TagInput>>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
};

export type UpdateVocabularyInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
  workspaceId: Scalars['String'];
  schemaVersion?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  bankId?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  grade?: Maybe<Array<Scalars['String']>>;
  language?: Maybe<Array<Scalars['String']>>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  subject?: Maybe<Array<Scalars['String']>>;
  tags?: Maybe<Array<TagInput>>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
};

export type DeleteVocabularyInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
};

export type SearchableVocabularyConnection = {
  __typename?: 'SearchableVocabularyConnection';
  items?: Maybe<Array<Maybe<Vocabulary>>>;
  nextToken?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Int']>;
  aggregations?: Maybe<SearchAggregations>;
};

export type Event = {
  __typename?: 'Event';
  id: Scalars['ID'];
  sk: Scalars['String'];
  type: Scalars['String'];
  sender?: Maybe<Scalars['String']>;
  payload?: Maybe<Scalars['String']>;
  actorUserId?: Maybe<Scalars['String']>;
  actorUser?: Maybe<User>;
  actorWorkspaceId?: Maybe<Scalars['String']>;
  actorWorkspace?: Maybe<Workspace>;
  workspaceId?: Maybe<Scalars['String']>;
  actorUserIdWorkspaceId?: Maybe<Scalars['String']>;
  refResourceIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  refResources?: Maybe<Array<Maybe<Resource>>>;
  refJobIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  refJobs?: Maybe<Array<Maybe<Job>>>;
  refCollaborationIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  refCollaborations?: Maybe<Array<Maybe<Collaboration>>>;
  refUserIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  refUsers?: Maybe<Array<Maybe<User>>>;
  meta?: Maybe<Scalars['AWSJSON']>;
  requestArguments?: Maybe<Scalars['AWSJSON']>;
  requestIdentity?: Maybe<Scalars['AWSJSON']>;
  requestSourceIp?: Maybe<Scalars['String']>;
  targetResourceIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  broadcast?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
};

export type CreateEventForUserInput = {
  id?: Maybe<Scalars['ID']>;
  sk: Scalars['String'];
  type: Scalars['String'];
  sender?: Maybe<Scalars['String']>;
  payload?: Maybe<Scalars['String']>;
  actorUserId?: Maybe<Scalars['String']>;
  actorWorkspaceId?: Maybe<Scalars['String']>;
  workspaceId?: Maybe<Scalars['String']>;
  refResourceIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  refJobIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  refCollaborationIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  refUserIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  meta?: Maybe<Scalars['AWSJSON']>;
  broadcast?: Maybe<Scalars['Boolean']>;
  targetResourceIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
};

export type ExamSession = {
  __typename?: 'ExamSession';
  id: Scalars['ID'];
  sk: Scalars['String'];
  workspaceId: Scalars['String'];
  schemaVersion: Scalars['String'];
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  tags?: Maybe<Array<Tag>>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
  currentAttemptNumber?: Maybe<Scalars['Int']>;
  scoredAttemptNumber?: Maybe<Scalars['Int']>;
  examSessionResponses?: Maybe<Scalars['AWSJSON']>;
  examSessionResults?: Maybe<Scalars['AWSJSON']>;
  examSessionData?: Maybe<ExamSessionData>;
  config?: Maybe<Scalars['AWSJSON']>;
  imageUrl?: Maybe<Scalars['String']>;
  maturity?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  examConfigId: Scalars['ID'];
  examId?: Maybe<Scalars['String']>;
  scoreMin?: Maybe<Scalars['Float']>;
  scoreMax?: Maybe<Scalars['Float']>;
  scoreActual?: Maybe<Scalars['Float']>;
  examPosition?: Maybe<ExamPosition>;
  isActive?: Maybe<Scalars['Boolean']>;
};

export type DeleteExamSessionInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
};

export type ExamAttempt = {
  __typename?: 'ExamAttempt';
  id: Scalars['ID'];
  sk: Scalars['String'];
  workspaceId: Scalars['String'];
  schemaVersion: Scalars['String'];
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  tags?: Maybe<Array<Tag>>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
  examSessionResponses?: Maybe<Scalars['AWSJSON']>;
  examSessionResults?: Maybe<Scalars['AWSJSON']>;
  examPosition?: Maybe<ExamPosition>;
  examBlobs?: Maybe<Scalars['AWSJSON']>;
  highlights?: Maybe<Scalars['AWSJSON']>;
  source: Scalars['String'];
  examSessionId: Scalars['ID'];
  attemptNumber: Scalars['Int'];
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSubmitted?: Maybe<Scalars['Boolean']>;
};

export type CreateExamAttemptInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
  workspaceId: Scalars['String'];
  schemaVersion: Scalars['String'];
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  tags?: Maybe<Array<TagInput>>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
  examSessionResponses?: Maybe<Scalars['AWSJSON']>;
  examSessionResults?: Maybe<Scalars['AWSJSON']>;
  examPosition?: Maybe<ExamPositionInput>;
  examBlobs?: Maybe<Scalars['AWSJSON']>;
  highlights?: Maybe<Scalars['AWSJSON']>;
  source: Scalars['String'];
  examSessionId: Scalars['ID'];
  attemptNumber: Scalars['Int'];
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSubmitted?: Maybe<Scalars['Boolean']>;
};

export type UpdateExamAttemptInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
  workspaceId: Scalars['String'];
  schemaVersion?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  tags?: Maybe<Array<TagInput>>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
  examSessionResponses?: Maybe<Scalars['AWSJSON']>;
  examSessionResults?: Maybe<Scalars['AWSJSON']>;
  examPosition?: Maybe<ExamPositionInput>;
  examBlobs?: Maybe<Scalars['AWSJSON']>;
  highlights?: Maybe<Scalars['AWSJSON']>;
  source?: Maybe<Scalars['String']>;
  examSessionId?: Maybe<Scalars['ID']>;
  attemptNumber?: Maybe<Scalars['Int']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSubmitted?: Maybe<Scalars['Boolean']>;
};

export type DeleteExamAttemptInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
};

export type CreateExamSessionInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
  schemaVersion: Scalars['String'];
  workspaceId: Scalars['String'];
  tags?: Maybe<Array<TagInput>>;
  maturity?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  examConfigId: Scalars['ID'];
  currentAttemptNumber?: Maybe<Scalars['Int']>;
  scoredAttemptNumber?: Maybe<Scalars['Int']>;
  examSessionResponses?: Maybe<Scalars['AWSJSON']>;
  examSessionResults?: Maybe<Scalars['AWSJSON']>;
  examSessionData?: Maybe<ExamSessionDataInput>;
  config?: Maybe<Scalars['AWSJSON']>;
  scoreMin?: Maybe<Scalars['Float']>;
  scoreMax?: Maybe<Scalars['Float']>;
  scoreActual?: Maybe<Scalars['Float']>;
};

export type UpdateExamSessionInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
  tags?: Maybe<Array<TagInput>>;
  name?: Maybe<Scalars['String']>;
  examConfigId?: Maybe<Scalars['ID']>;
  maturity?: Maybe<Scalars['String']>;
  currentAttemptNumber?: Maybe<Scalars['Int']>;
  scoredAttemptNumber?: Maybe<Scalars['Int']>;
  examPosition?: Maybe<ExamPositionInput>;
  examSessionResponses?: Maybe<Scalars['AWSJSON']>;
  examSessionResults?: Maybe<Scalars['AWSJSON']>;
  examSessionData?: Maybe<ExamSessionDataInput>;
  config?: Maybe<Scalars['AWSJSON']>;
  scoreMin?: Maybe<Scalars['Float']>;
  scoreMax?: Maybe<Scalars['Float']>;
  scoreActual?: Maybe<Scalars['Float']>;
  isActive?: Maybe<Scalars['Boolean']>;
};

export type ListExamAttemptsInput = {
  sk: Scalars['String'];
};

export type ModelExamAttemptConnection = {
  __typename?: 'ModelExamAttemptConnection';
  items?: Maybe<Array<ExamAttempt>>;
  nextToken?: Maybe<Scalars['String']>;
};

export type UserErrorMessage = {
  __typename?: 'UserErrorMessage';
  message?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type SubmittedExamToken = {
  __typename?: 'SubmittedExamToken';
  token?: Maybe<Scalars['String']>;
  userErrorMessage?: Maybe<UserErrorMessage>;
};

export type Subscription = {
  __typename?: 'Subscription';
  onCreateSystemEvent?: Maybe<SystemEvent>;
  onCreateUser?: Maybe<User>;
  onCreateUserNotificationRecord?: Maybe<User>;
  onSendWorkspaceUpdate?: Maybe<WorkspaceUpdate>;
  onSendWorkspaceUpdateById?: Maybe<WorkspaceUpdate>;
  onSendWorkspaceUpdateByIdSk?: Maybe<WorkspaceUpdate>;
  onUpdateExamSession?: Maybe<ExamSession>;
  onUserNotification?: Maybe<User>;
  root?: Maybe<Scalars['String']>;
};


export type SubscriptionOnCreateUserArgs = {
  id?: Maybe<Scalars['ID']>;
  sk?: Maybe<Scalars['ID']>;
};


export type SubscriptionOnCreateUserNotificationRecordArgs = {
  id?: Maybe<Scalars['ID']>;
  sk?: Maybe<Scalars['ID']>;
};


export type SubscriptionOnSendWorkspaceUpdateByIdArgs = {
  id?: Maybe<Scalars['ID']>;
};


export type SubscriptionOnSendWorkspaceUpdateByIdSkArgs = {
  id?: Maybe<Scalars['ID']>;
  sk?: Maybe<Scalars['String']>;
};


export type SubscriptionOnUpdateExamSessionArgs = {
  id?: Maybe<Scalars['ID']>;
  examConfigId?: Maybe<Scalars['ID']>;
};

export enum DocumentPrintMode {
  Normal = 'NORMAL',
  Binding = 'BINDING'
}

export type PrintExamInput = {
  examId: Scalars['String'];
  theme: Scalars['String'];
  workspace: Scalars['String'];
  copyrightYear: Scalars['String'];
  date: Scalars['String'];
  username: Scalars['String'];
  coverPage?: Maybe<Scalars['Boolean']>;
  answerKey: Scalars['Boolean'];
  workspaceId: Scalars['String'];
  dualColumn: Scalars['Boolean'];
  publisherName?: Maybe<Scalars['String']>;
  shouldShuffleItemOrder?: Maybe<Scalars['Boolean']>;
  shuffleSeed?: Maybe<Scalars['String']>;
};

export type PrintVerificationDocumentInput = {
  courseId: Scalars['String'];
  username: Scalars['String'];
  workspaceId: Scalars['String'];
};

export type PrintYearAtaGlanceInput = {
  courseId: Scalars['String'];
  username: Scalars['String'];
  workspaceId: Scalars['String'];
  showStandardsInGroups: Scalars['Boolean'];
  weeks?: Maybe<Scalars['String']>;
  calendarId?: Maybe<Scalars['String']>;
  workspace: Scalars['String'];
  copyrightYear: Scalars['String'];
  date: Scalars['String'];
};

export type PrintPerformanceAssessmentInput = {
  performanceAssessmentId: Scalars['String'];
  username: Scalars['String'];
  workspace: Scalars['String'];
  copyrightYear: Scalars['String'];
  date: Scalars['String'];
  showStandards: Scalars['Boolean'];
};

export type ExportDocumentResponse = ExportDocumentSuccessResponse | ExportDocumentErrorResponse;

export type ExportDocumentSuccessResponse = {
  __typename?: 'ExportDocumentSuccessResponse';
  resultUrl: Scalars['String'];
  packageUrl: Scalars['String'];
};

export type ExportDocumentErrorResponse = {
  __typename?: 'ExportDocumentErrorResponse';
  error: Scalars['String'];
  packageUrl: Scalars['String'];
  log?: Maybe<Scalars['String']>;
};

export type SubmitFeedbackInput = {
  appId: Scalars['String'];
  subject: Scalars['String'];
  feedback: Scalars['String'];
  userEmail: Scalars['String'];
  additionalData?: Maybe<Scalars['AWSJSON']>;
};

export type SubmitFeedbackResponse = SubmitFeedbackSuccessResponse | SubmitFeedbackErrorResponse;

export type SubmitFeedbackSuccessResponse = {
  __typename?: 'SubmitFeedbackSuccessResponse';
  message: Scalars['String'];
};

export type SubmitFeedbackErrorResponse = {
  __typename?: 'SubmitFeedbackErrorResponse';
  error: Scalars['String'];
};

export type CreateItemInput = {
  id?: Maybe<Scalars['ID']>;
  sk: Scalars['String'];
  workspaceId?: Maybe<Scalars['String']>;
  schemaVersion: Scalars['String'];
  alignmentIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  author?: Maybe<Scalars['String']>;
  bankId?: Maybe<Scalars['String']>;
  blooms?: Maybe<Array<Maybe<Scalars['String']>>>;
  content?: Maybe<ResourceContentInput>;
  contextIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  copyright?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  creatorId?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  difficulty?: Maybe<Scalars['String']>;
  dok?: Maybe<Array<Maybe<Scalars['String']>>>;
  excerpt?: Maybe<Scalars['String']>;
  flesch?: Maybe<Scalars['Float']>;
  grade?: Maybe<Array<Maybe<Scalars['String']>>>;
  idInc?: Maybe<Scalars['String']>;
  idVendor?: Maybe<Scalars['String']>;
  interaction?: Maybe<Array<Maybe<Scalars['String']>>>;
  language?: Maybe<Array<Maybe<Scalars['String']>>>;
  lexile?: Maybe<Scalars['Int']>;
  lexileMax?: Maybe<Scalars['Int']>;
  lexileMin?: Maybe<Scalars['Int']>;
  maturity?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  originBankId?: Maybe<Scalars['String']>;
  originIdInc?: Maybe<Scalars['String']>;
  originResourceId?: Maybe<Scalars['String']>;
  originWorkspaceId?: Maybe<Scalars['String']>;
  parccTextComplexity?: Maybe<Scalars['String']>;
  resourceId?: Maybe<Scalars['String']>;
  rmm?: Maybe<Scalars['Float']>;
  scoringMethod?: Maybe<Scalars['String']>;
  subject?: Maybe<Array<Maybe<Scalars['String']>>>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
  version?: Maybe<Scalars['Int']>;
  visibility?: Maybe<ResourceVisibilityType>;
  wordCount?: Maybe<Scalars['Int']>;
};

export type DeleteItemInput = {
  workspaceId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  sk: Scalars['String'];
};

export type Job = {
  __typename?: 'Job';
  id: Scalars['ID'];
  sk: Scalars['String'];
  type: JobType;
  name?: Maybe<Scalars['String']>;
  data?: Maybe<Scalars['String']>;
  params?: Maybe<Scalars['AWSJSON']>;
  status?: Maybe<JobStatus>;
  creatorId?: Maybe<Scalars['String']>;
  creator?: Maybe<User>;
  workspaceId?: Maybe<Scalars['String']>;
  parentJobId?: Maybe<Scalars['String']>;
  parentJob?: Maybe<Job>;
  outputFile?: Maybe<S3Object>;
  percentComplete?: Maybe<Scalars['Float']>;
  jobPartCount?: Maybe<Scalars['Int']>;
  jobPartCompleteCount?: Maybe<Scalars['Int']>;
  jobPartCompleteSuccessCount?: Maybe<Scalars['Int']>;
  jobPartCompleteFailureCount?: Maybe<Scalars['Int']>;
  concurrencyGroup?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['AWSDateTime']>;
  completedAt?: Maybe<Scalars['AWSDateTime']>;
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
};

export enum JobStatus {
  Pending = 'PENDING',
  InProgress = 'IN_PROGRESS',
  Success = 'SUCCESS',
  Failure = 'FAILURE',
  Cancelled = 'CANCELLED',
  CompleteSuccess = 'COMPLETE_SUCCESS',
  CompleteFailure = 'COMPLETE_FAILURE',
  Rejected = 'REJECTED'
}

export enum JobType {
  DeleteBank = 'DELETE_BANK',
  ExportAppUsage = 'EXPORT_APP_USAGE',
  ExportAppUsers = 'EXPORT_APP_USERS',
  ExportContent = 'EXPORT_CONTENT',
  ExportContentAlignments = 'EXPORT_CONTENT_ALIGNMENTS',
  ExportContentMetadata = 'EXPORT_CONTENT_METADATA',
  ExportExamQti = 'EXPORT_EXAM_QTI',
  ExportObjectiveItemCounts = 'EXPORT_OBJECTIVE_ITEM_COUNTS',
  ExportPassageMetadata = 'EXPORT_PASSAGE_METADATA',
  ImportContent = 'IMPORT_CONTENT',
  ImportContentMetadata = 'IMPORT_CONTENT_METADATA',
  MergeBanks = 'MERGE_BANKS',
  PublishContent = 'PUBLISH_CONTENT',
  TaskItemReport = 'TASK_ITEM_REPORT',
  ValidateContent = 'VALIDATE_CONTENT',
  RebuildLicense = 'REBUILD_LICENSE',
  TestJob = 'TEST_JOB'
}

export enum JobExportContentFormat {
  ImsQtiV2P0 = 'IMS_QTI_V2P0',
  ImsQtiV2P1 = 'IMS_QTI_V2P1',
  ImsQtiV2P1Legacy = 'IMS_QTI_V2P1_LEGACY',
  ImsQtiV2P2 = 'IMS_QTI_V2P2',
  ImsQtiV3P0 = 'IMS_QTI_V3P0'
}

export enum JobImportImportFormat {
  ImsQtiV2P0 = 'IMS_QTI_V2P0',
  ImsQtiV2P1 = 'IMS_QTI_V2P1',
  ImsQtiV2P2 = 'IMS_QTI_V2P2',
  ImsQtiV3P0 = 'IMS_QTI_V3P0'
}

export type PerformanceTask = {
  __typename?: 'PerformanceTask';
  id: Scalars['ID'];
  sk: Scalars['String'];
  workspaceId: Scalars['String'];
  schemaVersion: Scalars['String'];
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  tags?: Maybe<Array<Tag>>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
  author?: Maybe<Scalars['String']>;
  bankId?: Maybe<Scalars['String']>;
  checksum?: Maybe<Scalars['String']>;
  copyrightYear?: Maybe<Scalars['String']>;
  courseIds?: Maybe<Array<Scalars['String']>>;
  description?: Maybe<Scalars['String']>;
  grade?: Maybe<Array<Scalars['String']>>;
  idInc?: Maybe<Scalars['String']>;
  idVendor?: Maybe<Scalars['String']>;
  isbn?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isUnlisted?: Maybe<Scalars['Boolean']>;
  keywords?: Maybe<Array<Scalars['String']>>;
  language?: Maybe<Array<Scalars['String']>>;
  maturity?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  sequence?: Maybe<Scalars['String']>;
  subject?: Maybe<Array<Scalars['String']>>;
  type?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['Int']>;
  visibility?: Maybe<ResourceVisibilityType>;
  creator?: Maybe<User>;
  creatorId?: Maybe<Scalars['String']>;
  objectives?: Maybe<Array<ObjectivesItem>>;
  objectivesIds?: Maybe<Array<GenericReferenceId>>;
  content?: Maybe<ResourceContent>;
  rubrics?: Maybe<Array<PerformanceTaskRubric>>;
  rubricIds?: Maybe<Array<GenericReferenceId>>;
  resources?: Maybe<Array<ResourcesItem>>;
  resourcesIds?: Maybe<Array<GenericReferenceId>>;
};

export type CreatePerformanceTaskInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
  workspaceId: Scalars['String'];
  schemaVersion: Scalars['String'];
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  tags?: Maybe<Array<TagInput>>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
  author?: Maybe<Scalars['String']>;
  bankId?: Maybe<Scalars['String']>;
  checksum?: Maybe<Scalars['String']>;
  copyrightYear?: Maybe<Scalars['String']>;
  courseIds?: Maybe<Array<Scalars['String']>>;
  description?: Maybe<Scalars['String']>;
  grade?: Maybe<Array<Scalars['String']>>;
  idInc?: Maybe<Scalars['String']>;
  idVendor?: Maybe<Scalars['String']>;
  isbn?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isUnlisted?: Maybe<Scalars['Boolean']>;
  keywords?: Maybe<Array<Scalars['String']>>;
  language?: Maybe<Array<Scalars['String']>>;
  maturity?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  sequence?: Maybe<Scalars['String']>;
  subject?: Maybe<Array<Scalars['String']>>;
  type?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['Int']>;
  visibility?: Maybe<ResourceVisibilityType>;
  creatorId?: Maybe<Scalars['String']>;
  objectivesIds?: Maybe<Array<GenericReferenceIdInput>>;
  content?: Maybe<ResourceContentInput>;
  rubricIds?: Maybe<Array<GenericReferenceIdInput>>;
  resourcesIds?: Maybe<Array<GenericReferenceIdInput>>;
};

export type UpdatePerformanceTaskInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
  workspaceId: Scalars['String'];
  schemaVersion?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  tags?: Maybe<Array<TagInput>>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
  author?: Maybe<Scalars['String']>;
  bankId?: Maybe<Scalars['String']>;
  checksum?: Maybe<Scalars['String']>;
  copyrightYear?: Maybe<Scalars['String']>;
  courseIds?: Maybe<Array<Scalars['String']>>;
  description?: Maybe<Scalars['String']>;
  grade?: Maybe<Array<Scalars['String']>>;
  idInc?: Maybe<Scalars['String']>;
  idVendor?: Maybe<Scalars['String']>;
  isbn?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isUnlisted?: Maybe<Scalars['Boolean']>;
  keywords?: Maybe<Array<Scalars['String']>>;
  language?: Maybe<Array<Scalars['String']>>;
  maturity?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  sequence?: Maybe<Scalars['String']>;
  subject?: Maybe<Array<Scalars['String']>>;
  type?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['Int']>;
  visibility?: Maybe<ResourceVisibilityType>;
  creatorId?: Maybe<Scalars['String']>;
  objectivesIds?: Maybe<Array<GenericReferenceIdInput>>;
  content?: Maybe<ResourceContentInput>;
  rubricIds?: Maybe<Array<GenericReferenceIdInput>>;
  resourcesIds?: Maybe<Array<GenericReferenceIdInput>>;
};

export type DeletePerformanceTaskInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
};

export type PerformanceTaskRubric = {
  __typename?: 'PerformanceTaskRubric';
  id: Scalars['ID'];
  sk: Scalars['String'];
  data?: Maybe<Scalars['AWSJSON']>;
  rubric?: Maybe<Rubric>;
  tags?: Maybe<Array<Tag>>;
};

export type Rubric = {
  __typename?: 'Rubric';
  id: Scalars['ID'];
  sk: Scalars['String'];
  workspaceId: Scalars['String'];
  schemaVersion: Scalars['String'];
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  tags?: Maybe<Array<Tag>>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
  author?: Maybe<Scalars['String']>;
  bankId?: Maybe<Scalars['String']>;
  checksum?: Maybe<Scalars['String']>;
  copyrightYear?: Maybe<Scalars['String']>;
  courseIds?: Maybe<Array<Scalars['String']>>;
  description?: Maybe<Scalars['String']>;
  grade?: Maybe<Array<Scalars['String']>>;
  idInc?: Maybe<Scalars['String']>;
  idVendor?: Maybe<Scalars['String']>;
  isbn?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isUnlisted?: Maybe<Scalars['Boolean']>;
  keywords?: Maybe<Array<Scalars['String']>>;
  language?: Maybe<Array<Scalars['String']>>;
  maturity?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  sequence?: Maybe<Scalars['String']>;
  subject?: Maybe<Array<Scalars['String']>>;
  type?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['Int']>;
  visibility?: Maybe<ResourceVisibilityType>;
  creator?: Maybe<User>;
  creatorId?: Maybe<Scalars['String']>;
  content?: Maybe<ResourceContent>;
};

export type CreateRubricInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
  workspaceId: Scalars['String'];
  schemaVersion: Scalars['String'];
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  tags?: Maybe<Array<TagInput>>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
  author?: Maybe<Scalars['String']>;
  bankId?: Maybe<Scalars['String']>;
  checksum?: Maybe<Scalars['String']>;
  copyrightYear?: Maybe<Scalars['String']>;
  courseIds?: Maybe<Array<Scalars['String']>>;
  description?: Maybe<Scalars['String']>;
  grade?: Maybe<Array<Scalars['String']>>;
  idInc?: Maybe<Scalars['String']>;
  idVendor?: Maybe<Scalars['String']>;
  isbn?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isUnlisted?: Maybe<Scalars['Boolean']>;
  keywords?: Maybe<Array<Scalars['String']>>;
  language?: Maybe<Array<Scalars['String']>>;
  maturity?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  sequence?: Maybe<Scalars['String']>;
  subject?: Maybe<Array<Scalars['String']>>;
  type?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['Int']>;
  visibility?: Maybe<ResourceVisibilityType>;
  creatorId?: Maybe<Scalars['String']>;
  content?: Maybe<ResourceContentInput>;
};

export type UpdateRubricInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
  workspaceId: Scalars['String'];
  schemaVersion?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  tags?: Maybe<Array<TagInput>>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
  author?: Maybe<Scalars['String']>;
  bankId?: Maybe<Scalars['String']>;
  checksum?: Maybe<Scalars['String']>;
  copyrightYear?: Maybe<Scalars['String']>;
  courseIds?: Maybe<Array<Scalars['String']>>;
  description?: Maybe<Scalars['String']>;
  grade?: Maybe<Array<Scalars['String']>>;
  idInc?: Maybe<Scalars['String']>;
  idVendor?: Maybe<Scalars['String']>;
  isbn?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isUnlisted?: Maybe<Scalars['Boolean']>;
  keywords?: Maybe<Array<Scalars['String']>>;
  language?: Maybe<Array<Scalars['String']>>;
  maturity?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  sequence?: Maybe<Scalars['String']>;
  subject?: Maybe<Array<Scalars['String']>>;
  type?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['Int']>;
  visibility?: Maybe<ResourceVisibilityType>;
  creatorId?: Maybe<Scalars['String']>;
  content?: Maybe<ResourceContentInput>;
};

export type DeleteRubricInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
};

export type WebDocument = {
  __typename?: 'WebDocument';
  id: Scalars['ID'];
  sk: Scalars['String'];
  workspaceId: Scalars['String'];
  schemaVersion: Scalars['String'];
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  tags?: Maybe<Array<Tag>>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
  author?: Maybe<Scalars['String']>;
  bankId?: Maybe<Scalars['String']>;
  checksum?: Maybe<Scalars['String']>;
  copyrightYear?: Maybe<Scalars['String']>;
  courseIds?: Maybe<Array<Scalars['String']>>;
  description?: Maybe<Scalars['String']>;
  grade?: Maybe<Array<Scalars['String']>>;
  idInc?: Maybe<Scalars['String']>;
  idVendor?: Maybe<Scalars['String']>;
  isbn?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isUnlisted?: Maybe<Scalars['Boolean']>;
  keywords?: Maybe<Array<Scalars['String']>>;
  language?: Maybe<Array<Scalars['String']>>;
  maturity?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  sequence?: Maybe<Scalars['String']>;
  subject?: Maybe<Array<Scalars['String']>>;
  type?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['Int']>;
  visibility?: Maybe<ResourceVisibilityType>;
  creator?: Maybe<User>;
  creatorId?: Maybe<Scalars['String']>;
  content?: Maybe<ResourceContent>;
  resources?: Maybe<Array<ResourcesItem>>;
  resourcesIds?: Maybe<Array<GenericReferenceId>>;
};

export type CreateWebDocumentInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
  workspaceId: Scalars['String'];
  schemaVersion: Scalars['String'];
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  tags?: Maybe<Array<TagInput>>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
  author?: Maybe<Scalars['String']>;
  bankId?: Maybe<Scalars['String']>;
  checksum?: Maybe<Scalars['String']>;
  copyrightYear?: Maybe<Scalars['String']>;
  courseIds?: Maybe<Array<Scalars['String']>>;
  description?: Maybe<Scalars['String']>;
  grade?: Maybe<Array<Scalars['String']>>;
  idInc?: Maybe<Scalars['String']>;
  idVendor?: Maybe<Scalars['String']>;
  isbn?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isUnlisted?: Maybe<Scalars['Boolean']>;
  keywords?: Maybe<Array<Scalars['String']>>;
  language?: Maybe<Array<Scalars['String']>>;
  maturity?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  sequence?: Maybe<Scalars['String']>;
  subject?: Maybe<Array<Scalars['String']>>;
  type?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['Int']>;
  visibility?: Maybe<ResourceVisibilityType>;
  creatorId?: Maybe<Scalars['String']>;
  content?: Maybe<ResourceContentInput>;
  resourcesIds?: Maybe<Array<GenericReferenceIdInput>>;
};

export type UpdateWebDocumentInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
  workspaceId: Scalars['String'];
  schemaVersion?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  tags?: Maybe<Array<TagInput>>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
  author?: Maybe<Scalars['String']>;
  bankId?: Maybe<Scalars['String']>;
  checksum?: Maybe<Scalars['String']>;
  copyrightYear?: Maybe<Scalars['String']>;
  courseIds?: Maybe<Array<Scalars['String']>>;
  description?: Maybe<Scalars['String']>;
  grade?: Maybe<Array<Scalars['String']>>;
  idInc?: Maybe<Scalars['String']>;
  idVendor?: Maybe<Scalars['String']>;
  isbn?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isUnlisted?: Maybe<Scalars['Boolean']>;
  keywords?: Maybe<Array<Scalars['String']>>;
  language?: Maybe<Array<Scalars['String']>>;
  maturity?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  sequence?: Maybe<Scalars['String']>;
  subject?: Maybe<Array<Scalars['String']>>;
  type?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['Int']>;
  visibility?: Maybe<ResourceVisibilityType>;
  creatorId?: Maybe<Scalars['String']>;
  content?: Maybe<ResourceContentInput>;
  resourcesIds?: Maybe<Array<GenericReferenceIdInput>>;
};

export type DeleteWebDocumentInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
};

export type Objective = {
  __typename?: 'Objective';
  id: Scalars['ID'];
  sk: Scalars['String'];
  guid?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  content?: Maybe<Scalars['String']>;
  /** @deprecated Use `outlineNumber` field */
  numRaw?: Maybe<Scalars['String']>;
  /** @deprecated Use `abbreviation` field */
  numEnhanced?: Maybe<Scalars['String']>;
  outlineNumber?: Maybe<Scalars['String']>;
  abbreviation?: Maybe<Scalars['String']>;
  sequence?: Maybe<Scalars['Int']>;
  idAuthority?: Maybe<Scalars['String']>;
  idPublisher?: Maybe<Scalars['String']>;
  parentId?: Maybe<Scalars['String']>;
  scope?: Maybe<Scalars['String']>;
  isAlignable?: Maybe<Scalars['Boolean']>;
  isObsolete?: Maybe<Scalars['Boolean']>;
  objectiveTree?: Maybe<Scalars['AWSJSON']>;
  workflowStatus?: Maybe<Scalars['String']>;
  versionCurrent?: Maybe<Scalars['Int']>;
  versionNext?: Maybe<Scalars['Int']>;
  versionLabel?: Maybe<Scalars['String']>;
  documentId?: Maybe<Scalars['String']>;
  document?: Maybe<Objective>;
  authorityId?: Maybe<Scalars['String']>;
  authority?: Maybe<Objective>;
  publicationId?: Maybe<Scalars['String']>;
  publication?: Maybe<Objective>;
  notes?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Tag>>;
  keywords?: Maybe<Array<Maybe<ObjectiveKeyword>>>;
  annotations?: Maybe<Array<ObjectiveAnnotation>>;
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
};

export type ObjectiveAnnotation = {
  __typename?: 'ObjectiveAnnotation';
  label?: Maybe<Scalars['String']>;
  content?: Maybe<Scalars['String']>;
};

export type ObjectiveKeyword = {
  __typename?: 'ObjectiveKeyword';
  label?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type InvokeObjectiveInput = {
  workspaceId?: Maybe<Scalars['String']>;
  action?: Maybe<Scalars['String']>;
  payload?: Maybe<Scalars['AWSJSON']>;
};

export type ModelObjectiveConnection = {
  __typename?: 'ModelObjectiveConnection';
  items?: Maybe<Array<Objective>>;
  nextToken?: Maybe<Scalars['String']>;
};

export type AddCollectionItemInput = {
  id: Scalars['String'];
  sk: Scalars['String'];
  resourceId: Scalars['String'];
  workspaceId: Scalars['String'];
};

export type RemoveCollectionItemInput = {
  id: Scalars['String'];
  sk: Scalars['String'];
  resourceId: Scalars['String'];
  workspaceId: Scalars['String'];
};

export type CreateAssetInput = {
  id?: Maybe<Scalars['ID']>;
  sk: Scalars['String'];
  schemaVersion: Scalars['String'];
  workspaceId: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  creatorId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
};

export type UpdateAssetInput = {
  id?: Maybe<Scalars['ID']>;
  sk: Scalars['String'];
  workspaceId: Scalars['String'];
  schemaVersion?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  creatorId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
};

export type DeleteAssetInput = {
  id?: Maybe<Scalars['ID']>;
  sk: Scalars['String'];
  workspaceId: Scalars['String'];
};

export type PresignedUrlResponse = {
  __typename?: 'PresignedUrlResponse';
  questionId?: Maybe<Scalars['String']>;
  interactionId?: Maybe<Scalars['String']>;
  blobId?: Maybe<Scalars['String']>;
  presignedUrl?: Maybe<Scalars['String']>;
};

export type Resource = {
  __typename?: 'Resource';
  actor?: Maybe<User>;
  actorId?: Maybe<Scalars['String']>;
  alignmentCount?: Maybe<Scalars['Int']>;
  alignmentIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  alignmentScopes?: Maybe<Array<Scalars['String']>>;
  alignments?: Maybe<Array<Maybe<Objective>>>;
  answerDistribution?: Maybe<Array<Maybe<Scalars['String']>>>;
  appExpiresAt?: Maybe<Scalars['AWSDateTime']>;
  appId?: Maybe<Scalars['String']>;
  appKey?: Maybe<Scalars['String']>;
  appSecret?: Maybe<Scalars['String']>;
  assetIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  assets?: Maybe<Array<Maybe<Resource>>>;
  assignee?: Maybe<User>;
  assigneeId?: Maybe<Scalars['String']>;
  author?: Maybe<Scalars['String']>;
  bank?: Maybe<Workspace>;
  bankId?: Maybe<Scalars['String']>;
  blooms?: Maybe<Array<Maybe<Scalars['String']>>>;
  blueprint?: Maybe<Scalars['AWSJSON']>;
  blueprintIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  blueprintSpecs?: Maybe<Scalars['AWSJSON']>;
  blueprints?: Maybe<Array<Maybe<Resource>>>;
  checksum?: Maybe<Scalars['String']>;
  collectionQuery?: Maybe<Scalars['AWSJSON']>;
  collectionType?: Maybe<ResourceCollectionType>;
  config?: Maybe<Scalars['AWSJSON']>;
  content?: Maybe<ResourceContent>;
  contextIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  contextItems?: Maybe<Array<Maybe<Resource>>>;
  contexts?: Maybe<Array<Maybe<Resource>>>;
  copyright?: Maybe<Scalars['String']>;
  copyrightYear?: Maybe<Scalars['String']>;
  courseIds?: Maybe<Array<Scalars['String']>>;
  coverImage?: Maybe<S3Object>;
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  creator?: Maybe<User>;
  creatorId?: Maybe<Scalars['String']>;
  data?: Maybe<Scalars['AWSJSON']>;
  deletesAt?: Maybe<Scalars['AWSTimestamp']>;
  deliveryMediaType?: Maybe<DeliveryMediaType>;
  description?: Maybe<Scalars['String']>;
  difficulty?: Maybe<Scalars['String']>;
  dimensions?: Maybe<ResourceDimensions>;
  dok?: Maybe<Array<Maybe<Scalars['String']>>>;
  dueAt?: Maybe<Scalars['AWSDateTime']>;
  editor?: Maybe<User>;
  editorId?: Maybe<Scalars['String']>;
  eventLogActorId?: Maybe<Scalars['String']>;
  eventLogChanges?: Maybe<Scalars['AWSJSON']>;
  eventLogNewImage?: Maybe<Scalars['AWSJSON']>;
  eventLogOldImage?: Maybe<Scalars['AWSJSON']>;
  examConfig?: Maybe<Resource>;
  examConfigAverageScore?: Maybe<Scalars['Float']>;
  examConfigData?: Maybe<ExamConfig>;
  examConfigId?: Maybe<Scalars['String']>;
  examConfigStatus?: Maybe<Scalars['String']>;
  examItemAverageScore?: Maybe<Scalars['Float']>;
  examItemLastUsedAt?: Maybe<Scalars['AWSDateTime']>;
  examItemUseCount?: Maybe<Scalars['Int']>;
  examSession?: Maybe<Resource>;
  examSessionData?: Maybe<ExamSessionData>;
  examSessionId?: Maybe<Scalars['String']>;
  examSessionResponseScores?: Maybe<Scalars['AWSJSON']>;
  examSessionResponses?: Maybe<Scalars['AWSJSON']>;
  examSessionResults?: Maybe<Scalars['AWSJSON']>;
  excerpt?: Maybe<Scalars['String']>;
  file?: Maybe<ResourceFile>;
  flesch?: Maybe<Scalars['Float']>;
  fontScaling?: Maybe<Scalars['String']>;
  genres?: Maybe<Array<Maybe<Scalars['String']>>>;
  grade?: Maybe<Array<Maybe<Scalars['String']>>>;
  id: Scalars['ID'];
  idInc?: Maybe<Scalars['String']>;
  idVendor?: Maybe<Scalars['String']>;
  imageHash?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  interaction?: Maybe<Array<Maybe<Scalars['String']>>>;
  interactionCount?: Maybe<Scalars['Int']>;
  isArchived?: Maybe<Scalars['Boolean']>;
  isCreating?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isDisabled?: Maybe<Scalars['Boolean']>;
  isPublished?: Maybe<Scalars['Boolean']>;
  isUnlisted?: Maybe<Scalars['Boolean']>;
  isUserFavorite?: Maybe<Scalars['Boolean']>;
  isUserPurchased?: Maybe<Scalars['Boolean']>;
  isUserRated?: Maybe<Scalars['Boolean']>;
  isUserWatcher?: Maybe<Scalars['Boolean']>;
  isbn?: Maybe<Scalars['String']>;
  issueCount?: Maybe<Scalars['Int']>;
  issueCountUnresolved?: Maybe<Scalars['Int']>;
  issueKey?: Maybe<Scalars['String']>;
  issues?: Maybe<Array<Maybe<Resource>>>;
  itemCount?: Maybe<Scalars['Int']>;
  keywords?: Maybe<Array<Maybe<Scalars['String']>>>;
  language?: Maybe<Array<Maybe<Scalars['String']>>>;
  latestPublishedVersion?: Maybe<Scalars['String']>;
  lexile?: Maybe<Scalars['Int']>;
  lexileMax?: Maybe<Scalars['Int']>;
  lexileMin?: Maybe<Scalars['Int']>;
  maturity?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  numberLabel?: Maybe<Scalars['String']>;
  objectiveMap?: Maybe<ResourceObjectiveMap>;
  objectiveMapSourceScope?: Maybe<Scalars['String']>;
  objectiveMapTargetScope?: Maybe<Scalars['String']>;
  originBankId?: Maybe<Scalars['String']>;
  originIdInc?: Maybe<Scalars['String']>;
  originResourceId?: Maybe<Scalars['String']>;
  originWorkspaceId?: Maybe<Scalars['String']>;
  ownerUserIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  ownerUsers?: Maybe<Array<Maybe<User>>>;
  parccTextComplexity?: Maybe<Scalars['String']>;
  priority?: Maybe<ResourcePriorityEnum>;
  questionIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  questions?: Maybe<Array<Maybe<Resource>>>;
  referencesIds?: Maybe<Array<Scalars['AWSJSON']>>;
  relationship?: Maybe<RelationshipTypeEnum>;
  relatives?: Maybe<Array<Maybe<Resource>>>;
  resolutionAt?: Maybe<Scalars['AWSDateTime']>;
  resolutionText?: Maybe<Scalars['String']>;
  resolutionType?: Maybe<Scalars['String']>;
  resolutionUserId?: Maybe<Scalars['String']>;
  resource?: Maybe<Resource>;
  resourceId?: Maybe<Scalars['String']>;
  resources?: Maybe<Array<Maybe<Resource>>>;
  resourcesIds?: Maybe<Array<GenericReferenceId>>;
  review?: Maybe<Resource>;
  reviewId?: Maybe<Scalars['String']>;
  reviewer?: Maybe<User>;
  reviewerId?: Maybe<Scalars['String']>;
  reviews?: Maybe<Array<Maybe<Resource>>>;
  rmm?: Maybe<Scalars['Float']>;
  schemaVersion: Scalars['String'];
  scoreActual?: Maybe<Scalars['Float']>;
  scoreMax?: Maybe<Scalars['Float']>;
  scoreMin?: Maybe<Scalars['Float']>;
  scoring?: Maybe<Scalars['AWSJSON']>;
  scoringMethod?: Maybe<Scalars['String']>;
  sequence?: Maybe<Scalars['String']>;
  sk: Scalars['String'];
  snapshots?: Maybe<Array<Maybe<Resource>>>;
  stats?: Maybe<Scalars['AWSJSON']>;
  statsAt?: Maybe<Scalars['AWSDateTime']>;
  storeIsEnabled?: Maybe<Scalars['Boolean']>;
  storePrice?: Maybe<Scalars['Int']>;
  storePriceScheme?: Maybe<ResourceStorePriceSchemeType>;
  subject?: Maybe<Array<Maybe<Scalars['String']>>>;
  tags?: Maybe<Array<Maybe<Tag>>>;
  task?: Maybe<Scalars['String']>;
  taskCount?: Maybe<Scalars['Int']>;
  taskCountUnresolved?: Maybe<Scalars['Int']>;
  taskId?: Maybe<Scalars['String']>;
  tasks?: Maybe<Array<Maybe<Resource>>>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
  url?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['Int']>;
  visibility?: Maybe<ResourceVisibilityType>;
  wordCount?: Maybe<Scalars['Int']>;
  workflow?: Maybe<Scalars['AWSJSON']>;
  workflowId?: Maybe<Scalars['String']>;
  workflowStatusId?: Maybe<Scalars['String']>;
  worklogTimeRemaining?: Maybe<Scalars['Int']>;
  worklogTimeSpent?: Maybe<Scalars['Int']>;
  worklogs?: Maybe<Array<Maybe<Resource>>>;
  workspace?: Maybe<Workspace>;
  workspaceId?: Maybe<Scalars['String']>;
};

export type CreateResourceFavoriteInput = {
  id: Scalars['String'];
  sk: Scalars['String'];
  workspaceId: Scalars['String'];
  userId: Scalars['String'];
};

export type DeleteResourceFavoriteInput = {
  id: Scalars['String'];
  sk: Scalars['String'];
  userId: Scalars['String'];
};

export enum DeliveryMediaType {
  PrintOnly = 'PRINT_ONLY',
  PrintAndDigital = 'PRINT_AND_DIGITAL',
  DigitalOnly = 'DIGITAL_ONLY'
}

export enum ResourceCollectionType {
  Standard = 'STANDARD',
  Smart = 'SMART'
}

export enum ResourceStorePriceSchemeType {
  PerStudent = 'PER_STUDENT',
  PerSession = 'PER_SESSION',
  None = 'NONE'
}

export enum ScoringMethodEnum {
  PerQuestion = 'PER_QUESTION',
  Dichotomous = 'DICHOTOMOUS',
  Dependent = 'DEPENDENT',
  CustomTxStaar = 'CUSTOM_TX_STAAR'
}

export type Tag = {
  __typename?: 'Tag';
  key?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export enum ResourcePriorityEnum {
  Info = 'INFO',
  Low = 'LOW',
  Medium = 'MEDIUM',
  High = 'HIGH',
  Critical = 'CRITICAL'
}

export type ResourceElement = {
  __typename?: 'ResourceElement';
  id?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  interactionType?: Maybe<Scalars['String']>;
  content?: Maybe<Scalars['AWSJSON']>;
  config?: Maybe<Scalars['AWSJSON']>;
  scoring?: Maybe<Scalars['AWSJSON']>;
};

export type ResourceContent = {
  __typename?: 'ResourceContent';
  body?: Maybe<Scalars['String']>;
  canvas?: Maybe<Array<Maybe<ResourceElement>>>;
  exemplar?: Maybe<Scalars['String']>;
  forms?: Maybe<Array<Maybe<ResourceExamForm>>>;
  objectiveMatrix?: Maybe<Scalars['AWSJSON']>;
  rubric?: Maybe<Scalars['AWSJSON']>;
};

export type ResourceDimensions = {
  __typename?: 'ResourceDimensions';
  length?: Maybe<Scalars['Int']>;
  width?: Maybe<Scalars['Int']>;
  height?: Maybe<Scalars['Int']>;
  scale?: Maybe<Scalars['String']>;
};

export type ResourceFile = {
  __typename?: 'ResourceFile';
  name?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  bucket?: Maybe<Scalars['String']>;
  key?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Int']>;
  mimetype?: Maybe<Scalars['String']>;
  format?: Maybe<Scalars['String']>;
  extension?: Maybe<Scalars['String']>;
};

export type ResourceExamForm = {
  __typename?: 'ResourceExamForm';
  name?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  config?: Maybe<Scalars['AWSJSON']>;
  sections?: Maybe<Array<Maybe<ResourceExamSection>>>;
};

export type ResourceExamSection = {
  __typename?: 'ResourceExamSection';
  name?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  config?: Maybe<Scalars['AWSJSON']>;
  questionIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ExamPosition = {
  __typename?: 'ExamPosition';
  form: Scalars['Int'];
  section: Scalars['Int'];
  question: Scalars['Int'];
};

export type ModelResourceConnection = {
  __typename?: 'ModelResourceConnection';
  items?: Maybe<Array<Resource>>;
  nextToken?: Maybe<Scalars['String']>;
};

export type ListResourcesByIdThenSkInput = {
  id?: Maybe<Scalars['ID']>;
  sk?: Maybe<ModelStringKeyConditionInput>;
  workspaceId: Scalars['String'];
  filter?: Maybe<ModelWorkspaceFilterInput>;
  limit?: Maybe<Scalars['Int']>;
  nextToken?: Maybe<Scalars['String']>;
  sortDirection?: Maybe<ModelSortDirection>;
};

export type ListResourcesByWorkspaceIdInput = {
  workspaceId?: Maybe<Scalars['ID']>;
  id?: Maybe<ModelStringKeyConditionInput>;
  filter?: Maybe<ModelWorkspaceFilterInput>;
  limit?: Maybe<Scalars['Int']>;
  nextToken?: Maybe<Scalars['String']>;
  sortDirection?: Maybe<ModelSortDirection>;
};

export type ListResourcesByWorkspaceIdThenSkInput = {
  workspaceId?: Maybe<Scalars['ID']>;
  sk?: Maybe<ModelStringKeyConditionInput>;
  filter?: Maybe<ModelWorkspaceFilterInput>;
  limit?: Maybe<Scalars['Int']>;
  nextToken?: Maybe<Scalars['String']>;
  sortDirection?: Maybe<ModelSortDirection>;
};

export type ResourceObjectiveMap = {
  __typename?: 'ResourceObjectiveMap';
  sourceObjective?: Maybe<Scalars['String']>;
  targetObjective?: Maybe<Scalars['String']>;
};

export type DeleteUserResourceInput = {
  workspaceId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  sk: Scalars['String'];
};

export type DeleteResourceInput = {
  id?: Maybe<Scalars['ID']>;
  sk: Scalars['String'];
  workspaceId: Scalars['String'];
};

export type ExamSessionData = {
  __typename?: 'ExamSessionData';
  lti?: Maybe<ExamSessionLti>;
  studentId?: Maybe<Scalars['String']>;
  accessKey?: Maybe<Scalars['String']>;
  examId?: Maybe<Scalars['String']>;
  examConfigId?: Maybe<Scalars['String']>;
  responses?: Maybe<Scalars['AWSJSON']>;
};

export type ExamSessionLti = {
  __typename?: 'ExamSessionLti';
  assignmentId?: Maybe<Scalars['String']>;
  contextId?: Maybe<Scalars['String']>;
  contextLabel?: Maybe<Scalars['String']>;
  contextTitle?: Maybe<Scalars['String']>;
  courseId?: Maybe<Scalars['String']>;
  domain?: Maybe<Scalars['String']>;
  outcomeUrl?: Maybe<Scalars['String']>;
  sourcedId?: Maybe<Scalars['String']>;
  toolConsumerGuid?: Maybe<Scalars['String']>;
  toolConsumerName?: Maybe<Scalars['String']>;
  toolConsumerProductCode?: Maybe<Scalars['String']>;
  toolConsumerVersion?: Maybe<Scalars['String']>;
  product?: Maybe<Scalars['String']>;
  uniqueUserId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
  consumerKey?: Maybe<Scalars['String']>;
  agsAllowedScopes?: Maybe<Array<Maybe<Scalars['String']>>>;
  agsLineItemUrl?: Maybe<Scalars['String']>;
  agsLineItemsUrl?: Maybe<Scalars['String']>;
  toolClientId?: Maybe<Scalars['String']>;
  toolIssuer?: Maybe<Scalars['String']>;
};

export type ExamConfig = {
  __typename?: 'ExamConfig';
  foo?: Maybe<Scalars['String']>;
};

export type CreateExamConfigInput = {
  id?: Maybe<Scalars['ID']>;
  sk: Scalars['String'];
  schemaVersion: Scalars['String'];
  workspaceId: Scalars['String'];
  resourceId: Scalars['String'];
};

export enum ResourceVisibilityType {
  Private = 'PRIVATE',
  Workspace = 'WORKSPACE',
  WorkspaceShareable = 'WORKSPACE_SHAREABLE'
}

export type CreateIssueInput = {
  id?: Maybe<Scalars['ID']>;
  sk: Scalars['String'];
  schemaVersion: Scalars['String'];
  workspaceId: Scalars['String'];
  creatorId?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  maturity: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  priority: ResourcePriorityEnum;
  resourceId?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type UpdateIssueInput = {
  id?: Maybe<Scalars['ID']>;
  sk: Scalars['String'];
  schemaVersion?: Maybe<Scalars['String']>;
  workspaceId: Scalars['String'];
  creatorId?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  maturity?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  priority?: Maybe<ResourcePriorityEnum>;
  resourceId?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type DeleteIssueInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
  workspaceId: Scalars['String'];
};

export type ResourceRelative = {
  __typename?: 'ResourceRelative';
  id?: Maybe<Scalars['String']>;
  sk?: Maybe<Scalars['String']>;
  type?: Maybe<RelationshipTypeEnum>;
};

export enum RelationshipTypeEnum {
  AlternateChild = 'ALTERNATE_CHILD',
  AlternateParent = 'ALTERNATE_PARENT',
  Enemy = 'ENEMY',
  Suggestion = 'SUGGESTION',
  TranslationChild = 'TRANSLATION_CHILD',
  TranslationParent = 'TRANSLATION_PARENT'
}

export type CreateResourceRelativeInput = {
  src: Scalars['String'];
  dst: Scalars['String'];
  type: Scalars['String'];
  workspaceId: Scalars['String'];
};

export type DeleteResourceRelativeInput = {
  src: Scalars['String'];
  dst: Scalars['String'];
};

export type CreateReviewInput = {
  id?: Maybe<Scalars['ID']>;
  sk: Scalars['String'];
  workspaceId: Scalars['String'];
  creatorId: Scalars['String'];
  maturity?: Maybe<Scalars['String']>;
};

export type UpdateReviewInput = {
  id?: Maybe<Scalars['ID']>;
  sk: Scalars['String'];
  workspaceId: Scalars['String'];
  maturity?: Maybe<Scalars['String']>;
};

export type DeleteReviewInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
  workspaceId: Scalars['String'];
};

export type CreateSnapshotInput = {
  id?: Maybe<Scalars['ID']>;
  sk: Scalars['String'];
  schemaVersion: Scalars['String'];
  workspaceId: Scalars['String'];
  name: Scalars['String'];
};

export type DeleteSnapshotInput = {
  id?: Maybe<Scalars['ID']>;
  sk: Scalars['String'];
  workspaceId: Scalars['String'];
};

export type RestoreSnapshotInput = {
  id?: Maybe<Scalars['ID']>;
  sk: Scalars['String'];
  workspaceId: Scalars['String'];
};

export type CreateResourcePurchase = {
  __typename?: 'CreateResourcePurchase';
  id: Scalars['String'];
  sk: Scalars['String'];
  createdAt: Scalars['AWSDateTime'];
};

export type CreateResourceRating = {
  __typename?: 'CreateResourceRating';
  id: Scalars['String'];
  sk: Scalars['String'];
  createdAt: Scalars['AWSDateTime'];
};

export type CreateResourcePurchaseInput = {
  workspaceId: Scalars['String'];
  userId: Scalars['String'];
  resourceId: Scalars['String'];
  resourceSk: Scalars['String'];
};

export type DeleteResourcePurchaseInput = {
  workspaceId: Scalars['String'];
  userId: Scalars['String'];
  resourceId: Scalars['String'];
  resourceSk: Scalars['String'];
  createdAt: Scalars['String'];
};

export type CreateResourceRatingInput = {
  workspaceId: Scalars['String'];
  userId: Scalars['String'];
  resourceId: Scalars['String'];
  resourceSk: Scalars['String'];
  body: Scalars['String'];
  rating: Scalars['Int'];
};

export type DeleteResourceRatingInput = {
  workspaceId: Scalars['String'];
  userId: Scalars['String'];
  resourceId: Scalars['String'];
  resourceSk: Scalars['String'];
  createdAt: Scalars['String'];
};

export type ControllerInput = {
  action: Scalars['String'];
  params?: Maybe<Scalars['AWSJSON']>;
};

export type CreateTaskInput = {
  id?: Maybe<Scalars['ID']>;
  sk: Scalars['String'];
  schemaVersion: Scalars['String'];
  workspaceId: Scalars['String'];
  type: Scalars['String'];
  maturity: Scalars['String'];
  assigneeId?: Maybe<Scalars['String']>;
  config?: Maybe<Scalars['AWSJSON']>;
  creatorId?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  dueAt?: Maybe<Scalars['AWSDateTime']>;
  name?: Maybe<Scalars['String']>;
  priority: ResourcePriorityEnum;
  resourceId?: Maybe<Scalars['String']>;
  reviewerId?: Maybe<Scalars['String']>;
  workflow?: Maybe<Scalars['AWSJSON']>;
};

export type UpdateTaskInput = {
  id?: Maybe<Scalars['ID']>;
  sk: Scalars['String'];
  schemaVersion: Scalars['String'];
  workspaceId: Scalars['String'];
  assigneeId?: Maybe<Scalars['String']>;
  config?: Maybe<Scalars['AWSJSON']>;
  creatorId?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  dueAt?: Maybe<Scalars['AWSDateTime']>;
  maturity?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  priority?: Maybe<ResourcePriorityEnum>;
  resourceId?: Maybe<Scalars['String']>;
  reviewerId?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  workflow?: Maybe<Scalars['AWSJSON']>;
};

export type DeleteTaskInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
  workspaceId: Scalars['String'];
};

export type TaskToResource = {
  __typename?: 'TaskToResource';
  task?: Maybe<Scalars['String']>;
  resource?: Maybe<Scalars['String']>;
  workspaceId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type TaskToResourceInput = {
  workspaceId: Scalars['String'];
  task?: Maybe<Scalars['String']>;
  resource?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type GetResourceTranslationInput = {
  sourceLanguageCode?: Maybe<Scalars['String']>;
  targetLanguageCode?: Maybe<Scalars['String']>;
  resource?: Maybe<Scalars['AWSJSON']>;
};

export type AttachVendorIdInput = {
  id?: Maybe<Scalars['ID']>;
  sk: Scalars['String'];
  vendorId: Scalars['String'];
  workspaceId: Scalars['String'];
};

export type DetachVendorIdInput = {
  id?: Maybe<Scalars['ID']>;
  sk: Scalars['String'];
  vendorId: Scalars['String'];
  workspaceId: Scalars['String'];
};

export type VersionData = {
  __typename?: 'VersionData';
  id: Scalars['ID'];
  sk: Scalars['String'];
  schemaVersion: Scalars['String'];
  workspaceId?: Maybe<Scalars['String']>;
  draftVersion?: Maybe<Scalars['Int']>;
  publishedVersion?: Maybe<Scalars['Int']>;
  resourceId?: Maybe<Scalars['String']>;
  versionMetadata?: Maybe<Scalars['AWSJSON']>;
};

export type CreateResourceVersionDataInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
  schemaVersion: Scalars['String'];
  workspaceId?: Maybe<Scalars['String']>;
  draftVersion?: Maybe<Scalars['Int']>;
  publishedVersion?: Maybe<Scalars['Int']>;
  resourceId?: Maybe<Scalars['String']>;
  versionMetadata?: Maybe<Scalars['AWSJSON']>;
};

export type UpdateResourceVersionDataInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
  schemaVersion: Scalars['String'];
  workspaceId?: Maybe<Scalars['String']>;
  draftVersion?: Maybe<Scalars['Int']>;
  publishedVersion?: Maybe<Scalars['Int']>;
  resourceId?: Maybe<Scalars['String']>;
  versionMetadata?: Maybe<Scalars['AWSJSON']>;
};

export type ResourceWatcher = {
  __typename?: 'ResourceWatcher';
  id?: Maybe<Scalars['String']>;
  sk?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type CreateResourceWatcherInput = {
  id: Scalars['String'];
  sk: Scalars['String'];
  userId: Scalars['String'];
  workspaceId: Scalars['String'];
};

export type DeleteResourceWatcherInput = {
  id: Scalars['String'];
  sk: Scalars['String'];
  userId: Scalars['String'];
};

export type Workflow = {
  __typename?: 'Workflow';
  foo?: Maybe<Scalars['String']>;
};

export type CreateWorklogInput = {
  id?: Maybe<Scalars['ID']>;
  sk: Scalars['String'];
  schemaVersion: Scalars['String'];
  workspaceId: Scalars['String'];
  worklogTimeSpent: Scalars['Int'];
  worklogTimeRemaining: Scalars['Int'];
  creatorId: Scalars['String'];
};

export type UpdateWorklogInput = {
  id?: Maybe<Scalars['ID']>;
  sk: Scalars['String'];
  workspaceId: Scalars['String'];
  worklogTimeSpent?: Maybe<Scalars['Int']>;
  worklogTimeRemaining?: Maybe<Scalars['Int']>;
  creatorId?: Maybe<Scalars['String']>;
};

export type DeleteWorklogInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
  workspaceId: Scalars['String'];
};

export type Role = {
  __typename?: 'Role';
  id: Scalars['ID'];
  sk: Scalars['String'];
  workspaceId: Scalars['String'];
  schemaVersion: Scalars['String'];
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  tags?: Maybe<Array<Tag>>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
  creator?: Maybe<User>;
  creatorId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
};

export type CreateRoleInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
  workspaceId: Scalars['String'];
  schemaVersion: Scalars['String'];
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  tags?: Maybe<Array<TagInput>>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
  creatorId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
};

export type UpdateRoleInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
  workspaceId: Scalars['String'];
  schemaVersion?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  tags?: Maybe<Array<TagInput>>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
  creatorId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
};

export type DeleteRoleInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
};

export type RolePolicy = {
  __typename?: 'RolePolicy';
  id: Scalars['ID'];
  sk: Scalars['String'];
  workspaceId: Scalars['String'];
  schemaVersion: Scalars['String'];
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  tags?: Maybe<Array<Tag>>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
  creator?: Maybe<User>;
  creatorId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  roleId?: Maybe<Scalars['String']>;
  policyId?: Maybe<Scalars['String']>;
  cedar?: Maybe<RolePolicyCedar>;
};

export type CreateRolePolicyInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
  workspaceId: Scalars['String'];
  schemaVersion: Scalars['String'];
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  tags?: Maybe<Array<TagInput>>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
  creatorId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  roleId?: Maybe<Scalars['String']>;
  policyId?: Maybe<Scalars['String']>;
  cedar?: Maybe<RolePolicyCedarInput>;
};

export type UpdateRolePolicyInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
  workspaceId: Scalars['String'];
  schemaVersion?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  tags?: Maybe<Array<TagInput>>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
  creatorId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  roleId?: Maybe<Scalars['String']>;
  policyId?: Maybe<Scalars['String']>;
  cedar?: Maybe<RolePolicyCedarInput>;
};

export type DeleteRolePolicyInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
};

export type ModelRolePolicyConnection = {
  __typename?: 'ModelRolePolicyConnection';
  items?: Maybe<Array<Maybe<RolePolicy>>>;
  nextToken?: Maybe<Scalars['String']>;
};

export type ListRolePoliciesInput = {
  id?: Maybe<Scalars['String']>;
  nextToken?: Maybe<Scalars['String']>;
};

export type RolePolicyCedar = {
  __typename?: 'RolePolicyCedar';
  effect?: Maybe<Scalars['String']>;
  action?: Maybe<Scalars['String']>;
  resource?: Maybe<Scalars['String']>;
  conditions?: Maybe<Scalars['String']>;
};

export type RolePolicyCedarInput = {
  effect?: Maybe<Scalars['String']>;
  action?: Maybe<Scalars['String']>;
  resource?: Maybe<Scalars['String']>;
  conditions?: Maybe<Scalars['String']>;
};

export type SearchableResourceConnection = {
  __typename?: 'SearchableResourceConnection';
  items?: Maybe<Array<Resource>>;
  nextToken?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Int']>;
  aggregations?: Maybe<SearchAggregations>;
};

export type BulkSearchableResourceConnection = {
  __typename?: 'BulkSearchableResourceConnection';
  items?: Maybe<Scalars['AWSJSON']>;
  nextToken?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Int']>;
  aggregations?: Maybe<SearchAggregations>;
};

export type SearchableResourceConnectionNew = {
  __typename?: 'SearchableResourceConnectionNew';
  items?: Maybe<Array<Resource>>;
  nextToken?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Int']>;
  aggregations?: Maybe<Scalars['AWSJSON']>;
};

export type ResourceAggregates = {
  __typename?: 'ResourceAggregates';
  total?: Maybe<Scalars['Int']>;
  aggregations?: Maybe<SearchAggregations>;
};

export type SearchAggregation = {
  __typename?: 'SearchAggregation';
  key?: Maybe<Scalars['String']>;
  count?: Maybe<Scalars['Int']>;
};

export type SearchAggregations = {
  __typename?: 'SearchAggregations';
  alignmentIds?: Maybe<Array<SearchAggregation>>;
  assetType?: Maybe<Array<SearchAggregation>>;
  bankId?: Maybe<Array<SearchAggregation>>;
  blooms?: Maybe<Array<SearchAggregation>>;
  contextIds?: Maybe<Array<SearchAggregation>>;
  dok?: Maybe<Array<SearchAggregation>>;
  fileExtension?: Maybe<Array<SearchAggregation>>;
  fileMimetype?: Maybe<Array<SearchAggregation>>;
  grade?: Maybe<Array<SearchAggregation>>;
  interaction?: Maybe<Array<SearchAggregation>>;
  keywords?: Maybe<Array<SearchAggregation>>;
  language?: Maybe<Array<SearchAggregation>>;
  maturity?: Maybe<Array<SearchAggregation>>;
  mediaType?: Maybe<Array<SearchAggregation>>;
  objectiveAbbreviation?: Maybe<Array<SearchAggregation>>;
  objectiveAuthority?: Maybe<Array<SearchAggregation>>;
  objectiveDocument?: Maybe<Array<SearchAggregation>>;
  objectiveId?: Maybe<Array<SearchAggregation>>;
  objectiveScope?: Maybe<Array<SearchAggregation>>;
  objectType?: Maybe<Array<SearchAggregation>>;
  subject?: Maybe<Array<SearchAggregation>>;
  tagsKey?: Maybe<Array<SearchAggregation>>;
  tagsKeyValue?: Maybe<Array<SearchAggregation>>;
  tagsValue?: Maybe<Array<SearchAggregation>>;
  type?: Maybe<Array<SearchAggregation>>;
  workspaceId?: Maybe<Array<SearchAggregation>>;
};

export type SearchableResourceFilter = {
  __typename?: 'SearchableResourceFilter';
  id?: Maybe<SearchableIdFilter>;
  alignmentIds?: Maybe<SearchableStringFilter>;
  answerDistribution?: Maybe<SearchableStringFilter>;
  assetIds?: Maybe<SearchableStringFilter>;
  assigneeId?: Maybe<SearchableStringFilter>;
  author?: Maybe<SearchableStringFilter>;
  bankId?: Maybe<SearchableStringFilter>;
  blooms?: Maybe<SearchableStringFilter>;
  checksum?: Maybe<SearchableStringFilter>;
  content?: Maybe<SearchableStringFilter>;
  contextIds?: Maybe<SearchableStringFilter>;
  courseId?: Maybe<SearchableStringFilter>;
  createdAt?: Maybe<SearchableDateFilter>;
  creatorId?: Maybe<SearchableStringFilter>;
  description?: Maybe<SearchableStringFilter>;
  dok?: Maybe<SearchableStringFilter>;
  dueAt?: Maybe<SearchableDateFilter>;
  editorId?: Maybe<SearchableStringFilter>;
  email?: Maybe<SearchableStringFilter>;
  examConfigId?: Maybe<SearchableStringFilter>;
  examItemAverageScore?: Maybe<SearchableFloatFilter>;
  examItemLastUsedAt?: Maybe<SearchableDateFilter>;
  examItemUseCount?: Maybe<SearchableIntFilter>;
  examSessionId?: Maybe<SearchableStringFilter>;
  excerpt?: Maybe<SearchableStringFilter>;
  foo?: Maybe<SearchableStringFilter>;
  genres?: Maybe<SearchableStringFilter>;
  grade?: Maybe<SearchableStringFilter>;
  idInc?: Maybe<SearchableStringFilter>;
  idVendor?: Maybe<SearchableStringFilter>;
  interaction?: Maybe<SearchableStringFilter>;
  interactionCount?: Maybe<SearchableIntFilter>;
  isArchived?: Maybe<SearchableBooleanFilter>;
  isDeleted?: Maybe<SearchableBooleanFilter>;
  isDisabled?: Maybe<SearchableBooleanFilter>;
  isProcessing?: Maybe<SearchableBooleanFilter>;
  isUnlisted?: Maybe<SearchableBooleanFilter>;
  keywords?: Maybe<SearchableStringFilter>;
  language?: Maybe<SearchableStringFilter>;
  maturity?: Maybe<SearchableStringFilter>;
  name?: Maybe<SearchableStringFilter>;
  originResourceId?: Maybe<SearchableStringFilter>;
  questionIds?: Maybe<SearchableStringFilter>;
  resourceId?: Maybe<SearchableStringFilter>;
  reviewerId?: Maybe<SearchableStringFilter>;
  reviews?: Maybe<SearchableStringFilter>;
  schemaVersion?: Maybe<SearchableStringFilter>;
  scoreActual?: Maybe<SearchableFloatFilter>;
  scoreMax?: Maybe<SearchableFloatFilter>;
  scoreMin?: Maybe<SearchableFloatFilter>;
  sequence?: Maybe<SearchableStringFilter>;
  sk?: Maybe<SearchableStringFilter>;
  subject?: Maybe<SearchableStringFilter>;
  tags?: Maybe<SearchableTagFilter>;
  type?: Maybe<SearchableStringFilter>;
  updatedAt?: Maybe<SearchableDateFilter>;
  version?: Maybe<SearchableIntFilter>;
  visibility?: Maybe<SearchableStringFilter>;
  wordCount?: Maybe<SearchableIntFilter>;
  workspaceId?: Maybe<SearchableStringFilter>;
  assetType?: Maybe<SearchableStringFilter>;
  collectionIds?: Maybe<SearchableStringFilter>;
  containsImages?: Maybe<SearchableBooleanFilter>;
  containsMath?: Maybe<SearchableBooleanFilter>;
  favoriteUserIds?: Maybe<SearchableStringFilter>;
  fileExtension?: Maybe<SearchableStringFilter>;
  fileMimetype?: Maybe<SearchableStringFilter>;
  fileSize?: Maybe<SearchableIntFilter>;
  fullText?: Maybe<SearchableStringFilter>;
  itemCount?: Maybe<SearchableIntFilter>;
  mediaType?: Maybe<SearchableStringFilter>;
  objectiveAuthority?: Maybe<SearchableStringFilter>;
  objectiveAbbreviation?: Maybe<SearchableStringFilter>;
  objectiveDocument?: Maybe<SearchableStringFilter>;
  objectiveId?: Maybe<SearchableStringFilter>;
  objectiveScope?: Maybe<SearchableStringFilter>;
  objectType?: Maybe<SearchableStringFilter>;
  referencesIds?: Maybe<SearchableStringFilter>;
  relativeCount?: Maybe<SearchableIntFilter>;
  translatedLanguages?: Maybe<SearchableStringFilter>;
  watcherUserIds?: Maybe<SearchableStringFilter>;
  and?: Maybe<Array<Maybe<SearchableResourceFilter>>>;
  or?: Maybe<Array<Maybe<SearchableResourceFilter>>>;
  not?: Maybe<SearchableResourceFilter>;
};

export type SearchableStringFilter = {
  __typename?: 'SearchableStringFilter';
  ne?: Maybe<Scalars['String']>;
  eq?: Maybe<Scalars['String']>;
  match?: Maybe<Scalars['String']>;
  matchPhrase?: Maybe<Scalars['String']>;
  matchPhrasePrefix?: Maybe<Scalars['String']>;
  multiMatch?: Maybe<Scalars['String']>;
  exists?: Maybe<Scalars['Boolean']>;
  wildcard?: Maybe<Scalars['String']>;
  regexp?: Maybe<Scalars['String']>;
};

export type SearchableTagFilter = {
  __typename?: 'SearchableTagFilter';
  ne?: Maybe<Scalars['String']>;
  eq?: Maybe<Scalars['String']>;
  match?: Maybe<Scalars['String']>;
  matchPhrase?: Maybe<Scalars['String']>;
  matchPhrasePrefix?: Maybe<Scalars['String']>;
  multiMatch?: Maybe<Scalars['String']>;
  notEmpty?: Maybe<Scalars['String']>;
  empty?: Maybe<Scalars['String']>;
  exists?: Maybe<Scalars['String']>;
  wildcard?: Maybe<Scalars['String']>;
  regexp?: Maybe<Scalars['String']>;
};

export type SearchableIdFilter = {
  __typename?: 'SearchableIDFilter';
  ne?: Maybe<Scalars['ID']>;
  eq?: Maybe<Scalars['ID']>;
  match?: Maybe<Scalars['ID']>;
  matchPhrase?: Maybe<Scalars['ID']>;
  matchPhrasePrefix?: Maybe<Scalars['ID']>;
  multiMatch?: Maybe<Scalars['ID']>;
  exists?: Maybe<Scalars['Boolean']>;
  wildcard?: Maybe<Scalars['ID']>;
  regexp?: Maybe<Scalars['ID']>;
};

export type SearchableDateFilter = {
  __typename?: 'SearchableDateFilter';
  gt?: Maybe<Scalars['String']>;
  lt?: Maybe<Scalars['String']>;
  gte?: Maybe<Scalars['String']>;
  lte?: Maybe<Scalars['String']>;
};

export type SearchableIntFilter = {
  __typename?: 'SearchableIntFilter';
  eq?: Maybe<Scalars['Int']>;
  exists?: Maybe<Scalars['Boolean']>;
  gt?: Maybe<Scalars['Int']>;
  gte?: Maybe<Scalars['Int']>;
  lt?: Maybe<Scalars['Int']>;
  lte?: Maybe<Scalars['Int']>;
  ne?: Maybe<Scalars['Int']>;
  range?: Maybe<Array<Maybe<Scalars['Int']>>>;
};

export type SearchableFloatFilter = {
  __typename?: 'SearchableFloatFilter';
  eq?: Maybe<Scalars['Float']>;
  exists?: Maybe<Scalars['Boolean']>;
  gt?: Maybe<Scalars['Float']>;
  gte?: Maybe<Scalars['Float']>;
  lt?: Maybe<Scalars['Float']>;
  lte?: Maybe<Scalars['Float']>;
  ne?: Maybe<Scalars['Float']>;
  range?: Maybe<Array<Maybe<Scalars['Float']>>>;
};

export type SearchableBooleanFilter = {
  __typename?: 'SearchableBooleanFilter';
  eq?: Maybe<Scalars['Boolean']>;
  ne?: Maybe<Scalars['Boolean']>;
};

export type SearchAggs = {
  __typename?: 'SearchAggs';
  name: Scalars['String'];
  type: Scalars['String'];
  field?: Maybe<Scalars['String']>;
  query?: Maybe<Scalars['String']>;
  path?: Maybe<Scalars['String']>;
  include?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Int']>;
  interval?: Maybe<Scalars['String']>;
  extendedBounds?: Maybe<SearchAggsExtendedBounds>;
  aggs?: Maybe<Array<SearchAggs>>;
};

export type SearchAggsExtendedBounds = {
  __typename?: 'SearchAggsExtendedBounds';
  min?: Maybe<Scalars['String']>;
  max?: Maybe<Scalars['String']>;
};

export type SearchableResourceAggs = {
  __typename?: 'SearchableResourceAggs';
  term: Scalars['String'];
  tagTerms?: Maybe<Array<Maybe<Scalars['String']>>>;
  tagMatch?: Maybe<Scalars['String']>;
};

export type SearchableResourceSort = {
  __typename?: 'SearchableResourceSort';
  field?: Maybe<SearchableResourceSortableFields>;
  direction?: Maybe<SearchableSortDirection>;
};

export type SearchableObjectiveFilter = {
  __typename?: 'SearchableObjectiveFilter';
  id?: Maybe<SearchableIdFilter>;
  sk?: Maybe<SearchableStringFilter>;
  guid?: Maybe<SearchableStringFilter>;
  type?: Maybe<SearchableStringFilter>;
  name?: Maybe<SearchableStringFilter>;
  content?: Maybe<SearchableStringFilter>;
  numRaw?: Maybe<SearchableStringFilter>;
  numEnhanced?: Maybe<SearchableStringFilter>;
  outlineNumber?: Maybe<SearchableStringFilter>;
  abbreviation?: Maybe<SearchableStringFilter>;
  sequence?: Maybe<SearchableIntFilter>;
  idAuthority?: Maybe<SearchableStringFilter>;
  idPublisher?: Maybe<SearchableStringFilter>;
  parentId?: Maybe<SearchableStringFilter>;
  scope?: Maybe<SearchableStringFilter>;
  isAlignable?: Maybe<SearchableBooleanFilter>;
  isObsolete?: Maybe<SearchableBooleanFilter>;
  objectiveTree?: Maybe<SearchableStringFilter>;
  workflowStatus?: Maybe<SearchableStringFilter>;
  versionCurrent?: Maybe<SearchableIntFilter>;
  versionNext?: Maybe<SearchableIntFilter>;
  versionLabel?: Maybe<SearchableStringFilter>;
  documentId?: Maybe<SearchableStringFilter>;
  authorityId?: Maybe<SearchableStringFilter>;
  publicationId?: Maybe<SearchableStringFilter>;
  notes?: Maybe<SearchableStringFilter>;
  createdAt?: Maybe<SearchableStringFilter>;
  updatedAt?: Maybe<SearchableStringFilter>;
  and?: Maybe<Array<Maybe<SearchableObjectiveFilter>>>;
  or?: Maybe<Array<Maybe<SearchableObjectiveFilter>>>;
  not?: Maybe<SearchableObjectiveFilter>;
};

export type SearchableObjectiveSort = {
  __typename?: 'SearchableObjectiveSort';
  field?: Maybe<SearchableObjectiveSortableFields>;
  direction?: Maybe<SearchableSortDirection>;
};

export type SearchableUserConnection = {
  __typename?: 'SearchableUserConnection';
  items?: Maybe<Array<User>>;
  nextToken?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Int']>;
  aggregations?: Maybe<Scalars['AWSJSON']>;
};

export type SearchableWorkspaceConnection = {
  __typename?: 'SearchableWorkspaceConnection';
  items?: Maybe<Array<Workspace>>;
  nextToken?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Int']>;
  aggregations?: Maybe<Scalars['AWSJSON']>;
};

export type SystemEvent = {
  __typename?: 'SystemEvent';
  type: Scalars['String'];
  codebaseName?: Maybe<Scalars['String']>;
  data?: Maybe<Scalars['AWSJSON']>;
};

export type SystemEventInput = {
  type: Scalars['String'];
  codebaseName?: Maybe<Scalars['String']>;
  data?: Maybe<Scalars['AWSJSON']>;
};

export enum SystemEventType {
  AppUpdate = 'APP_UPDATE'
}

export type User = {
  __typename?: 'User';
  id: Scalars['ID'];
  sk: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  avatarHash?: Maybe<Scalars['String']>;
  acl?: Maybe<Scalars['AWSJSON']>;
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
  userId?: Maybe<Scalars['String']>;
  lastActiveAt?: Maybe<Scalars['AWSDateTime']>;
  status?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  file?: Maybe<S3Object>;
  data?: Maybe<Scalars['AWSJSON']>;
  workspaceId?: Maybe<Scalars['String']>;
  notification?: Maybe<Notification>;
  notificationsConfig?: Maybe<NotificationsConfig>;
  school?: Maybe<School>;
  eventId?: Maybe<Scalars['String']>;
  event?: Maybe<Event>;
  jobId?: Maybe<Scalars['String']>;
  job?: Maybe<Job>;
  intercomId?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Tag>>;
  cognitoState?: Maybe<UserCognitoState>;
};

export type UserCognitoState = {
  __typename?: 'UserCognitoState';
  exists: Scalars['Boolean'];
  confirmationStatus: Scalars['String'];
  isEmailVerified: Scalars['Boolean'];
};

export type S3Object = {
  __typename?: 'S3Object';
  bucket: Scalars['String'];
  region: Scalars['String'];
  key: Scalars['String'];
};

export type NotificationsConfig = {
  __typename?: 'NotificationsConfig';
  enabled?: Maybe<Scalars['Boolean']>;
};

export type School = {
  __typename?: 'School';
  name?: Maybe<Scalars['String']>;
};

export type CreateUserNotificationInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
  notification?: Maybe<NotificationInput>;
};

export type Notification = {
  __typename?: 'Notification';
  type?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  file?: Maybe<S3Object>;
  payload?: Maybe<Scalars['AWSJSON']>;
};

export type CreateAccountInput = {
  id?: Maybe<Scalars['ID']>;
  sk: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  avatarHash?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
  school?: Maybe<SchoolInput>;
  notificationsConfig?: Maybe<NotificationsConfigInput>;
};

export type UpdateAccountInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  avatarHash?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
  lastActiveAt?: Maybe<Scalars['AWSDateTime']>;
  workspaceId?: Maybe<Scalars['String']>;
  school?: Maybe<SchoolInput>;
  notificationsConfig?: Maybe<NotificationsConfigInput>;
};

export type UpdateUserNotificationInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
  status?: Maybe<Scalars['String']>;
};

export type DeleteUserNotificationInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  avatarHash?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
  lastActiveAt?: Maybe<Scalars['AWSDateTime']>;
  workspaceId?: Maybe<Scalars['String']>;
};

export type LoginUserInput = {
  username: Scalars['String'];
};

export type ModelUserConnection = {
  __typename?: 'ModelUserConnection';
  items?: Maybe<Array<Maybe<User>>>;
  nextToken?: Maybe<Scalars['String']>;
};

export type RegistrationStatusInput = {
  email: Scalars['String'];
  registrationCode: Scalars['String'];
  workspaceId: Scalars['String'];
};

export type RegistrationStatusControllerInput = {
  params: RegistrationStatusInput;
  action: Scalars['String'];
};

export type RegistrationPass = {
  __typename?: 'RegistrationPass';
  isRecognized?: Maybe<Scalars['Boolean']>;
  isCreated?: Maybe<Scalars['Boolean']>;
  jwt?: Maybe<Scalars['String']>;
  userStatus?: Maybe<Scalars['String']>;
};

export type RegisterCognitoUserInput = {
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  jwt: Scalars['String'];
};

export type RegisterCognitoUserControllerInput = {
  params: RegisterCognitoUserInput;
  action: Scalars['String'];
};

export type RegisterAppUserInput = {
  jwt: Scalars['String'];
};

export type RegisterAppUserControllerInput = {
  params: RegisterAppUserInput;
  action: Scalars['String'];
};

export type GenericStatus = {
  __typename?: 'GenericStatus';
  status?: Maybe<Scalars['String']>;
};

export type WorkspaceParent = {
  __typename?: 'WorkspaceParent';
  id: Scalars['ID'];
  sk: Scalars['String'];
  workspaceId: Scalars['String'];
  schemaVersion: Scalars['String'];
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  tags?: Maybe<Array<Tag>>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
  creatorId?: Maybe<Scalars['String']>;
  parentWorkspaceId: Scalars['String'];
  parentWorkspace?: Maybe<Workspace>;
  childWorkspace?: Maybe<Workspace>;
  creator?: Maybe<User>;
};

export type CreateWorkspaceParentInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
  workspaceId: Scalars['String'];
  schemaVersion: Scalars['String'];
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  tags?: Maybe<Array<TagInput>>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
  creatorId?: Maybe<Scalars['String']>;
  parentWorkspaceId: Scalars['String'];
};

export type UpdateWorkspaceParentInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
  workspaceId: Scalars['String'];
  schemaVersion?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  tags?: Maybe<Array<TagInput>>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
  creatorId?: Maybe<Scalars['String']>;
  parentWorkspaceId?: Maybe<Scalars['String']>;
};

export type DeleteWorkspaceParentInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
};

export type ModelWorkspaceParentConnection = {
  __typename?: 'ModelWorkspaceParentConnection';
  items?: Maybe<Array<WorkspaceParent>>;
  nextToken?: Maybe<Scalars['String']>;
};

export type WorkspaceProduct = {
  __typename?: 'WorkspaceProduct';
  id: Scalars['ID'];
  sk: Scalars['String'];
  workspaceId: Scalars['String'];
  schemaVersion: Scalars['String'];
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  tags?: Maybe<Array<Tag>>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
  creatorId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  filter?: Maybe<Scalars['AWSJSON']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isDisabled?: Maybe<Scalars['Boolean']>;
  creator?: Maybe<User>;
};

export type CreateWorkspaceProductInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
  workspaceId: Scalars['String'];
  schemaVersion: Scalars['String'];
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  tags?: Maybe<Array<TagInput>>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
  creatorId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  filter?: Maybe<Scalars['AWSJSON']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isDisabled?: Maybe<Scalars['Boolean']>;
};

export type UpdateWorkspaceProductInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
  workspaceId: Scalars['String'];
  schemaVersion?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  tags?: Maybe<Array<TagInput>>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
  creatorId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  filter?: Maybe<Scalars['AWSJSON']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isDisabled?: Maybe<Scalars['Boolean']>;
};

export type DeleteWorkspaceProductInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
};

export type SearchableWorkspaceProductConnection = {
  __typename?: 'SearchableWorkspaceProductConnection';
  items?: Maybe<Array<WorkspaceProduct>>;
  nextToken?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Int']>;
  aggregations?: Maybe<Scalars['AWSJSON']>;
};

export type WorkspaceRegistrationCode = {
  __typename?: 'WorkspaceRegistrationCode';
  id: Scalars['ID'];
  sk: Scalars['String'];
  workspaceId: Scalars['String'];
  schemaVersion: Scalars['String'];
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  tags?: Maybe<Array<Tag>>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
  creator?: Maybe<User>;
  creatorId?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
};

export type CreateWorkspaceRegistrationCodeInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
  workspaceId: Scalars['String'];
  schemaVersion: Scalars['String'];
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  tags?: Maybe<Array<TagInput>>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
  creatorId?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
};

export type UpdateWorkspaceRegistrationCodeInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
  workspaceId: Scalars['String'];
  schemaVersion?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  tags?: Maybe<Array<TagInput>>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
  creatorId?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
};

export type DeleteWorkspaceRegistrationCodeInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
};

export type WorkspaceShare = {
  __typename?: 'WorkspaceShare';
  id: Scalars['ID'];
  sk: Scalars['String'];
  workspaceId: Scalars['String'];
  schemaVersion: Scalars['String'];
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  tags?: Maybe<Array<Tag>>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
  creatorId?: Maybe<Scalars['String']>;
  creator?: Maybe<User>;
  expiresAt?: Maybe<Scalars['AWSDateTime']>;
  workspace?: Maybe<Workspace>;
  consumer?: Maybe<WorkspaceShareConsumer>;
  bankIds: Array<Scalars['String']>;
  banks?: Maybe<Array<Maybe<Workspace>>>;
  allowFilter?: Maybe<Scalars['AWSJSON']>;
  definition?: Maybe<Scalars['AWSJSON']>;
};

export type CreateWorkspaceShareInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
  workspaceId: Scalars['String'];
  schemaVersion: Scalars['String'];
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  tags?: Maybe<Array<TagInput>>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
  creatorId?: Maybe<Scalars['String']>;
  expiresAt?: Maybe<Scalars['AWSDateTime']>;
  bankIds: Array<Scalars['String']>;
  allowFilter?: Maybe<Scalars['AWSJSON']>;
  definition?: Maybe<Scalars['AWSJSON']>;
};

export type UpdateWorkspaceShareInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
  workspaceId: Scalars['String'];
  schemaVersion?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  tags?: Maybe<Array<TagInput>>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
  creatorId?: Maybe<Scalars['String']>;
  expiresAt?: Maybe<Scalars['AWSDateTime']>;
  bankIds?: Maybe<Array<Scalars['String']>>;
  allowFilter?: Maybe<Scalars['AWSJSON']>;
  definition?: Maybe<Scalars['AWSJSON']>;
};

export type DeleteWorkspaceShareInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
};

export type WorkspaceShareConsumer = {
  __typename?: 'WorkspaceShareConsumer';
  appId?: Maybe<Scalars['String']>;
  appName?: Maybe<Scalars['String']>;
  workspaceId?: Maybe<Scalars['String']>;
  workspaceName?: Maybe<Scalars['String']>;
};

export type SearchableWorkspaceShareConnection = {
  __typename?: 'SearchableWorkspaceShareConnection';
  items?: Maybe<Array<WorkspaceShare>>;
  nextToken?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Int']>;
  aggregations?: Maybe<Scalars['AWSJSON']>;
};

export type CreateBankInput = {
  id?: Maybe<Scalars['ID']>;
  sk: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  schemaVersion?: Maybe<Scalars['String']>;
  workspaceId?: Maybe<Scalars['String']>;
};

export type UpdateBankInput = {
  id?: Maybe<Scalars['ID']>;
  sk: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
};

export type DeleteBankInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
  workspaceId: Scalars['String'];
};

export type Workspace = {
  __typename?: 'Workspace';
  acl?: Maybe<Scalars['AWSJSON']>;
  appLicenses?: Maybe<Array<AppLicense>>;
  billing?: Maybe<Billing>;
  contact?: Maybe<Contact>;
  counter?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  customerId?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  features?: Maybe<Scalars['AWSJSON']>;
  id: Scalars['ID'];
  intercomId?: Maybe<Scalars['String']>;
  invitationId?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isDisabled?: Maybe<Scalars['Boolean']>;
  lastActiveAt?: Maybe<Scalars['AWSDateTime']>;
  name?: Maybe<Scalars['String']>;
  outlet?: Maybe<OutletConfig>;
  product?: Maybe<Product>;
  recentResourceIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  recentResources?: Maybe<ModelResourceConnection>;
  reviewCountPending?: Maybe<Scalars['Int']>;
  roleIds?: Maybe<Array<Scalars['String']>>;
  roles?: Maybe<Array<Maybe<Workspace>>>;
  schemaVersion?: Maybe<Scalars['String']>;
  sk: Scalars['String'];
  status?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Maybe<Tag>>>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
  user?: Maybe<User>;
  webhook?: Maybe<WebhookConfig>;
  workspace?: Maybe<Workspace>;
  workspaceId?: Maybe<Scalars['String']>;
  workspaceParentId?: Maybe<Scalars['String']>;
  workspaceUserId?: Maybe<Scalars['String']>;
};

export enum ProductTier {
  Free = 'FREE',
  Basic = 'BASIC',
  Professional = 'PROFESSIONAL',
  Enterprise = 'ENTERPRISE'
}

export type UpdateWorkspaceSubscription = {
  __typename?: 'UpdateWorkspaceSubscription';
  id: Scalars['ID'];
  sk: Scalars['String'];
  workspaceId: Scalars['String'];
  action?: Maybe<Scalars['String']>;
  product?: Maybe<Product>;
  billing?: Maybe<Billing>;
};

export type DeleteWorkspaceInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
};

export type ListUserWorkspacesInput = {
  primaryOnly?: Maybe<Scalars['Boolean']>;
  userId?: Maybe<Scalars['String']>;
};

export type WorkspaceUpdate = {
  __typename?: 'WorkspaceUpdate';
  type?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  sk?: Maybe<Scalars['String']>;
  data?: Maybe<WorkspaceUpdateData>;
};

export type WorkspaceUpdateData = {
  __typename?: 'WorkspaceUpdateData';
  id: Scalars['String'];
  sk: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  acl?: Maybe<Scalars['AWSJSON']>;
  plan?: Maybe<Scalars['AWSJSON']>;
  isDisabled?: Maybe<Scalars['Boolean']>;
  features?: Maybe<Scalars['AWSJSON']>;
  reviewCountPending?: Maybe<Scalars['Int']>;
};

export type IncrementWorkspaceCounterInput = {
  id: Scalars['String'];
  sk: Scalars['String'];
};

export type ModelWorkspaceConnection = {
  __typename?: 'ModelWorkspaceConnection';
  items?: Maybe<Array<Maybe<Workspace>>>;
  nextToken?: Maybe<Scalars['String']>;
};

export type ModelWorkspaceFilterInput = {
  id?: Maybe<ModelIdFilterInput>;
  sk?: Maybe<ModelStringFilterInput>;
  name?: Maybe<ModelStringFilterInput>;
  description?: Maybe<ModelStringFilterInput>;
  createdAt?: Maybe<ModelStringFilterInput>;
  updatedAt?: Maybe<ModelStringFilterInput>;
  lastActiveAt?: Maybe<ModelStringFilterInput>;
  workspaceId?: Maybe<ModelStringFilterInput>;
  invitationId?: Maybe<ModelStringFilterInput>;
  customerId?: Maybe<ModelStringFilterInput>;
  status?: Maybe<ModelStringFilterInput>;
  acl?: Maybe<ModelStringFilterInput>;
  counter?: Maybe<ModelIntFilterInput>;
  isDisabled?: Maybe<ModelBooleanFilterInput>;
  isDeleted?: Maybe<ModelBooleanFilterInput>;
  and?: Maybe<Array<Maybe<ModelWorkspaceFilterInput>>>;
  or?: Maybe<Array<Maybe<ModelWorkspaceFilterInput>>>;
  not?: Maybe<ModelWorkspaceFilterInput>;
};

export type Product = {
  __typename?: 'Product';
  type?: Maybe<ProductTier>;
  name?: Maybe<Scalars['String']>;
  units?: Maybe<Scalars['Int']>;
  unitPrice?: Maybe<Scalars['Float']>;
  isTrial?: Maybe<Scalars['Boolean']>;
  productId?: Maybe<Scalars['String']>;
  priceId?: Maybe<Scalars['String']>;
  subscriptionId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
};

export type Billing = {
  __typename?: 'Billing';
  method?: Maybe<BillingMethod>;
  contact?: Maybe<Contact>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
};

export type BillingMethod = {
  __typename?: 'BillingMethod';
  id: Scalars['String'];
  type: Scalars['String'];
  card?: Maybe<BillingCard>;
  createdAt?: Maybe<Scalars['AWSDateTime']>;
};

export type BillingCard = {
  __typename?: 'BillingCard';
  brand?: Maybe<Scalars['String']>;
  expMonth?: Maybe<Scalars['Int']>;
  expYear?: Maybe<Scalars['Int']>;
  last4?: Maybe<Scalars['String']>;
};

export type Contact = {
  __typename?: 'Contact';
  name?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
};

export type OutletConfig = {
  __typename?: 'OutletConfig';
  label?: Maybe<Scalars['String']>;
  type?: Maybe<OutletType>;
  learnosity?: Maybe<LearnosityConfig>;
  isEnabled?: Maybe<Scalars['Boolean']>;
  bankIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export enum OutletType {
  Learnosity = 'LEARNOSITY'
}

export type LearnosityConfig = {
  __typename?: 'LearnosityConfig';
  organizationId?: Maybe<Scalars['String']>;
  consumerKey?: Maybe<Scalars['String']>;
  secret?: Maybe<Scalars['String']>;
  config?: Maybe<Scalars['AWSJSON']>;
};

export type RestApiToken = {
  __typename?: 'RestApiToken';
  id: Scalars['ID'];
  sk: Scalars['String'];
  workspaceId: Scalars['String'];
  schemaVersion: Scalars['String'];
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  tags?: Maybe<Array<Tag>>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
};

export type CreateRestApiTokenInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
  workspaceId: Scalars['String'];
  schemaVersion: Scalars['String'];
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  tags?: Maybe<Array<TagInput>>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
};

export type UpdateRestApiTokenInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
  workspaceId: Scalars['String'];
  schemaVersion?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  tags?: Maybe<Array<TagInput>>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
};

export type DeleteRestApiTokenInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
};

export type WebhookConfig = {
  __typename?: 'WebhookConfig';
  label?: Maybe<Scalars['String']>;
  endpoint?: Maybe<Scalars['String']>;
  isEnabled?: Maybe<Scalars['Boolean']>;
  bankIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type CreateResourceInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
  schemaVersion: Scalars['String'];
  idInc?: Maybe<Scalars['String']>;
  idVendor?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['Int']>;
  originIdInc?: Maybe<Scalars['String']>;
  originResourceId?: Maybe<Scalars['String']>;
  originWorkspaceId?: Maybe<Scalars['String']>;
  originBankId?: Maybe<Scalars['String']>;
  resourceId?: Maybe<Scalars['String']>;
  bankId?: Maybe<Scalars['String']>;
  workspaceId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  author?: Maybe<Scalars['String']>;
  maturity?: Maybe<Scalars['String']>;
  subject?: Maybe<Array<Maybe<Scalars['String']>>>;
  courseIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  language?: Maybe<Array<Maybe<Scalars['String']>>>;
  grade?: Maybe<Array<Maybe<Scalars['String']>>>;
  dok?: Maybe<Array<Maybe<Scalars['String']>>>;
  blooms?: Maybe<Array<Maybe<Scalars['String']>>>;
  excerpt?: Maybe<Scalars['String']>;
  lexile?: Maybe<Scalars['Int']>;
  lexileMin?: Maybe<Scalars['Int']>;
  lexileMax?: Maybe<Scalars['Int']>;
  rmm?: Maybe<Scalars['Float']>;
  flesch?: Maybe<Scalars['Float']>;
  wordCount?: Maybe<Scalars['Int']>;
  parccTextComplexity?: Maybe<Scalars['String']>;
  difficulty?: Maybe<Scalars['String']>;
  scoringMethod?: Maybe<Scalars['String']>;
  answerDistribution?: Maybe<Array<Maybe<Scalars['String']>>>;
  fontScaling?: Maybe<Scalars['String']>;
  copyright?: Maybe<Scalars['String']>;
  copyrightYear?: Maybe<Scalars['String']>;
  isbn?: Maybe<Scalars['String']>;
  content?: Maybe<ResourceContentInput>;
  interaction?: Maybe<Array<Maybe<Scalars['String']>>>;
  interactionCount?: Maybe<Scalars['Int']>;
  scoring?: Maybe<Scalars['AWSJSON']>;
  contextIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  assetIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  itemCount?: Maybe<Scalars['Int']>;
  dimensions?: Maybe<ResourceDimensionsInput>;
  file?: Maybe<ResourceFileInput>;
  editorId?: Maybe<Scalars['String']>;
  actorId?: Maybe<Scalars['String']>;
  reviewerId?: Maybe<Scalars['String']>;
  assigneeId?: Maybe<Scalars['String']>;
  creatorId?: Maybe<Scalars['String']>;
  alignmentIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  alignmentCount?: Maybe<Scalars['Int']>;
  alignmentScopes?: Maybe<Array<Maybe<Scalars['String']>>>;
  tags?: Maybe<Array<Maybe<TagInput>>>;
  keywords?: Maybe<Array<Maybe<Scalars['String']>>>;
  genres?: Maybe<Array<Maybe<Scalars['String']>>>;
  relationship?: Maybe<RelationshipTypeEnum>;
  reviewId?: Maybe<Scalars['String']>;
  dueAt?: Maybe<Scalars['AWSDateTime']>;
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
  deletesAt?: Maybe<Scalars['AWSTimestamp']>;
  isCreating?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isDisabled?: Maybe<Scalars['Boolean']>;
  isArchived?: Maybe<Scalars['Boolean']>;
  isUnlisted?: Maybe<Scalars['Boolean']>;
  visibility?: Maybe<ResourceVisibilityType>;
  isPublished?: Maybe<Scalars['Boolean']>;
  latestPublishedVersion?: Maybe<Scalars['String']>;
  questionIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  config?: Maybe<Scalars['AWSJSON']>;
  data?: Maybe<Scalars['AWSJSON']>;
  stats?: Maybe<Scalars['AWSJSON']>;
  statsAt?: Maybe<Scalars['AWSDateTime']>;
  ownerUserIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  workflowId?: Maybe<Scalars['String']>;
  workflow?: Maybe<Scalars['AWSJSON']>;
  workflowStatusId?: Maybe<Scalars['String']>;
  issueKey?: Maybe<Scalars['String']>;
  issueCount?: Maybe<Scalars['Int']>;
  issueCountUnresolved?: Maybe<Scalars['Int']>;
  resolutionText?: Maybe<Scalars['String']>;
  resolutionType?: Maybe<Scalars['String']>;
  resolutionUserId?: Maybe<Scalars['String']>;
  resolutionAt?: Maybe<Scalars['AWSDateTime']>;
  referencesIds?: Maybe<Array<Maybe<Scalars['AWSJSON']>>>;
  taskId?: Maybe<Scalars['String']>;
  task?: Maybe<Scalars['String']>;
  priority?: Maybe<ResourcePriorityEnum>;
  taskCount?: Maybe<Scalars['Int']>;
  taskCountUnresolved?: Maybe<Scalars['Int']>;
  resourcesIds?: Maybe<Array<Maybe<GenericReferenceIdInput>>>;
  blueprintIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  blueprint?: Maybe<Scalars['AWSJSON']>;
  blueprintSpecs?: Maybe<Scalars['AWSJSON']>;
  storeIsEnabled?: Maybe<Scalars['Boolean']>;
  storePrice?: Maybe<Scalars['Int']>;
  storePriceScheme?: Maybe<ResourceStorePriceSchemeType>;
  objectiveMap?: Maybe<ResourceObjectiveMapInput>;
  objectiveMapSourceScope?: Maybe<Scalars['String']>;
  objectiveMapTargetScope?: Maybe<Scalars['String']>;
  collectionType?: Maybe<ResourceCollectionType>;
  collectionQuery?: Maybe<Scalars['AWSJSON']>;
  examSessionResponses?: Maybe<Scalars['AWSJSON']>;
  examSessionResponseScores?: Maybe<Scalars['AWSJSON']>;
  examSessionResults?: Maybe<Scalars['AWSJSON']>;
  scoreMin?: Maybe<Scalars['Float']>;
  scoreMax?: Maybe<Scalars['Float']>;
  scoreActual?: Maybe<Scalars['Float']>;
  appId?: Maybe<Scalars['String']>;
  appKey?: Maybe<Scalars['String']>;
  appSecret?: Maybe<Scalars['String']>;
  appExpiresAt?: Maybe<Scalars['AWSDateTime']>;
  eventLogChanges?: Maybe<Scalars['AWSJSON']>;
  eventLogOldImage?: Maybe<Scalars['AWSJSON']>;
  eventLogNewImage?: Maybe<Scalars['AWSJSON']>;
  eventLogActorId?: Maybe<Scalars['String']>;
  numberLabel?: Maybe<Scalars['String']>;
  examSessionId?: Maybe<Scalars['String']>;
  examSessionData?: Maybe<ExamSessionDataInput>;
  examConfigId?: Maybe<Scalars['String']>;
  examConfigStatus?: Maybe<Scalars['String']>;
  examConfigData?: Maybe<ExamConfigInput>;
  examItemAverageScore?: Maybe<Scalars['Float']>;
  examItemLastUsedAt?: Maybe<Scalars['AWSDateTime']>;
  examItemUseCount?: Maybe<Scalars['Int']>;
  imageUrl?: Maybe<Scalars['String']>;
  imageHash?: Maybe<Scalars['String']>;
  coverImage?: Maybe<S3ObjectInput>;
  checksum?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  sequence?: Maybe<Scalars['String']>;
  deliveryMediaType?: Maybe<DeliveryMediaType>;
};

export type UpdateResourceInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
  schemaVersion?: Maybe<Scalars['String']>;
  idInc?: Maybe<Scalars['String']>;
  idVendor?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['Int']>;
  originIdInc?: Maybe<Scalars['String']>;
  originResourceId?: Maybe<Scalars['String']>;
  originWorkspaceId?: Maybe<Scalars['String']>;
  originBankId?: Maybe<Scalars['String']>;
  resourceId?: Maybe<Scalars['String']>;
  bankId?: Maybe<Scalars['String']>;
  workspaceId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  author?: Maybe<Scalars['String']>;
  maturity?: Maybe<Scalars['String']>;
  subject?: Maybe<Array<Maybe<Scalars['String']>>>;
  courseIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  language?: Maybe<Array<Maybe<Scalars['String']>>>;
  grade?: Maybe<Array<Maybe<Scalars['String']>>>;
  dok?: Maybe<Array<Maybe<Scalars['String']>>>;
  blooms?: Maybe<Array<Maybe<Scalars['String']>>>;
  excerpt?: Maybe<Scalars['String']>;
  lexile?: Maybe<Scalars['Int']>;
  lexileMin?: Maybe<Scalars['Int']>;
  lexileMax?: Maybe<Scalars['Int']>;
  rmm?: Maybe<Scalars['Float']>;
  flesch?: Maybe<Scalars['Float']>;
  wordCount?: Maybe<Scalars['Int']>;
  parccTextComplexity?: Maybe<Scalars['String']>;
  difficulty?: Maybe<Scalars['String']>;
  scoringMethod?: Maybe<Scalars['String']>;
  answerDistribution?: Maybe<Array<Maybe<Scalars['String']>>>;
  fontScaling?: Maybe<Scalars['String']>;
  copyright?: Maybe<Scalars['String']>;
  copyrightYear?: Maybe<Scalars['String']>;
  isbn?: Maybe<Scalars['String']>;
  content?: Maybe<ResourceContentInput>;
  interaction?: Maybe<Array<Maybe<Scalars['String']>>>;
  interactionCount?: Maybe<Scalars['Int']>;
  scoring?: Maybe<Scalars['AWSJSON']>;
  contextIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  assetIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  itemCount?: Maybe<Scalars['Int']>;
  dimensions?: Maybe<ResourceDimensionsInput>;
  file?: Maybe<ResourceFileInput>;
  editorId?: Maybe<Scalars['String']>;
  actorId?: Maybe<Scalars['String']>;
  reviewerId?: Maybe<Scalars['String']>;
  assigneeId?: Maybe<Scalars['String']>;
  creatorId?: Maybe<Scalars['String']>;
  alignmentIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  alignmentCount?: Maybe<Scalars['Int']>;
  alignmentScopes?: Maybe<Array<Maybe<Scalars['String']>>>;
  tags?: Maybe<Array<Maybe<TagInput>>>;
  keywords?: Maybe<Array<Maybe<Scalars['String']>>>;
  genres?: Maybe<Array<Maybe<Scalars['String']>>>;
  relationship?: Maybe<RelationshipTypeEnum>;
  reviewId?: Maybe<Scalars['String']>;
  dueAt?: Maybe<Scalars['AWSDateTime']>;
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
  deletesAt?: Maybe<Scalars['AWSTimestamp']>;
  isCreating?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isDisabled?: Maybe<Scalars['Boolean']>;
  isArchived?: Maybe<Scalars['Boolean']>;
  isUnlisted?: Maybe<Scalars['Boolean']>;
  visibility?: Maybe<ResourceVisibilityType>;
  isPublished?: Maybe<Scalars['Boolean']>;
  latestPublishedVersion?: Maybe<Scalars['String']>;
  questionIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  config?: Maybe<Scalars['AWSJSON']>;
  data?: Maybe<Scalars['AWSJSON']>;
  stats?: Maybe<Scalars['AWSJSON']>;
  statsAt?: Maybe<Scalars['AWSDateTime']>;
  ownerUserIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  workflowId?: Maybe<Scalars['String']>;
  workflow?: Maybe<Scalars['AWSJSON']>;
  workflowStatusId?: Maybe<Scalars['String']>;
  issueKey?: Maybe<Scalars['String']>;
  issueCount?: Maybe<Scalars['Int']>;
  issueCountUnresolved?: Maybe<Scalars['Int']>;
  resolutionText?: Maybe<Scalars['String']>;
  resolutionType?: Maybe<Scalars['String']>;
  resolutionUserId?: Maybe<Scalars['String']>;
  resolutionAt?: Maybe<Scalars['AWSDateTime']>;
  referencesIds?: Maybe<Array<Maybe<Scalars['AWSJSON']>>>;
  taskId?: Maybe<Scalars['String']>;
  task?: Maybe<Scalars['String']>;
  priority?: Maybe<ResourcePriorityEnum>;
  taskCount?: Maybe<Scalars['Int']>;
  taskCountUnresolved?: Maybe<Scalars['Int']>;
  resourcesIds?: Maybe<Array<Maybe<GenericReferenceIdInput>>>;
  blueprintIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  blueprint?: Maybe<Scalars['AWSJSON']>;
  blueprintSpecs?: Maybe<Scalars['AWSJSON']>;
  storeIsEnabled?: Maybe<Scalars['Boolean']>;
  storePrice?: Maybe<Scalars['Int']>;
  storePriceScheme?: Maybe<ResourceStorePriceSchemeType>;
  objectiveMap?: Maybe<ResourceObjectiveMapInput>;
  objectiveMapSourceScope?: Maybe<Scalars['String']>;
  objectiveMapTargetScope?: Maybe<Scalars['String']>;
  collectionType?: Maybe<ResourceCollectionType>;
  collectionQuery?: Maybe<Scalars['AWSJSON']>;
  examSessionResponses?: Maybe<Scalars['AWSJSON']>;
  examSessionResponseScores?: Maybe<Scalars['AWSJSON']>;
  examSessionResults?: Maybe<Scalars['AWSJSON']>;
  scoreMin?: Maybe<Scalars['Float']>;
  scoreMax?: Maybe<Scalars['Float']>;
  scoreActual?: Maybe<Scalars['Float']>;
  appId?: Maybe<Scalars['String']>;
  appKey?: Maybe<Scalars['String']>;
  appSecret?: Maybe<Scalars['String']>;
  appExpiresAt?: Maybe<Scalars['AWSDateTime']>;
  eventLogChanges?: Maybe<Scalars['AWSJSON']>;
  eventLogOldImage?: Maybe<Scalars['AWSJSON']>;
  eventLogNewImage?: Maybe<Scalars['AWSJSON']>;
  eventLogActorId?: Maybe<Scalars['String']>;
  numberLabel?: Maybe<Scalars['String']>;
  examSessionId?: Maybe<Scalars['String']>;
  examSessionData?: Maybe<ExamSessionDataInput>;
  examConfigId?: Maybe<Scalars['String']>;
  examConfigStatus?: Maybe<Scalars['String']>;
  examConfigData?: Maybe<ExamConfigInput>;
  examItemAverageScore?: Maybe<Scalars['Float']>;
  examItemLastUsedAt?: Maybe<Scalars['AWSDateTime']>;
  examItemUseCount?: Maybe<Scalars['Int']>;
  imageUrl?: Maybe<Scalars['String']>;
  imageHash?: Maybe<Scalars['String']>;
  coverImage?: Maybe<S3ObjectInput>;
  checksum?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  sequence?: Maybe<Scalars['String']>;
  deliveryMediaType?: Maybe<DeliveryMediaType>;
};

export type TagInput = {
  key?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type ResourceElementInput = {
  id?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  interactionType?: Maybe<Scalars['String']>;
  content?: Maybe<Scalars['AWSJSON']>;
  config?: Maybe<Scalars['AWSJSON']>;
  scoring?: Maybe<Scalars['AWSJSON']>;
};

export type ResourceContentInput = {
  body?: Maybe<Scalars['String']>;
  canvas?: Maybe<Array<Maybe<ResourceElementInput>>>;
  exemplar?: Maybe<Scalars['String']>;
  forms?: Maybe<Array<Maybe<ResourceExamFormInput>>>;
  objectiveMatrix?: Maybe<Scalars['AWSJSON']>;
  rubric?: Maybe<Scalars['AWSJSON']>;
};

export type ResourceDimensionsInput = {
  length?: Maybe<Scalars['Int']>;
  width?: Maybe<Scalars['Int']>;
  height?: Maybe<Scalars['Int']>;
  scale?: Maybe<Scalars['String']>;
};

export type ResourceFileInput = {
  name?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  bucket?: Maybe<Scalars['String']>;
  key?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Int']>;
  mimetype?: Maybe<Scalars['String']>;
  format?: Maybe<Scalars['String']>;
  extension?: Maybe<Scalars['String']>;
};

export type ResourceExamFormInput = {
  name?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  config?: Maybe<Scalars['AWSJSON']>;
  sections?: Maybe<Array<Maybe<ResourceExamSectionInput>>>;
};

export type ResourceExamSectionInput = {
  name?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  config?: Maybe<Scalars['AWSJSON']>;
  questionIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ExamPositionInput = {
  form: Scalars['Int'];
  section: Scalars['Int'];
  question: Scalars['Int'];
};

export type ModelResourceConnectionInput = {
  nextToken?: Maybe<Scalars['String']>;
};

export type ResourceObjectiveMapInput = {
  sourceObjective?: Maybe<Scalars['String']>;
  targetObjective?: Maybe<Scalars['String']>;
};

export type ExamSessionDataInput = {
  lti?: Maybe<ExamSessionLtiInput>;
  studentId?: Maybe<Scalars['String']>;
  accessKey?: Maybe<Scalars['String']>;
  examId?: Maybe<Scalars['String']>;
  examConfigId?: Maybe<Scalars['String']>;
  responses?: Maybe<Scalars['AWSJSON']>;
};

export type ExamSessionLtiInput = {
  assignmentId?: Maybe<Scalars['String']>;
  contextId?: Maybe<Scalars['String']>;
  contextLabel?: Maybe<Scalars['String']>;
  contextTitle?: Maybe<Scalars['String']>;
  courseId?: Maybe<Scalars['String']>;
  domain?: Maybe<Scalars['String']>;
  outcomeUrl?: Maybe<Scalars['String']>;
  sourcedId?: Maybe<Scalars['String']>;
  toolConsumerGuid?: Maybe<Scalars['String']>;
  toolConsumerName?: Maybe<Scalars['String']>;
  toolConsumerProductCode?: Maybe<Scalars['String']>;
  toolConsumerVersion?: Maybe<Scalars['String']>;
  product?: Maybe<Scalars['String']>;
  uniqueUserId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
  consumerKey?: Maybe<Scalars['String']>;
  agsAllowedScopes?: Maybe<Array<Maybe<Scalars['String']>>>;
  agsLineItemUrl?: Maybe<Scalars['String']>;
  agsLineItemsUrl?: Maybe<Scalars['String']>;
  toolClientId?: Maybe<Scalars['String']>;
  toolIssuer?: Maybe<Scalars['String']>;
};

export type ExamConfigInput = {
  foo?: Maybe<Scalars['String']>;
};

export type SearchableResourceFilterInput = {
  id?: Maybe<SearchableIdFilterInput>;
  alignmentIds?: Maybe<SearchableStringFilterInput>;
  answerDistribution?: Maybe<SearchableStringFilterInput>;
  assetIds?: Maybe<SearchableStringFilterInput>;
  assigneeId?: Maybe<SearchableStringFilterInput>;
  author?: Maybe<SearchableStringFilterInput>;
  bankId?: Maybe<SearchableStringFilterInput>;
  blooms?: Maybe<SearchableStringFilterInput>;
  checksum?: Maybe<SearchableStringFilterInput>;
  content?: Maybe<SearchableStringFilterInput>;
  contextIds?: Maybe<SearchableStringFilterInput>;
  courseId?: Maybe<SearchableStringFilterInput>;
  createdAt?: Maybe<SearchableDateFilterInput>;
  creatorId?: Maybe<SearchableStringFilterInput>;
  description?: Maybe<SearchableStringFilterInput>;
  dok?: Maybe<SearchableStringFilterInput>;
  dueAt?: Maybe<SearchableDateFilterInput>;
  editorId?: Maybe<SearchableStringFilterInput>;
  email?: Maybe<SearchableStringFilterInput>;
  examConfigId?: Maybe<SearchableStringFilterInput>;
  examItemAverageScore?: Maybe<SearchableFloatFilterInput>;
  examItemLastUsedAt?: Maybe<SearchableDateFilterInput>;
  examItemUseCount?: Maybe<SearchableIntFilterInput>;
  examSessionId?: Maybe<SearchableStringFilterInput>;
  excerpt?: Maybe<SearchableStringFilterInput>;
  foo?: Maybe<SearchableStringFilterInput>;
  genres?: Maybe<SearchableStringFilterInput>;
  grade?: Maybe<SearchableStringFilterInput>;
  idInc?: Maybe<SearchableStringFilterInput>;
  idVendor?: Maybe<SearchableStringFilterInput>;
  interaction?: Maybe<SearchableStringFilterInput>;
  interactionCount?: Maybe<SearchableIntFilterInput>;
  isArchived?: Maybe<SearchableBooleanFilterInput>;
  isDeleted?: Maybe<SearchableBooleanFilterInput>;
  isDisabled?: Maybe<SearchableBooleanFilterInput>;
  isProcessing?: Maybe<SearchableBooleanFilterInput>;
  isUnlisted?: Maybe<SearchableBooleanFilterInput>;
  keywords?: Maybe<SearchableStringFilterInput>;
  language?: Maybe<SearchableStringFilterInput>;
  maturity?: Maybe<SearchableStringFilterInput>;
  name?: Maybe<SearchableStringFilterInput>;
  originResourceId?: Maybe<SearchableStringFilterInput>;
  questionIds?: Maybe<SearchableStringFilterInput>;
  resourceId?: Maybe<SearchableStringFilterInput>;
  reviewerId?: Maybe<SearchableStringFilterInput>;
  reviews?: Maybe<SearchableStringFilterInput>;
  schemaVersion?: Maybe<SearchableStringFilterInput>;
  scoreActual?: Maybe<SearchableFloatFilterInput>;
  scoreMax?: Maybe<SearchableFloatFilterInput>;
  scoreMin?: Maybe<SearchableFloatFilterInput>;
  sequence?: Maybe<SearchableStringFilterInput>;
  sk?: Maybe<SearchableStringFilterInput>;
  subject?: Maybe<SearchableStringFilterInput>;
  tags?: Maybe<SearchableTagFilterInput>;
  type?: Maybe<SearchableStringFilterInput>;
  updatedAt?: Maybe<SearchableDateFilterInput>;
  version?: Maybe<SearchableIntFilterInput>;
  visibility?: Maybe<SearchableStringFilterInput>;
  wordCount?: Maybe<SearchableIntFilterInput>;
  workspaceId?: Maybe<SearchableStringFilterInput>;
  assetType?: Maybe<SearchableStringFilterInput>;
  collectionIds?: Maybe<SearchableStringFilterInput>;
  containsImages?: Maybe<SearchableBooleanFilterInput>;
  containsMath?: Maybe<SearchableBooleanFilterInput>;
  favoriteUserIds?: Maybe<SearchableStringFilterInput>;
  fileExtension?: Maybe<SearchableStringFilterInput>;
  fileMimetype?: Maybe<SearchableStringFilterInput>;
  fileSize?: Maybe<SearchableIntFilterInput>;
  fullText?: Maybe<SearchableStringFilterInput>;
  itemCount?: Maybe<SearchableIntFilterInput>;
  mediaType?: Maybe<SearchableStringFilterInput>;
  objectiveAuthority?: Maybe<SearchableStringFilterInput>;
  objectiveAbbreviation?: Maybe<SearchableStringFilterInput>;
  objectiveDocument?: Maybe<SearchableStringFilterInput>;
  objectiveId?: Maybe<SearchableStringFilterInput>;
  objectiveScope?: Maybe<SearchableStringFilterInput>;
  objectType?: Maybe<SearchableStringFilterInput>;
  referencesIds?: Maybe<SearchableStringFilterInput>;
  relativeCount?: Maybe<SearchableIntFilterInput>;
  translatedLanguages?: Maybe<SearchableStringFilterInput>;
  watcherUserIds?: Maybe<SearchableStringFilterInput>;
  and?: Maybe<Array<Maybe<SearchableResourceFilterInput>>>;
  or?: Maybe<Array<Maybe<SearchableResourceFilterInput>>>;
  not?: Maybe<SearchableResourceFilterInput>;
};

export type SearchableStringFilterInput = {
  ne?: Maybe<Scalars['String']>;
  eq?: Maybe<Scalars['String']>;
  match?: Maybe<Scalars['String']>;
  matchPhrase?: Maybe<Scalars['String']>;
  matchPhrasePrefix?: Maybe<Scalars['String']>;
  multiMatch?: Maybe<Scalars['String']>;
  exists?: Maybe<Scalars['Boolean']>;
  wildcard?: Maybe<Scalars['String']>;
  regexp?: Maybe<Scalars['String']>;
};

export type SearchableTagFilterInput = {
  ne?: Maybe<Scalars['String']>;
  eq?: Maybe<Scalars['String']>;
  match?: Maybe<Scalars['String']>;
  matchPhrase?: Maybe<Scalars['String']>;
  matchPhrasePrefix?: Maybe<Scalars['String']>;
  multiMatch?: Maybe<Scalars['String']>;
  notEmpty?: Maybe<Scalars['String']>;
  empty?: Maybe<Scalars['String']>;
  exists?: Maybe<Scalars['String']>;
  wildcard?: Maybe<Scalars['String']>;
  regexp?: Maybe<Scalars['String']>;
};

export type SearchableIdFilterInput = {
  ne?: Maybe<Scalars['ID']>;
  eq?: Maybe<Scalars['ID']>;
  match?: Maybe<Scalars['ID']>;
  matchPhrase?: Maybe<Scalars['ID']>;
  matchPhrasePrefix?: Maybe<Scalars['ID']>;
  multiMatch?: Maybe<Scalars['ID']>;
  exists?: Maybe<Scalars['Boolean']>;
  wildcard?: Maybe<Scalars['ID']>;
  regexp?: Maybe<Scalars['ID']>;
};

export type SearchableDateFilterInput = {
  gt?: Maybe<Scalars['String']>;
  lt?: Maybe<Scalars['String']>;
  gte?: Maybe<Scalars['String']>;
  lte?: Maybe<Scalars['String']>;
};

export type SearchableIntFilterInput = {
  eq?: Maybe<Scalars['Int']>;
  exists?: Maybe<Scalars['Boolean']>;
  gt?: Maybe<Scalars['Int']>;
  gte?: Maybe<Scalars['Int']>;
  lt?: Maybe<Scalars['Int']>;
  lte?: Maybe<Scalars['Int']>;
  ne?: Maybe<Scalars['Int']>;
  range?: Maybe<Array<Maybe<Scalars['Int']>>>;
};

export type SearchableFloatFilterInput = {
  eq?: Maybe<Scalars['Float']>;
  exists?: Maybe<Scalars['Boolean']>;
  gt?: Maybe<Scalars['Float']>;
  gte?: Maybe<Scalars['Float']>;
  lt?: Maybe<Scalars['Float']>;
  lte?: Maybe<Scalars['Float']>;
  ne?: Maybe<Scalars['Float']>;
  range?: Maybe<Array<Maybe<Scalars['Float']>>>;
};

export type SearchableBooleanFilterInput = {
  eq?: Maybe<Scalars['Boolean']>;
  ne?: Maybe<Scalars['Boolean']>;
};

export type SearchAggsInput = {
  name: Scalars['String'];
  type: Scalars['String'];
  field?: Maybe<Scalars['String']>;
  query?: Maybe<Scalars['String']>;
  path?: Maybe<Scalars['String']>;
  include?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Int']>;
  interval?: Maybe<Scalars['String']>;
  extendedBounds?: Maybe<SearchAggsExtendedBoundsInput>;
  aggs?: Maybe<Array<SearchAggsInput>>;
};

export type SearchAggsExtendedBoundsInput = {
  min?: Maybe<Scalars['String']>;
  max?: Maybe<Scalars['String']>;
};

export type SearchableResourceAggsInput = {
  term: Scalars['String'];
  tagTerms?: Maybe<Array<Maybe<Scalars['String']>>>;
  tagMatch?: Maybe<Scalars['String']>;
};

export enum SearchableSortDirection {
  Asc = 'asc',
  Desc = 'desc'
}

export enum SearchableResourceSortableFields {
  EsRandom = '_es_random_',
  EsScore = '_es_score_',
  AlignmentIds = 'alignmentIds',
  Author = 'author',
  BankId = 'bankId',
  Blooms = 'blooms',
  Content = 'content',
  ContextIds = 'contextIds',
  CreatedAt = 'createdAt',
  CreatorId = 'creatorId',
  Description = 'description',
  Dok = 'dok',
  DueAt = 'dueAt',
  EditorId = 'editorId',
  ExamItemAverageScore = 'examItemAverageScore',
  ExamItemLastUsedAt = 'examItemLastUsedAt',
  ExamItemUseCount = 'examItemUseCount',
  Excerpt = 'excerpt',
  Foo = 'foo',
  Grade = 'grade',
  Id = 'id',
  Interaction = 'interaction',
  IsArchived = 'isArchived',
  IsDeleted = 'isDeleted',
  IsDisabled = 'isDisabled',
  IsProcessing = 'isProcessing',
  Language = 'language',
  Maturity = 'maturity',
  Name = 'name',
  ObjectiveDocument = 'objectiveDocument',
  ObjectiveScope = 'objectiveScope',
  Reviews = 'reviews',
  SchemaVersion = 'schemaVersion',
  Sequence = 'sequence',
  Sk = 'sk',
  Subject = 'subject',
  Tags = 'tags',
  Type = 'type',
  UpdatedAt = 'updatedAt',
  Version = 'version'
}

export type SearchableResourceSortInput = {
  field?: Maybe<SearchableResourceSortableFields>;
  direction?: Maybe<SearchableSortDirection>;
};

export type SearchableObjectiveFilterInput = {
  id?: Maybe<SearchableIdFilterInput>;
  sk?: Maybe<SearchableStringFilterInput>;
  guid?: Maybe<SearchableStringFilterInput>;
  type?: Maybe<SearchableStringFilterInput>;
  name?: Maybe<SearchableStringFilterInput>;
  content?: Maybe<SearchableStringFilterInput>;
  numRaw?: Maybe<SearchableStringFilterInput>;
  numEnhanced?: Maybe<SearchableStringFilterInput>;
  outlineNumber?: Maybe<SearchableStringFilterInput>;
  abbreviation?: Maybe<SearchableStringFilterInput>;
  sequence?: Maybe<SearchableIntFilterInput>;
  idAuthority?: Maybe<SearchableStringFilterInput>;
  idPublisher?: Maybe<SearchableStringFilterInput>;
  parentId?: Maybe<SearchableStringFilterInput>;
  scope?: Maybe<SearchableStringFilterInput>;
  isAlignable?: Maybe<SearchableBooleanFilterInput>;
  isObsolete?: Maybe<SearchableBooleanFilterInput>;
  objectiveTree?: Maybe<SearchableStringFilterInput>;
  workflowStatus?: Maybe<SearchableStringFilterInput>;
  versionCurrent?: Maybe<SearchableIntFilterInput>;
  versionNext?: Maybe<SearchableIntFilterInput>;
  versionLabel?: Maybe<SearchableStringFilterInput>;
  documentId?: Maybe<SearchableStringFilterInput>;
  authorityId?: Maybe<SearchableStringFilterInput>;
  publicationId?: Maybe<SearchableStringFilterInput>;
  notes?: Maybe<SearchableStringFilterInput>;
  createdAt?: Maybe<SearchableStringFilterInput>;
  updatedAt?: Maybe<SearchableStringFilterInput>;
  and?: Maybe<Array<Maybe<SearchableObjectiveFilterInput>>>;
  or?: Maybe<Array<Maybe<SearchableObjectiveFilterInput>>>;
  not?: Maybe<SearchableObjectiveFilterInput>;
};

export enum SearchableObjectiveSortableFields {
  Id = 'id',
  Sk = 'sk',
  Guid = 'guid',
  Type = 'type',
  Name = 'name',
  Content = 'content',
  NumRaw = 'numRaw',
  NumEnhanced = 'numEnhanced',
  OutlineNumber = 'outlineNumber',
  Abbreviation = 'abbreviation',
  Sequence = 'sequence',
  IdAuthority = 'idAuthority',
  IdPublisher = 'idPublisher',
  ParentId = 'parentId',
  Scope = 'scope',
  IsAlignable = 'isAlignable',
  IsObsolete = 'isObsolete',
  ObjectiveTree = 'objectiveTree',
  WorkflowStatus = 'workflowStatus',
  VersionCurrent = 'versionCurrent',
  VersionNext = 'versionNext',
  VersionLabel = 'versionLabel',
  DocumentId = 'documentId',
  AuthorityId = 'authorityId',
  PublicationId = 'publicationId',
  Notes = 'notes',
  CreatedAt = 'createdAt',
  UpdatedAt = 'updatedAt'
}

export type SearchableObjectiveSortInput = {
  field?: Maybe<SearchableObjectiveSortableFields>;
  direction?: Maybe<SearchableSortDirection>;
};

export type CreateUserInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  avatarHash?: Maybe<Scalars['String']>;
  acl?: Maybe<Scalars['AWSJSON']>;
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
  userId?: Maybe<Scalars['String']>;
  lastActiveAt?: Maybe<Scalars['AWSDateTime']>;
  status?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  file?: Maybe<S3ObjectInput>;
  data?: Maybe<Scalars['AWSJSON']>;
  workspaceId?: Maybe<Scalars['String']>;
  notification?: Maybe<NotificationInput>;
  notificationsConfig?: Maybe<NotificationsConfigInput>;
  school?: Maybe<SchoolInput>;
  eventId?: Maybe<Scalars['String']>;
  jobId?: Maybe<Scalars['String']>;
  intercomId?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Maybe<TagInput>>>;
};

export type UpdateUserInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  avatarHash?: Maybe<Scalars['String']>;
  acl?: Maybe<Scalars['AWSJSON']>;
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
  userId?: Maybe<Scalars['String']>;
  lastActiveAt?: Maybe<Scalars['AWSDateTime']>;
  status?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  file?: Maybe<S3ObjectInput>;
  data?: Maybe<Scalars['AWSJSON']>;
  workspaceId?: Maybe<Scalars['String']>;
  notification?: Maybe<NotificationInput>;
  notificationsConfig?: Maybe<NotificationsConfigInput>;
  school?: Maybe<SchoolInput>;
  eventId?: Maybe<Scalars['String']>;
  jobId?: Maybe<Scalars['String']>;
  intercomId?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Maybe<TagInput>>>;
};

export type UserCognitoStateInput = {
  exists: Scalars['Boolean'];
  confirmationStatus: Scalars['String'];
  isEmailVerified: Scalars['Boolean'];
};

export type S3ObjectInput = {
  bucket: Scalars['String'];
  region: Scalars['String'];
  key: Scalars['String'];
};

export type NotificationsConfigInput = {
  enabled?: Maybe<Scalars['Boolean']>;
};

export type SchoolInput = {
  name?: Maybe<Scalars['String']>;
};

export type NotificationInput = {
  type?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  file?: Maybe<S3ObjectInput>;
  payload?: Maybe<Scalars['AWSJSON']>;
};

export type ModelUserConnectionInput = {
  nextToken?: Maybe<Scalars['String']>;
};

export type CreateWorkspaceInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
  schemaVersion?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
  lastActiveAt?: Maybe<Scalars['AWSDateTime']>;
  features?: Maybe<Scalars['AWSJSON']>;
  workspaceId?: Maybe<Scalars['String']>;
  workspaceUserId?: Maybe<Scalars['String']>;
  invitationId?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  product?: Maybe<ProductInput>;
  contact?: Maybe<ContactInput>;
  customerId?: Maybe<Scalars['String']>;
  billing?: Maybe<BillingInput>;
  acl?: Maybe<Scalars['AWSJSON']>;
  roleIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  counter?: Maybe<Scalars['Int']>;
  reviewCountPending?: Maybe<Scalars['Int']>;
  isDisabled?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  recentResourceIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  tags?: Maybe<Array<Maybe<TagInput>>>;
  intercomId?: Maybe<Scalars['String']>;
};

export type UpdateWorkspaceInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
  schemaVersion?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
  lastActiveAt?: Maybe<Scalars['AWSDateTime']>;
  features?: Maybe<Scalars['AWSJSON']>;
  workspaceId?: Maybe<Scalars['String']>;
  workspaceUserId?: Maybe<Scalars['String']>;
  invitationId?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  product?: Maybe<ProductInput>;
  contact?: Maybe<ContactInput>;
  customerId?: Maybe<Scalars['String']>;
  billing?: Maybe<BillingInput>;
  acl?: Maybe<Scalars['AWSJSON']>;
  roleIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  counter?: Maybe<Scalars['Int']>;
  reviewCountPending?: Maybe<Scalars['Int']>;
  isDisabled?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  recentResourceIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  tags?: Maybe<Array<Maybe<TagInput>>>;
  intercomId?: Maybe<Scalars['String']>;
};

export type UpdateWorkspaceSubscriptionInput = {
  id: Scalars['ID'];
  sk: Scalars['String'];
  workspaceId: Scalars['String'];
  action?: Maybe<Scalars['String']>;
  product?: Maybe<ProductInput>;
  billing?: Maybe<BillingInput>;
};

export type WorkspaceUpdateInput = {
  type?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  sk?: Maybe<Scalars['String']>;
  data?: Maybe<WorkspaceUpdateDataInput>;
};

export type WorkspaceUpdateDataInput = {
  id: Scalars['String'];
  sk: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  acl?: Maybe<Scalars['AWSJSON']>;
  plan?: Maybe<Scalars['AWSJSON']>;
  isDisabled?: Maybe<Scalars['Boolean']>;
  features?: Maybe<Scalars['AWSJSON']>;
  reviewCountPending?: Maybe<Scalars['Int']>;
};

export type ModelWorkspaceConnectionInput = {
  nextToken?: Maybe<Scalars['String']>;
};

export type ProductInput = {
  type?: Maybe<ProductTier>;
  name?: Maybe<Scalars['String']>;
  units?: Maybe<Scalars['Int']>;
  unitPrice?: Maybe<Scalars['Float']>;
  isTrial?: Maybe<Scalars['Boolean']>;
  productId?: Maybe<Scalars['String']>;
  priceId?: Maybe<Scalars['String']>;
  subscriptionId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
};

export type BillingInput = {
  method?: Maybe<BillingMethodInput>;
  contact?: Maybe<ContactInput>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
};

export type BillingMethodInput = {
  id: Scalars['String'];
  type: Scalars['String'];
  card?: Maybe<BillingCardInput>;
  createdAt?: Maybe<Scalars['AWSDateTime']>;
};

export type BillingCardInput = {
  brand?: Maybe<Scalars['String']>;
  expMonth?: Maybe<Scalars['Int']>;
  expYear?: Maybe<Scalars['Int']>;
  last4?: Maybe<Scalars['String']>;
};

export type ContactInput = {
  name?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
};




export type QueryArgs = {
  "adminLoginAsAppUser": QueryAdminLoginAsAppUserArgs,
  "adminSearch": QueryAdminSearchArgs,
  "authGetToken": QueryAuthGetTokenArgs,
  "bulkSearch": QueryBulkSearchArgs,
  "determineRegistrationStatus": QueryDetermineRegistrationStatusArgs,
  "getAcademicCalendar": QueryGetAcademicCalendarArgs,
  "getAppDomain": QueryGetAppDomainArgs,
  "getBank": QueryGetBankArgs,
  "getClassroom": QueryGetClassroomArgs,
  "getClassroomActivity": QueryGetClassroomActivityArgs,
  "getClassroomUnit": QueryGetClassroomUnitArgs,
  "getCollection": QueryGetCollectionArgs,
  "getComment": QueryGetCommentArgs,
  "getCourse": QueryGetCourseArgs,
  "getCourseCalendar": QueryGetCourseCalendarArgs,
  "getExamAttempt": QueryGetExamAttemptArgs,
  "getExamConfig": QueryGetExamConfigArgs,
  "getExamSession": QueryGetExamSessionArgs,
  "getExamTicket": QueryGetExamTicketArgs,
  "getFileChecksum": QueryGetFileChecksumArgs,
  "getIssue": QueryGetIssueArgs,
  "getItem": QueryGetItemArgs,
  "getLaunchToken": QueryGetLaunchTokenArgs,
  "getLoginTokenForAppUser": QueryGetLoginTokenForAppUserArgs,
  "getObjectivesView": QueryGetObjectivesViewArgs,
  "getOpenGraphMetadata": QueryGetOpenGraphMetadataArgs,
  "getPerformanceTask": QueryGetPerformanceTaskArgs,
  "getPlayableExam": QueryGetPlayableExamArgs,
  "getPrintableExam": QueryGetPrintableExamArgs,
  "getResourceForUser": QueryGetResourceForUserArgs,
  "getResourceTranslation": QueryGetResourceTranslationArgs,
  "getResourceVersionData": QueryGetResourceVersionDataArgs,
  "getRolePolicy": QueryGetRolePolicyArgs,
  "getRubric": QueryGetRubricArgs,
  "getStudent": QueryGetStudentArgs,
  "getStudentAnswerKey": QueryGetStudentAnswerKeyArgs,
  "getStudentScore": QueryGetStudentScoreArgs,
  "getTask": QueryGetTaskArgs,
  "getUnit": QueryGetUnitArgs,
  "getUnitLayout": QueryGetUnitLayoutArgs,
  "getUser": QueryGetUserArgs,
  "getVocabulary": QueryGetVocabularyArgs,
  "getWebDocument": QueryGetWebDocumentArgs,
  "getWorklog": QueryGetWorklogArgs,
  "getWorkspace": QueryGetWorkspaceArgs,
  "getWorkspaceInvitation": QueryGetWorkspaceInvitationArgs,
  "getWorkspaceParent": QueryGetWorkspaceParentArgs,
  "getWorkspaceProduct": QueryGetWorkspaceProductArgs,
  "getWorkspaceShare": QueryGetWorkspaceShareArgs,
  "listAcademicCalendars": QueryListAcademicCalendarsArgs,
  "listAnnotations": QueryListAnnotationsArgs,
  "listAppUserConfigs": QueryListAppUserConfigsArgs,
  "listBanks": QueryListBanksArgs,
  "listClassroomActivities": QueryListClassroomActivitiesArgs,
  "listClassroomStudents": QueryListClassroomStudentsArgs,
  "listCollectionItems": QueryListCollectionItemsArgs,
  "listCollections": QueryListCollectionsArgs,
  "listComments": QueryListCommentsArgs,
  "listContentLicenses": QueryListContentLicensesArgs,
  "listContentSharedToWorkspace": QueryListContentSharedToWorkspaceArgs,
  "listCourseCalendars": QueryListCourseCalendarsArgs,
  "listExamAttempts": QueryListExamAttemptsArgs,
  "listExamTickets": QueryListExamTicketsArgs,
  "listInboundWorkspaceShares": QueryListInboundWorkspaceSharesArgs,
  "listIssues": QueryListIssuesArgs,
  "listItemUnits": QueryListItemUnitsArgs,
  "listManagedWorkspaceUsers": QueryListManagedWorkspaceUsersArgs,
  "listOutboundWorkspaceShares": QueryListOutboundWorkspaceSharesArgs,
  "listRestApiTokens": QueryListRestApiTokensArgs,
  "listReviews": QueryListReviewsArgs,
  "listRevisionNotes": QueryListRevisionNotesArgs,
  "listRolePolicies": QueryListRolePoliciesArgs,
  "listTasks": QueryListTasksArgs,
  "listUnitExams": QueryListUnitExamsArgs,
  "listUnitItems": QueryListUnitItemsArgs,
  "listUnitLayouts": QueryListUnitLayoutsArgs,
  "listUserClassrooms": QueryListUserClassroomsArgs,
  "listUserNotifications": QueryListUserNotificationsArgs,
  "listUserReviewRequests": QueryListUserReviewRequestsArgs,
  "listUserWorkspaces": QueryListUserWorkspacesArgs,
  "listWorklogs": QueryListWorklogsArgs,
  "listWorkspaceParentsByParentWorkspaceId": QueryListWorkspaceParentsByParentWorkspaceIdArgs,
  "listWorkspaceRegistrationCodes": QueryListWorkspaceRegistrationCodesArgs,
  "listWorkspaceRoles": QueryListWorkspaceRolesArgs,
  "listWorkspaceUserInvitations": QueryListWorkspaceUserInvitationsArgs,
  "listWorkspaceUsers": QueryListWorkspaceUsersArgs,
  "listWorkspaces": QueryListWorkspacesArgs,
  "listWorkspacesForUser": QueryListWorkspacesForUserArgs,
  "loginUser": QueryLoginUserArgs,
  "resolveUnitVocabularies": QueryResolveUnitVocabulariesArgs,
  "search": QuerySearchArgs,
  "searchAcademicCalendars": QuerySearchAcademicCalendarsArgs,
  "searchCourseCalendars": QuerySearchCourseCalendarsArgs,
  "searchExamResponses": QuerySearchExamResponsesArgs,
  "searchResourcesGuest": QuerySearchResourcesGuestArgs,
  "searchUserResources": QuerySearchUserResourcesArgs,
  "searchUsers": QuerySearchUsersArgs,
  "searchVocabulary": QuerySearchVocabularyArgs,
  "searchWorkspaceProducts": QuerySearchWorkspaceProductsArgs,
  "searchWorkspaceShares": QuerySearchWorkspaceSharesArgs,
  "searchWorkspaceUsers": QuerySearchWorkspaceUsersArgs,
  "searchWorkspaces": QuerySearchWorkspacesArgs,
  "searchv2": QuerySearchv2Args,
  "signCampfireLti": QuerySignCampfireLtiArgs,
  "signContentItemSelectionLti": QuerySignContentItemSelectionLtiArgs
}

export type MutationArgs = {
  "addCollectionItem": MutationAddCollectionItemArgs,
  "addTaskAuditItem": MutationAddTaskAuditItemArgs,
  "archiveCampfireUserActivities": MutationArchiveCampfireUserActivitiesArgs,
  "archiveClassroomAction": MutationArchiveClassroomActionArgs,
  "archiveExam": MutationArchiveExamArgs,
  "attachExamsToUnit": MutationAttachExamsToUnitArgs,
  "attachItemsToUnit": MutationAttachItemsToUnitArgs,
  "attachTaskOutputToResource": MutationAttachTaskOutputToResourceArgs,
  "attachTaskToResource": MutationAttachTaskToResourceArgs,
  "attachVendorId": MutationAttachVendorIdArgs,
  "createAcademicCalendar": MutationCreateAcademicCalendarArgs,
  "createAccount": MutationCreateAccountArgs,
  "createAnnotation": MutationCreateAnnotationArgs,
  "createBank": MutationCreateBankArgs,
  "createBlueprint": MutationCreateBlueprintArgs,
  "createClassroom": MutationCreateClassroomArgs,
  "createClassroomActivity": MutationCreateClassroomActivityArgs,
  "createClassroomResource": MutationCreateClassroomResourceArgs,
  "createClassroomStudentAction": MutationCreateClassroomStudentActionArgs,
  "createClassroomUnit": MutationCreateClassroomUnitArgs,
  "createCollection": MutationCreateCollectionArgs,
  "createComment": MutationCreateCommentArgs,
  "createCourse": MutationCreateCourseArgs,
  "createCourseCalendar": MutationCreateCourseCalendarArgs,
  "createEventForUser": MutationCreateEventForUserArgs,
  "createExamAttempt": MutationCreateExamAttemptArgs,
  "createExamConfig": MutationCreateExamConfigArgs,
  "createExamConfigSession": MutationCreateExamConfigSessionArgs,
  "createExamExportAction": MutationCreateExamExportActionArgs,
  "createExamSession": MutationCreateExamSessionArgs,
  "createIssue": MutationCreateIssueArgs,
  "createItem": MutationCreateItemArgs,
  "createObjectivesView": MutationCreateObjectivesViewArgs,
  "createPerformanceTask": MutationCreatePerformanceTaskArgs,
  "createRelative": MutationCreateRelativeArgs,
  "createResourceFavorite": MutationCreateResourceFavoriteArgs,
  "createResourcePurchase": MutationCreateResourcePurchaseArgs,
  "createResourceRating": MutationCreateResourceRatingArgs,
  "createResourceVersionData": MutationCreateResourceVersionDataArgs,
  "createResourceWatcher": MutationCreateResourceWatcherArgs,
  "createRestApiToken": MutationCreateRestApiTokenArgs,
  "createReview": MutationCreateReviewArgs,
  "createRevisionNote": MutationCreateRevisionNoteArgs,
  "createRole": MutationCreateRoleArgs,
  "createRolePolicy": MutationCreateRolePolicyArgs,
  "createRoleSecure": MutationCreateRoleSecureArgs,
  "createRubric": MutationCreateRubricArgs,
  "createSnapshot": MutationCreateSnapshotArgs,
  "createStudent": MutationCreateStudentArgs,
  "createSystemEvent": MutationCreateSystemEventArgs,
  "createTask": MutationCreateTaskArgs,
  "createTaskAction": MutationCreateTaskActionArgs,
  "createUnit": MutationCreateUnitArgs,
  "createUnitLayout": MutationCreateUnitLayoutArgs,
  "createUserClassroom": MutationCreateUserClassroomArgs,
  "createUserNotification": MutationCreateUserNotificationArgs,
  "createUserNotificationRecord": MutationCreateUserNotificationRecordArgs,
  "createVocabulary": MutationCreateVocabularyArgs,
  "createWebDocument": MutationCreateWebDocumentArgs,
  "createWorklog": MutationCreateWorklogArgs,
  "createWorkspace": MutationCreateWorkspaceArgs,
  "createWorkspaceInvitation": MutationCreateWorkspaceInvitationArgs,
  "createWorkspaceParent": MutationCreateWorkspaceParentArgs,
  "createWorkspaceProduct": MutationCreateWorkspaceProductArgs,
  "createWorkspaceRegistrationCode": MutationCreateWorkspaceRegistrationCodeArgs,
  "createWorkspaceRole": MutationCreateWorkspaceRoleArgs,
  "createWorkspaceShare": MutationCreateWorkspaceShareArgs,
  "createWorkspaceUser": MutationCreateWorkspaceUserArgs,
  "deleteAcademicCalendar": MutationDeleteAcademicCalendarArgs,
  "deleteAnnotation": MutationDeleteAnnotationArgs,
  "deleteAppUserAction": MutationDeleteAppUserActionArgs,
  "deleteBank": MutationDeleteBankArgs,
  "deleteBlueprint": MutationDeleteBlueprintArgs,
  "deleteClassroom": MutationDeleteClassroomArgs,
  "deleteClassroomAction": MutationDeleteClassroomActionArgs,
  "deleteClassroomActivity": MutationDeleteClassroomActivityArgs,
  "deleteClassroomActivityAction": MutationDeleteClassroomActivityActionArgs,
  "deleteClassroomResource": MutationDeleteClassroomResourceArgs,
  "deleteClassroomUnit": MutationDeleteClassroomUnitArgs,
  "deleteCollection": MutationDeleteCollectionArgs,
  "deleteComment": MutationDeleteCommentArgs,
  "deleteCourse": MutationDeleteCourseArgs,
  "deleteCourseCalendar": MutationDeleteCourseCalendarArgs,
  "deleteIssue": MutationDeleteIssueArgs,
  "deleteItem": MutationDeleteItemArgs,
  "deleteObjectivesView": MutationDeleteObjectivesViewArgs,
  "deletePerformanceTask": MutationDeletePerformanceTaskArgs,
  "deleteRelative": MutationDeleteRelativeArgs,
  "deleteResourceFavorite": MutationDeleteResourceFavoriteArgs,
  "deleteResourcePurchase": MutationDeleteResourcePurchaseArgs,
  "deleteResourceRating": MutationDeleteResourceRatingArgs,
  "deleteResourceWatcher": MutationDeleteResourceWatcherArgs,
  "deleteRestApiToken": MutationDeleteRestApiTokenArgs,
  "deleteReview": MutationDeleteReviewArgs,
  "deleteRevisionNote": MutationDeleteRevisionNoteArgs,
  "deleteRole": MutationDeleteRoleArgs,
  "deleteRolePolicy": MutationDeleteRolePolicyArgs,
  "deleteRubric": MutationDeleteRubricArgs,
  "deleteSnapshot": MutationDeleteSnapshotArgs,
  "deleteStudent": MutationDeleteStudentArgs,
  "deleteTask": MutationDeleteTaskArgs,
  "deleteTaskAction": MutationDeleteTaskActionArgs,
  "deleteUnit": MutationDeleteUnitArgs,
  "deleteUnitLayout": MutationDeleteUnitLayoutArgs,
  "deleteUserClassroom": MutationDeleteUserClassroomArgs,
  "deleteUserNotification": MutationDeleteUserNotificationArgs,
  "deleteUserResource": MutationDeleteUserResourceArgs,
  "deleteVocabulary": MutationDeleteVocabularyArgs,
  "deleteWebDocument": MutationDeleteWebDocumentArgs,
  "deleteWorklog": MutationDeleteWorklogArgs,
  "deleteWorkspace": MutationDeleteWorkspaceArgs,
  "deleteWorkspaceInvitation": MutationDeleteWorkspaceInvitationArgs,
  "deleteWorkspaceParent": MutationDeleteWorkspaceParentArgs,
  "deleteWorkspaceProduct": MutationDeleteWorkspaceProductArgs,
  "deleteWorkspaceRole": MutationDeleteWorkspaceRoleArgs,
  "deleteWorkspaceShare": MutationDeleteWorkspaceShareArgs,
  "deleteWorkspaceUser": MutationDeleteWorkspaceUserArgs,
  "deregisterContent": MutationDeregisterContentArgs,
  "detachExamsFromUnit": MutationDetachExamsFromUnitArgs,
  "detachItemsFromUnit": MutationDetachItemsFromUnitArgs,
  "detachTaskFromResource": MutationDetachTaskFromResourceArgs,
  "detachTaskOutputFromResource": MutationDetachTaskOutputFromResourceArgs,
  "detachVendorId": MutationDetachVendorIdArgs,
  "disableWorkspaceUser": MutationDisableWorkspaceUserArgs,
  "exportClassroomRosterAction": MutationExportClassroomRosterActionArgs,
  "getPresignedUrlsForExamBlobs": MutationGetPresignedUrlsForExamBlobsArgs,
  "importClassroomRosterAction": MutationImportClassroomRosterActionArgs,
  "incrementWorkspaceCounter": MutationIncrementWorkspaceCounterArgs,
  "invokeObjective": MutationInvokeObjectiveArgs,
  "joinWorkspace": MutationJoinWorkspaceArgs,
  "leaveWorkspace": MutationLeaveWorkspaceArgs,
  "leaveWorkspaceV2": MutationLeaveWorkspaceV2Args,
  "printExam": MutationPrintExamArgs,
  "printPerformanceAssessment": MutationPrintPerformanceAssessmentArgs,
  "printVerificationDocument": MutationPrintVerificationDocumentArgs,
  "printYearAtaGlance": MutationPrintYearAtaGlanceArgs,
  "putAppUser": MutationPutAppUserArgs,
  "registerAppUser": MutationRegisterAppUserArgs,
  "registerCognitoUser": MutationRegisterCognitoUserArgs,
  "registerContent": MutationRegisterContentArgs,
  "removeCollectionItem": MutationRemoveCollectionItemArgs,
  "removeTaskAuditItem": MutationRemoveTaskAuditItemArgs,
  "resetAppUserAction": MutationResetAppUserActionArgs,
  "resetClassroomAction": MutationResetClassroomActionArgs,
  "restoreSnapshot": MutationRestoreSnapshotArgs,
  "sendEmail": MutationSendEmailArgs,
  "sendExamSessionUpdate": MutationSendExamSessionUpdateArgs,
  "sendWorkspaceUpdate": MutationSendWorkspaceUpdateArgs,
  "setDefaultWorkspaceCalendar": MutationSetDefaultWorkspaceCalendarArgs,
  "setUserConfirmed": MutationSetUserConfirmedArgs,
  "submitFeedback": MutationSubmitFeedbackArgs,
  "submitStudentExam": MutationSubmitStudentExamArgs,
  "toggleAppLicenseAction": MutationToggleAppLicenseActionArgs,
  "toggleAppUserAction": MutationToggleAppUserActionArgs,
  "updateAcademicCalendar": MutationUpdateAcademicCalendarArgs,
  "updateAccount": MutationUpdateAccountArgs,
  "updateAnnotation": MutationUpdateAnnotationArgs,
  "updateBank": MutationUpdateBankArgs,
  "updateBlueprint": MutationUpdateBlueprintArgs,
  "updateClassroom": MutationUpdateClassroomArgs,
  "updateClassroomActivity": MutationUpdateClassroomActivityArgs,
  "updateClassroomStudentAction": MutationUpdateClassroomStudentActionArgs,
  "updateClassroomUnit": MutationUpdateClassroomUnitArgs,
  "updateCollection": MutationUpdateCollectionArgs,
  "updateComment": MutationUpdateCommentArgs,
  "updateCourse": MutationUpdateCourseArgs,
  "updateCourseCalendar": MutationUpdateCourseCalendarArgs,
  "updateExamAttempt": MutationUpdateExamAttemptArgs,
  "updateExamSession": MutationUpdateExamSessionArgs,
  "updateIssue": MutationUpdateIssueArgs,
  "updateItem": MutationUpdateItemArgs,
  "updateObjectivesView": MutationUpdateObjectivesViewArgs,
  "updatePerformanceTask": MutationUpdatePerformanceTaskArgs,
  "updateResourceVersionData": MutationUpdateResourceVersionDataArgs,
  "updateReview": MutationUpdateReviewArgs,
  "updateRole": MutationUpdateRoleArgs,
  "updateRolePolicy": MutationUpdateRolePolicyArgs,
  "updateRubric": MutationUpdateRubricArgs,
  "updateStudent": MutationUpdateStudentArgs,
  "updateTask": MutationUpdateTaskArgs,
  "updateTaskStatus": MutationUpdateTaskStatusArgs,
  "updateUnit": MutationUpdateUnitArgs,
  "updateUnitLayout": MutationUpdateUnitLayoutArgs,
  "updateUserNotification": MutationUpdateUserNotificationArgs,
  "updateVocabulary": MutationUpdateVocabularyArgs,
  "updateWebDocument": MutationUpdateWebDocumentArgs,
  "updateWorklog": MutationUpdateWorklogArgs,
  "updateWorkspace": MutationUpdateWorkspaceArgs,
  "updateWorkspaceProduct": MutationUpdateWorkspaceProductArgs,
  "updateWorkspaceRole": MutationUpdateWorkspaceRoleArgs,
  "updateWorkspaceShare": MutationUpdateWorkspaceShareArgs,
  "updateWorkspaceSubscriptionForWorkspace": MutationUpdateWorkspaceSubscriptionForWorkspaceArgs,
  "updateWorkspaceUser": MutationUpdateWorkspaceUserArgs
}
    